export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AnyObject: any;
  Date: any;
  Upload: any;
};

export type Query = {
  __typename?: 'Query';
  userToken?: Maybe<UserTokenResponse>;
  zendeskToken?: Maybe<ZendeskTokenResponse>;
  allocationProducts?: Maybe<Allocations>;
  allocations?: Maybe<Allocations>;
  userAllocations?: Maybe<Allocations>;
  uploadChannels: Channels;
  company?: Maybe<Company>;
  companyBuyerAttributesV2: BuyerAttributes;
  currencies?: Maybe<Currencies>;
  customPurchaseOrderDetails: CustomPurchaseOrderDetailsResponse;
  downloadCustomPurchaseOrder: DownloadCustomPurchaseOrderResponse;
  inventoryCasepacks?: Maybe<InventoryCasepacks>;
  catalogs?: Maybe<Catalogs>;
  inventoryItems?: Maybe<InventoryItems>;
  inventoryAttributes?: Maybe<Attributes>;
  listingAttributes?: Maybe<Attributes>;
  inventoryFilterKey?: Maybe<InventoryFilterKey>;
  inventoryNotOffered?: Maybe<InventoryNotOffered>;
  inventoryOffered?: Maybe<InventoryOffered>;
  inventoryProductsAllocationRollups?: Maybe<InventoryProductsAllocationRollups>;
  inventoryProductsRollup: InventoryProductsRollup;
  inventoryRollup?: Maybe<InventoryRollup>;
  inventorySelectionSummary?: Maybe<InventorySelectionSummary>;
  legacyFilterKey?: Maybe<LegacyFilterKey>;
  listing?: Maybe<Listing>;
  listingV2: ListingV2;
  listingCompanyOffers?: Maybe<ListingCompanyOffers>;
  listingOffersV2: ListingOffersV2;
  listingsV2: ListingsV2;
  markets: Markets;
  productServiceMarkets: ChannelMarkets;
  me?: Maybe<Me>;
  messageThreads: MessageThreadsResponse;
  messageThreadMessages: MessageThreadMessagesResponse;
  metaData: MetaData;
  notifications?: Maybe<Notifications>;
  offer?: Maybe<Offer>;
  offerV2?: Maybe<OfferV2>;
  offerCasepacks?: Maybe<OfferCasepacks>;
  offerItems?: Maybe<OfferItems>;
  offerProductsRollup: OfferProductsRollup;
  offerRollup: OfferRollup;
  offerRollupSummary?: Maybe<OfferRollupSummary>;
  getOfferRows: OfferRows;
  offersSummary?: Maybe<OffersSummary>;
  processes?: Maybe<Processes>;
  productGroup?: Maybe<ProductGroup>;
  searchServiceProducts: SearchServiceProducts;
  searchServicePackages: SearchServicePackages;
  searchServiceActiveFilters?: Maybe<SearchServiceActiveFilters>;
  searchServiceFilterKey?: Maybe<SearchServiceFilterKey>;
  transactions: Transactions;
  user?: Maybe<User>;
  users?: Maybe<Users>;
  getProductCategoriesByUser?: Maybe<ProductCategories>;
  getUser?: Maybe<Me>;
  FED_offers: Fed_OffersConnection;
  FED_offer?: Maybe<Fed_Offer>;
  FED_listings: Fed_ListingsConnection;
  FED_listing: Fed_Listing;
  FED_company: Fed_Company;
  FED_market: Fed_Market;
  FED_markets: Fed_MarketsConnection;
  FED_companyConfiguration: Fed_CompanyConfiguration;
  FED_user: Fed_User;
  FED_users?: Maybe<Fed_Users>;
  FED_currency?: Maybe<Fed_Currency>;
  FED_currencies: Fed_CurrenciesConnection;
  FED_groups: Fed_GroupsConnection;
  FED_offerRollups: Fed_OfferRollups;
  FED_offerRows: Fed_OfferRows;
  FED_searchServicePackages: Fed_SearchServicePackages;
};

export type QueryUserTokenArgs = {
  username: Scalars['ID'];
  password: Scalars['String'];
};

export type QueryAllocationProductsArgs = {
  allocations: Array<Maybe<AllocationDistribution>>;
  entity: Scalars['String'];
  filters: Array<Maybe<CoreApiFilter>>;
  key: Scalars['String'];
};

export type QueryAllocationsArgs = {
  marketId: Scalars['ID'];
};

export type QueryUserAllocationsArgs = {
  userId: Scalars['ID'];
};

export type QueryUploadChannelsArgs = {
  creatorId?: Maybe<Scalars['String']>;
};

export type QueryCompanyArgs = {
  id: Scalars['ID'];
};

export type QueryCompanyBuyerAttributesV2Args = {
  groupUUID: Scalars['ID'];
};

export type QueryCustomPurchaseOrderDetailsArgs = {
  listingUuid: Scalars['String'];
};

export type QueryDownloadCustomPurchaseOrderArgs = {
  listingUuid: Scalars['String'];
  payload?: Maybe<Scalars['AnyObject']>;
};

export type QueryInventoryCasepacksArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<CoreApiFilter>>>;
};

export type QueryInventoryItemsArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<CoreApiFilter>>>;
};

export type QueryListingAttributesArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryInventoryFilterKeyArgs = {
  filters?: Maybe<Array<Maybe<CoreApiFilter>>>;
};

export type QueryInventoryNotOfferedArgs = {
  key: Scalars['ID'];
};

export type QueryInventoryOfferedArgs = {
  key: Scalars['ID'];
};

export type QueryInventoryProductsAllocationRollupsArgs = {
  entity: Scalars['String'];
  filters?: Maybe<Array<Maybe<CoreApiFilter>>>;
  key: Scalars['String'];
};

export type QueryInventoryProductsRollupArgs = {
  entity: Scalars['String'];
  filters?: Maybe<Array<Maybe<CoreApiFilter>>>;
  key: Scalars['String'];
};

export type QueryInventoryRollupArgs = {
  market: Scalars['String'];
};

export type QueryInventorySelectionSummaryArgs = {
  entity?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<CoreApiFilter>>>;
};

export type QueryLegacyFilterKeyArgs = {
  filters?: Maybe<Array<Maybe<CoreApiFilter>>>;
  entity: LegacyEntityType;
  offerId?: Maybe<Scalars['String']>;
};

export type QueryListingArgs = {
  id: Scalars['ID'];
};

export type QueryListingV2Args = {
  id: Scalars['ID'];
};

export type QueryListingCompanyOffersArgs = {
  listingId: Scalars['ID'];
  buyerCompanyId: Scalars['ID'];
  currentCompanyId: Scalars['ID'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryListingOffersV2Args = {
  buyerCompanyId: Scalars['String'];
  listingId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type QueryListingsV2Args = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  filters?: Maybe<Array<Maybe<CoreApiFilter>>>;
};

export type QueryProductServiceMarketsArgs = {
  groupId?: Maybe<Scalars['String']>;
};

export type QueryMessageThreadsArgs = {
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  participantIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryMessageThreadMessagesArgs = {
  threadId: Scalars['ID'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryOfferArgs = {
  id: Scalars['ID'];
};

export type QueryOfferV2Args = {
  offerId: Scalars['ID'];
  listingId: Scalars['ID'];
};

export type QueryOfferCasepacksArgs = {
  id: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<CoreApiFilter>>>;
};

export type QueryOfferItemsArgs = {
  id: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<CoreApiFilter>>>;
};

export type QueryOfferProductsRollupArgs = {
  entity: Scalars['String'];
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
};

export type QueryOfferRollupArgs = {
  id: Scalars['ID'];
};

export type QueryOfferRollupSummaryArgs = {
  id: Scalars['ID'];
  params?: Maybe<Array<Maybe<Scalars['AnyObject']>>>;
};

export type QueryGetOfferRowsArgs = {
  buyerCompanyUUID?: Maybe<Scalars['String']>;
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  limit?: Maybe<Scalars['Int']>;
  listingCreatorCompanyUUID: Scalars['String'];
  listingUUID: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  sortDirection?: Maybe<Scalars['String']>;
  sortKey?: Maybe<Scalars['String']>;
  sortScope?: Maybe<Scalars['String']>;
  sortScopeValue?: Maybe<Scalars['String']>;
};

export type QueryOffersSummaryArgs = {
  key: Scalars['ID'];
};

export type QueryProductGroupArgs = {
  id: Scalars['ID'];
};

export type QuerySearchServiceProductsArgs = {
  companyUUID?: Maybe<Scalars['ID']>;
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  groupUUID: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  isRedundantGroupsFilteringActive?: Maybe<Scalars['Boolean']>;
  sortKey?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<Scalars['String']>;
  sortScope?: Maybe<Scalars['String']>;
  sortScopeValue?: Maybe<Scalars['String']>;
  userUUID?: Maybe<Scalars['ID']>;
  key?: Maybe<Scalars['String']>;
};

export type QuerySearchServicePackagesArgs = {
  companyUUID?: Maybe<Scalars['ID']>;
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  groupUUID: Scalars['ID'];
  includeAllPackages?: Maybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  isRedundantGroupsFilteringActive?: Maybe<Scalars['Boolean']>;
  sortKey?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<Scalars['String']>;
  sortScope?: Maybe<Scalars['String']>;
  sortScopeValue?: Maybe<Scalars['String']>;
  userUUID?: Maybe<Scalars['ID']>;
  key?: Maybe<Scalars['String']>;
};

export type QuerySearchServiceActiveFiltersArgs = {
  companyUUID: Scalars['ID'];
  key: Scalars['String'];
  dataType: Scalars['String'];
};

export type QuerySearchServiceFilterKeyArgs = {
  companyUUID: Scalars['ID'];
  entityType: FilterKeyEntityType;
  query: SearchQueryType;
};

export type QueryTransactionsArgs = {
  offerId: Scalars['ID'];
};

export type QueryUserArgs = {
  id: Scalars['ID'];
};

export type QueryUsersArgs = {
  filters: Array<Maybe<CoreApiFilter>>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryGetProductCategoriesByUserArgs = {
  userId: Scalars['ID'];
};

export type QueryGetUserArgs = {
  userId: Scalars['ID'];
};

export type QueryFed_OffersArgs = {
  companyId?: Maybe<Scalars['ID']>;
  companyRole?: Maybe<Fed_CompanyRole>;
  listingIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type QueryFed_OfferArgs = {
  offerId?: Maybe<Scalars['ID']>;
};

export type QueryFed_ListingsArgs = {
  companyId?: Maybe<Scalars['ID']>;
  companyRole?: Maybe<Fed_CompanyRole>;
  states?: Maybe<Array<Maybe<Fed_ListingState>>>;
  parentGroupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  marketIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  filterCompanyIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<Fed_SortDirection>;
  sortKey?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  includeDeletedUsers?: Maybe<Scalars['Boolean']>;
};

export type QueryFed_ListingArgs = {
  listingId?: Maybe<Scalars['ID']>;
  includeDeletedUsers?: Maybe<Scalars['Boolean']>;
};

export type QueryFed_CompanyArgs = {
  id: Scalars['ID'];
};

export type QueryFed_MarketArgs = {
  id: Scalars['ID'];
};

export type QueryFed_CompanyConfigurationArgs = {
  companyId: Scalars['ID'];
};

export type QueryFed_UserArgs = {
  id: Scalars['ID'];
};

export type QueryFed_UsersArgs = {
  filters: Array<Maybe<UserFilter>>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryFed_CurrencyArgs = {
  id: Scalars['ID'];
};

export type QueryFed_GroupsArgs = {
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  type?: Maybe<Fed_GroupType>;
};

export type QueryFed_OfferRollupsArgs = {
  buyerCompanyId?: Maybe<Scalars['String']>;
  listingCreatorCompanyId?: Maybe<Scalars['String']>;
  listingId: Scalars['String'];
  filterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
  categoryRollupsFilterGroups?: Maybe<
    Array<Maybe<Fed_SearchServiceFilterGroup>>
  >;
};

export type QueryFed_OfferRowsArgs = {
  buyerCompanyUUID?: Maybe<Scalars['String']>;
  filterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
  limit?: Maybe<Scalars['Int']>;
  listingCreatorCompanyUUID: Scalars['String'];
  listingUUID: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  sortDirection?: Maybe<Scalars['String']>;
  sortKey?: Maybe<Scalars['String']>;
  sortScope?: Maybe<Scalars['String']>;
  sortScopeValue?: Maybe<Scalars['String']>;
};

export type QueryFed_SearchServicePackagesArgs = {
  companyUUID?: Maybe<Scalars['ID']>;
  filterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
  groupUUID: Scalars['ID'];
  includeAllPackages?: Maybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  isRedundantGroupsFilteringActive?: Maybe<Scalars['Boolean']>;
  sortKey?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<Scalars['String']>;
  sortScope?: Maybe<Scalars['String']>;
  sortScopeValue?: Maybe<Scalars['String']>;
  userUUID?: Maybe<Scalars['ID']>;
  key?: Maybe<Scalars['String']>;
};

export type UserTokenResponse = Token | GenericError;

export type Token = {
  __typename?: 'Token';
  accessToken: Scalars['String'];
  expiresIn: Scalars['Float'];
  tokenType: Scalars['String'];
};

export type GenericError = Error & {
  __typename?: 'GenericError';
  kind: ErrorKind;
  message: Scalars['String'];
};

export type Error = {
  kind: ErrorKind;
  message: Scalars['String'];
};

export enum ErrorKind {
  Authentication = 'Authentication',
  Unknown = 'Unknown',
}

export type ZendeskTokenResponse = Token | GenericError;

export type AllocationDistribution = {
  label?: Maybe<Scalars['String']>;
  fraction?: Maybe<AllocationDistributionFraction>;
};

export type AllocationDistributionFraction = {
  denominator?: Maybe<Scalars['Int']>;
  numerator?: Maybe<Scalars['Int']>;
};

export type CoreApiFilter = {
  name: Scalars['String'];
  mode: Scalars['String'];
  value: Scalars['AnyObject'];
};

export type Allocations = {
  __typename?: 'Allocations';
  totalAllocated?: Maybe<Scalars['Int']>;
  nodes?: Maybe<Array<Maybe<Allocation>>>;
};

export type Allocation = Node & {
  __typename?: 'Allocation';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  percentAllocated?: Maybe<Scalars['String']>;
  totalCost?: Maybe<Metric>;
  totalInInventory?: Maybe<Scalars['Int']>;
  totalInThisAllocation?: Maybe<Scalars['Float']>;
  totalItems?: Maybe<Metric>;
  totalMsrp?: Maybe<Metric>;
  totalUnits?: Maybe<Metric>;
  totalWholesale?: Maybe<Metric>;
};

export type Node = {
  id: Scalars['ID'];
};

export type Metric = {
  __typename?: 'Metric';
  displayValue?: Maybe<Scalars['String']>;
  isoCurrencyCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  originalDisplayValue?: Maybe<Scalars['String']>;
  originalValue?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type Channels = {
  __typename?: 'Channels';
  nodes: Array<Channel>;
};

export type Channel = {
  __typename?: 'Channel';
  id: Scalars['ID'];
  name: Scalars['String'];
  parentId: Scalars['String'];
};

export type Company = Node & {
  __typename?: 'Company';
  address?: Maybe<Address>;
  avatarUrl?: Maybe<Scalars['String']>;
  brands?: Maybe<Brands>;
  buyerAttributes?: Maybe<BuyerAttributes>;
  categories?: Maybe<Categories>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images?: Maybe<CompanyGalleryImages>;
  logo?: Maybe<File>;
  lookbooks?: Maybe<Lookbooks>;
  members?: Maybe<Members>;
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<CompanyRole>;
  socialLinks?: Maybe<SocialLinks>;
  uuid: Scalars['ID'];
};

export type CompanyMembersArgs = {
  filters?: Maybe<Array<Maybe<CoreApiFilter>>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type Address = {
  __typename?: 'Address';
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type Brands = {
  __typename?: 'Brands';
  nodes?: Maybe<Array<Maybe<Brand>>>;
};

export type Brand = Node & {
  __typename?: 'Brand';
  id: Scalars['ID'];
  logo?: Maybe<DocumentImage>;
  name?: Maybe<Scalars['String']>;
};

export type DocumentImage = Document & {
  __typename?: 'DocumentImage';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  src: Scalars['String'];
};

export type Document = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  src: Scalars['String'];
};

export type BuyerAttributes = {
  __typename?: 'BuyerAttributes';
  nodes: Array<BuyerAttribute>;
};

export type BuyerAttribute = {
  __typename?: 'BuyerAttribute';
  attributeType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Categories = {
  __typename?: 'Categories';
  nodes?: Maybe<Array<Maybe<Category>>>;
};

export type Category = Node & {
  __typename?: 'Category';
  grouping?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type CompanyGalleryImages = {
  __typename?: 'CompanyGalleryImages';
  nodes?: Maybe<Array<Maybe<CompanyGalleryImage>>>;
};

export type CompanyGalleryImage = Node & {
  __typename?: 'CompanyGalleryImage';
  id: Scalars['ID'];
  src?: Maybe<Scalars['String']>;
};

export type File = {
  __typename?: 'File';
  id: Scalars['ID'];
  src: Scalars['String'];
};

export type Lookbooks = {
  __typename?: 'Lookbooks';
  nodes?: Maybe<Array<Maybe<Lookbook>>>;
};

export type Lookbook = Node & {
  __typename?: 'Lookbook';
  coverImage?: Maybe<DocumentImage>;
  file: DocumentFile;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DocumentFile = Document & {
  __typename?: 'DocumentFile';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  src: Scalars['String'];
};

export type Members = {
  __typename?: 'Members';
  nodes: Array<User>;
  pagination: CoreApiPagination;
  filters: CoreApiFiltersResponse;
};

export type MembersFiltersArgs = {
  label?: Maybe<Scalars['String']>;
};

export type User = Node & {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']>;
  categories?: Maybe<Categories>;
  company: Company;
  companyId?: Maybe<Scalars['ID']>;
  /** @deprecated Use company field */
  companyName?: Maybe<Scalars['String']>;
  companyUuid?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<File>;
  isPersonalEmail?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  onboardingCompletedAt?: Maybe<Scalars['Date']>;
  userRole?: Maybe<UserRole>;
  uuid: Scalars['ID'];
};

export enum UserRole {
  Admin = 'ADMIN',
  Manager = 'MANAGER',
}

export type CoreApiPagination = {
  __typename?: 'CoreAPIPagination';
  count: Scalars['Int'];
  currentPage: Scalars['Int'];
  grandTotal: Scalars['Int'];
  perPage: Scalars['Int'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type CoreApiFiltersResponse = {
  __typename?: 'CoreAPIFiltersResponse';
  nodes: Array<CoreApiFiltersResponseFilter>;
};

export type CoreApiFiltersResponseFilter = {
  __typename?: 'CoreAPIFiltersResponseFilter';
  label: Scalars['String'];
  options?: Maybe<CoreApiFiltersResponseFilterOptions>;
  strategies?: Maybe<CoreApiFiltersResponseFilterStrategies>;
  type?: Maybe<Scalars['String']>;
};

export type CoreApiFiltersResponseFilterOptions = {
  __typename?: 'CoreAPIFiltersResponseFilterOptions';
  nodes: Array<CoreApiFiltersResponseFilterOption>;
};

export type CoreApiFiltersResponseFilterOption = {
  __typename?: 'CoreAPIFiltersResponseFilterOption';
  checked?: Maybe<Scalars['Boolean']>;
  count?: Maybe<Scalars['Int']>;
  label: Scalars['String'];
  name: Scalars['String'];
  options?: Maybe<CoreApiFiltersResponseFilterOptions>;
  value: Scalars['AnyObject'];
};

export type CoreApiFiltersResponseFilterStrategies = {
  __typename?: 'CoreAPIFiltersResponseFilterStrategies';
  nodes: Array<CoreApiFiltersResponseFilterStrategy>;
};

export type CoreApiFiltersResponseFilterStrategy = {
  __typename?: 'CoreAPIFiltersResponseFilterStrategy';
  checked: Scalars['Boolean'];
  label: Scalars['String'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export enum CompanyRole {
  Seller = 'SELLER',
  Buyer = 'BUYER',
}

export type SocialLinks = {
  __typename?: 'SocialLinks';
  facebook?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  pinterest?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type Currencies = {
  __typename?: 'Currencies';
  nodes?: Maybe<Array<Maybe<Currency>>>;
};

export type Currency = Node & {
  __typename?: 'Currency';
  exchangeRate?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  isoNumericCode?: Maybe<Scalars['Int']>;
  lastModified?: Maybe<Scalars['Int']>;
  longName?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
};

export type CustomPurchaseOrderDetailsResponse =
  | CustomPurchaseOrderDetails
  | GenericError;

export type CustomPurchaseOrderDetails = {
  __typename?: 'CustomPurchaseOrderDetails';
  title?: Maybe<Scalars['String']>;
  additionalProperties?: Maybe<Scalars['Boolean']>;
  properties: CustomPurchaseOrderProperties;
};

export type CustomPurchaseOrderProperties = {
  __typename?: 'CustomPurchaseOrderProperties';
  nodes: Array<CustomPurchaseOrderProperty>;
};

export type CustomPurchaseOrderProperty = {
  __typename?: 'CustomPurchaseOrderProperty';
  key: Scalars['String'];
  type: CustomPurchaseOrderPropertyType;
  title: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  options: Array<Scalars['String']>;
};

export enum CustomPurchaseOrderPropertyType {
  Integer = 'Integer',
  String = 'String',
  Date = 'Date',
}

export type DownloadCustomPurchaseOrderResponse = BooleanResult | GenericError;

export type BooleanResult = {
  __typename?: 'BooleanResult';
  ok?: Maybe<Scalars['Boolean']>;
};

export type InventoryCasepacks = {
  __typename?: 'InventoryCasepacks';
  nodes?: Maybe<Array<Maybe<InventoryCasepack>>>;
  meta?: Maybe<InventoryProductsMeta>;
};

export type InventoryCasepack =
  | InventoryMultiItemCasepack
  | InventorySingleItemCasepack;

export type InventoryMultiItemCasepack = InventoryProduct & {
  __typename?: 'InventoryMultiItemCasepack';
  attributes: Scalars['AnyObject'];
  allocations: Allocations;
  casepackItems: CasepackItems;
  catalogId: Scalars['ID'];
  companyId: Scalars['ID'];
  createdAt: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  images: InventoryItemImages;
  kind: Scalars['String'];
  prices: Prices;
  quantity?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  totalUnits: Scalars['Int'];
  unitsPerCasepack: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Int']>;
};

export type InventoryProduct = {
  allocations: Allocations;
  attributes: Scalars['AnyObject'];
  catalogId: Scalars['ID'];
  createdAt: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images: InventoryItemImages;
  kind: Scalars['String'];
  prices: Prices;
  title: Scalars['String'];
  totalUnits: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Int']>;
};

export type InventoryItemImages = {
  __typename?: 'InventoryItemImages';
  nodes?: Maybe<Array<Maybe<InventoryItemImage>>>;
};

export type InventoryItemImage = {
  __typename?: 'InventoryItemImage';
  colorMatch?: Maybe<Scalars['Boolean']>;
  src?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lineItemId?: Maybe<Scalars['Int']>;
  sortOrder?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type Prices = {
  __typename?: 'Prices';
  nodes?: Maybe<Array<Maybe<Price>>>;
};

export type Price = {
  __typename?: 'Price';
  cost?: Maybe<Metric>;
  countryCode?: Maybe<Scalars['String']>;
  currencyId?: Maybe<Scalars['Int']>;
  currencyCode?: Maybe<Scalars['String']>;
  msrp?: Maybe<Metric>;
  suggested?: Maybe<Metric>;
  wholesale?: Maybe<Metric>;
  retail?: Maybe<Metric>;
};

export type CasepackItems = {
  __typename?: 'CasepackItems';
  nodes?: Maybe<Array<Maybe<InventoryItem>>>;
};

export type InventoryItem = InventorySingleItem &
  InventoryProduct & {
    __typename?: 'InventoryItem';
    allocations: Allocations;
    attributes: Scalars['AnyObject'];
    description?: Maybe<Scalars['String']>;
    catalogId: Scalars['ID'];
    createdAt: Scalars['Int'];
    id: Scalars['ID'];
    images: InventoryItemImages;
    kind: Scalars['String'];
    prices: Prices;
    sizes: InventorySizes;
    sku: Scalars['String'];
    style?: Maybe<Scalars['String']>;
    title: Scalars['String'];
    totalUnits: Scalars['Int'];
    updatedAt?: Maybe<Scalars['Int']>;
  };

export type InventorySingleItem = {
  attributes: Scalars['AnyObject'];
  catalogId: Scalars['ID'];
  id: Scalars['ID'];
  images: InventoryItemImages;
  sizes: InventorySizes;
  sku: Scalars['String'];
  style?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type InventorySizes = {
  __typename?: 'InventorySizes';
  hasMultipleDimensions: Scalars['Boolean'];
  nodes?: Maybe<Array<Maybe<InventorySize>>>;
};

export type InventorySize = {
  __typename?: 'InventorySize';
  id: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  quantityRemaining?: Maybe<Scalars['Int']>;
  dimension1?: Maybe<Scalars['String']>;
  dimension2?: Maybe<Scalars['String']>;
};

export type InventorySingleItemCasepack = InventorySingleItem &
  InventoryProduct & {
    __typename?: 'InventorySingleItemCasepack';
    allocations: Allocations;
    attributes: Scalars['AnyObject'];
    catalogId: Scalars['ID'];
    companyId: Scalars['ID'];
    createdAt: Scalars['Int'];
    description?: Maybe<Scalars['String']>;
    externalId: Scalars['ID'];
    images: InventoryItemImages;
    kind: Scalars['String'];
    id: Scalars['ID'];
    prices: Prices;
    quantity?: Maybe<Scalars['Int']>;
    sku: Scalars['String'];
    sizes: InventorySizes;
    style?: Maybe<Scalars['String']>;
    title: Scalars['String'];
    totalUnits: Scalars['Int'];
    unitsPerCasepack: Scalars['Int'];
    updatedAt?: Maybe<Scalars['Int']>;
  };

export type InventoryProductsMeta = {
  __typename?: 'InventoryProductsMeta';
  filters?: Maybe<InventoryProductsFilters>;
  key?: Maybe<Scalars['String']>;
  pagination?: Maybe<InventoryProductsPagination>;
};

export type InventoryProductsFilters = {
  __typename?: 'InventoryProductsFilters';
  nodes?: Maybe<Array<Maybe<InventoryProductsFilter>>>;
};

export type InventoryProductsFilter = {
  __typename?: 'InventoryProductsFilter';
  label?: Maybe<Scalars['String']>;
  options?: Maybe<InventoryProductsFilterOptions>;
  strategies?: Maybe<InventoryProductsFilterStrategies>;
  type?: Maybe<Scalars['String']>;
};

export type InventoryProductsFilterOptions = {
  __typename?: 'InventoryProductsFilterOptions';
  nodes?: Maybe<Array<Maybe<InventoryProductsFilterOption>>>;
};

export type InventoryProductsFilterOption = {
  __typename?: 'InventoryProductsFilterOption';
  actions?: Maybe<InventoryProductsFilterActions>;
  checked?: Maybe<Scalars['Boolean']>;
  count?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['AnyObject']>;
};

export type InventoryProductsFilterActions = {
  __typename?: 'InventoryProductsFilterActions';
  update?: Maybe<Scalars['Boolean']>;
};

export type InventoryProductsFilterStrategies = {
  __typename?: 'InventoryProductsFilterStrategies';
  nodes?: Maybe<Array<Maybe<InventoryProductsFilterStrategy>>>;
};

export type InventoryProductsFilterStrategy = {
  __typename?: 'InventoryProductsFilterStrategy';
  checked?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type InventoryProductsPagination = {
  __typename?: 'InventoryProductsPagination';
  grandTotal?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type Catalogs = {
  __typename?: 'Catalogs';
  nodes?: Maybe<Array<Maybe<Catalog>>>;
};

export type Catalog = {
  __typename?: 'Catalog';
  id: Scalars['ID'];
  title: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  totalItems?: Maybe<Scalars['Int']>;
  totalUnits?: Maybe<Scalars['Float']>;
};

export type InventoryItems = {
  __typename?: 'InventoryItems';
  nodes?: Maybe<Array<Maybe<InventoryItem>>>;
  meta?: Maybe<InventoryProductsMeta>;
};

export type Attributes = {
  __typename?: 'Attributes';
  nodes: Array<InventoryAttribute>;
};

export type InventoryAttribute = {
  __typename?: 'InventoryAttribute';
  label: Scalars['String'];
  type: Scalars['String'];
};

export type InventoryFilterKey = {
  __typename?: 'InventoryFilterKey';
  key?: Maybe<Scalars['String']>;
};

export type InventoryNotOffered = Node & {
  __typename?: 'InventoryNotOffered';
  id: Scalars['ID'];
  cost?: Maybe<Metric>;
  items?: Maybe<Metric>;
  retail?: Maybe<Metric>;
  units?: Maybe<Metric>;
  wholesale?: Maybe<Metric>;
};

export type InventoryOffered = Node & {
  __typename?: 'InventoryOffered';
  id: Scalars['ID'];
  cost?: Maybe<Metric>;
  items?: Maybe<Metric>;
  retail?: Maybe<Metric>;
  units?: Maybe<Metric>;
  wholesale?: Maybe<Metric>;
};

export type InventoryProductsAllocationRollups = {
  __typename?: 'InventoryProductsAllocationRollups';
  nodes?: Maybe<Array<Maybe<InventoryProductsAllocationRollup>>>;
};

export type InventoryProductsAllocationRollup = Node & {
  __typename?: 'InventoryProductsAllocationRollup';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  totalQuantity?: Maybe<Scalars['Int']>;
};

export type InventoryProductsRollup = {
  __typename?: 'InventoryProductsRollup';
  allHaveCost: Scalars['Boolean'];
  allHaveMsrp: Scalars['Boolean'];
  allHaveWholesale: Scalars['Boolean'];
  id: Scalars['ID'];
  totalCost?: Maybe<Metric>;
  totalItems: Metric;
  totalCasepacks: Metric;
  totalMsrp: Metric;
  totalUnits: Metric;
  totalWholesale: Metric;
};

export type InventoryRollup = Node & {
  __typename?: 'InventoryRollup';
  id: Scalars['ID'];
  items?: Maybe<Metric>;
  units?: Maybe<Metric>;
  cost?: Maybe<Metric>;
  wholesale?: Maybe<Metric>;
  retail?: Maybe<Metric>;
};

export type InventorySelectionSummary = {
  __typename?: 'InventorySelectionSummary';
  affectedOffers?: Maybe<Scalars['Int']>;
  inAllocations?: Maybe<Scalars['Int']>;
  inCasepacks?: Maybe<Scalars['Int']>;
  inOffers?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export enum LegacyEntityType {
  Items = 'items',
  Casepacks = 'casepacks',
}

export type LegacyFilterKey = {
  __typename?: 'LegacyFilterKey';
  key?: Maybe<Scalars['String']>;
};

export type Listing = Node & {
  __typename?: 'Listing';
  addedItemCount?: Maybe<Metric>;
  allocation?: Maybe<Allocation>;
  allowCounterOffers?: Maybe<Scalars['Boolean']>;
  allowPickingItems?: Maybe<Scalars['Boolean']>;
  allowPickingQuantities?: Maybe<Scalars['Boolean']>;
  allowPickingSizes?: Maybe<Scalars['Boolean']>;
  availableInventory?: Maybe<AvailableInventory>;
  buyers?: Maybe<Buyers>;
  currency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Int']>;
  hasCasepacks?: Maybe<Scalars['Boolean']>;
  hasItems?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  marketId?: Maybe<Scalars['ID']>;
  meta?: Maybe<ListingMeta>;
  offers?: Maybe<Offers>;
  listingCompanyOffers?: Maybe<Listing>;
  otherRestrictions?: Maybe<Scalars['String']>;
  percentComplete?: Maybe<Metric>;
  pricedItemCount?: Maybe<Metric>;
  purchasingRule?: Maybe<PurchasingRule>;
  showMsrp?: Maybe<Scalars['Boolean']>;
  showMsrpPct?: Maybe<Scalars['Boolean']>;
  showSizes?: Maybe<Scalars['Boolean']>;
  showWholesale?: Maybe<Scalars['Boolean']>;
  showWholesalePct?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  visibleAttributes?: Maybe<VisibleAttributes>;
};

export type ListingOffersArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type ListingListingCompanyOffersArgs = {
  buyerCompanyId: Scalars['ID'];
  currentCompanyId: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type AvailableInventory = {
  __typename?: 'AvailableInventory';
  casepacks: Scalars['Int'];
  items: Scalars['Int'];
  total: Scalars['Int'];
};

export type Buyers = {
  __typename?: 'Buyers';
  nodes?: Maybe<Array<Maybe<User>>>;
};

export type ListingMeta = {
  __typename?: 'ListingMeta';
  actions: Actions;
};

export type Actions = {
  __typename?: 'Actions';
  clone?: Maybe<Scalars['Boolean']>;
  destroy?: Maybe<Scalars['Boolean']>;
  draftIsEmpty?: Maybe<Scalars['Boolean']>;
  export?: Maybe<Scalars['Boolean']>;
  publish?: Maybe<Scalars['Boolean']>;
};

export type Offers = {
  __typename?: 'Offers';
  nodes: Array<Offer>;
};

export type Offer = Node & {
  __typename?: 'Offer';
  bidLastModified?: Maybe<Scalars['Int']>;
  buyers?: Maybe<Buyers>;
  buyerCompanyId?: Maybe<Scalars['ID']>;
  buyerCompanyName?: Maybe<Scalars['String']>;
  buyerFinalPrice?: Maybe<Metric>;
  buyerPrice?: Maybe<Metric>;
  created?: Maybe<Scalars['Int']>;
  creator?: Maybe<CompanyRole>;
  creatorId?: Maybe<Scalars['ID']>;
  creatorName?: Maybe<Scalars['String']>;
  declineInfo?: Maybe<DeclineInfo>;
  id: Scalars['ID'];
  isCurrent?: Maybe<Scalars['Boolean']>;
  isDraftEdited?: Maybe<Scalars['Boolean']>;
  items?: Maybe<OfferItems>;
  lastModified?: Maybe<Scalars['Int']>;
  listingId?: Maybe<Scalars['ID']>;
  listingTitle?: Maybe<Scalars['String']>;
  negotiationId?: Maybe<Scalars['ID']>;
  rollup?: Maybe<OfferRollup>;
  sellerCompanyId?: Maybe<Scalars['ID']>;
  sellerCompanyName?: Maybe<Scalars['String']>;
  sellerFinalPrice?: Maybe<Metric>;
  seller?: Maybe<User>;
  sellerPrice?: Maybe<Metric>;
  stats?: Maybe<Stats>;
  status?: Maybe<Scalars['String']>;
  submitted?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type OfferItemsArgs = {
  id?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<CoreApiFilter>>>;
};

export type DeclineInfo = {
  __typename?: 'DeclineInfo';
  userInfo?: Maybe<User>;
  reasons?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OfferItems = {
  __typename?: 'OfferItems';
  nodes?: Maybe<Array<Maybe<OfferItem>>>;
  key?: Maybe<Scalars['String']>;
  pagination?: Maybe<OfferProductsPagination>;
  filters?: Maybe<OfferProductsFilters>;
};

export type OfferItem = {
  __typename?: 'OfferItem';
  attributes: Scalars['AnyObject'];
  bid?: Maybe<Bid>;
  catalogId: Scalars['ID'];
  colorCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images: OfferItemImages;
  itemNumber?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  missingKeyData?: Maybe<Scalars['Boolean']>;
  prices: Prices;
  quantityRemaining?: Maybe<Scalars['Int']>;
  sizes: OfferSizes;
  sku: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  totalUnits: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Int']>;
};

export type Bid = {
  __typename?: 'Bid';
  id?: Maybe<Scalars['ID']>;
  amountOffMsrp?: Maybe<Metric>;
  amountOffWholesale?: Maybe<Metric>;
  buyerPercentMargin?: Maybe<Metric>;
  isRemoved?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  percentMargin?: Maybe<Metric>;
  percentMarkup?: Maybe<Metric>;
  percentOffMsrp?: Maybe<Metric>;
  percentOffWholesale?: Maybe<Metric>;
  quantity?: Maybe<Scalars['Int']>;
  quantityRemaining?: Maybe<Scalars['Int']>;
  retailPrice?: Maybe<Metric>;
  sizes?: Maybe<OfferBidSizes>;
  totalOfferPrice?: Maybe<Metric>;
  totalUnits?: Maybe<Metric>;
  unitOfferPrice?: Maybe<Metric>;
};

export type OfferBidSizes = {
  __typename?: 'OfferBidSizes';
  hasMultipleDimensions: Scalars['Boolean'];
  nodes?: Maybe<Array<Maybe<OfferBidSize>>>;
};

export type OfferBidSize = {
  __typename?: 'OfferBidSize';
  id: Scalars['ID'];
  available?: Maybe<Metric>;
  description?: Maybe<Scalars['String']>;
  dimension1?: Maybe<Scalars['String']>;
  dimension2?: Maybe<Scalars['String']>;
  included?: Maybe<Metric>;
};

export type OfferItemImages = {
  __typename?: 'OfferItemImages';
  nodes?: Maybe<Array<Maybe<OfferItemImage>>>;
};

export type OfferItemImage = {
  __typename?: 'OfferItemImage';
  colorMatch?: Maybe<Scalars['Boolean']>;
  src?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lineItemId?: Maybe<Scalars['Int']>;
  sortOrder?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type OfferSizes = {
  __typename?: 'OfferSizes';
  hasMultipleDimensions: Scalars['Boolean'];
  nodes?: Maybe<Array<Maybe<OfferSize>>>;
};

export type OfferSize = {
  __typename?: 'OfferSize';
  id: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  dimension1?: Maybe<Scalars['String']>;
  dimension2?: Maybe<Scalars['String']>;
};

export type OfferProductsPagination = {
  __typename?: 'OfferProductsPagination';
  grandTotal?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type OfferProductsFilters = {
  __typename?: 'OfferProductsFilters';
  nodes?: Maybe<Array<Maybe<OfferProductsFilter>>>;
};

export type OfferProductsFilter = {
  __typename?: 'OfferProductsFilter';
  label?: Maybe<Scalars['String']>;
  options?: Maybe<OfferProductsFilterOptions>;
  strategies?: Maybe<OfferProductsFilterStrategies>;
  type?: Maybe<Scalars['String']>;
};

export type OfferProductsFilterOptions = {
  __typename?: 'OfferProductsFilterOptions';
  nodes?: Maybe<Array<Maybe<OfferProductsFilterOption>>>;
};

export type OfferProductsFilterOption = {
  __typename?: 'OfferProductsFilterOption';
  actions?: Maybe<OfferProductsFilterActions>;
  checked?: Maybe<Scalars['Boolean']>;
  count?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['AnyObject']>;
  options?: Maybe<OfferProductsFilterOptions>;
};

export type OfferProductsFilterActions = {
  __typename?: 'OfferProductsFilterActions';
  update?: Maybe<Scalars['Boolean']>;
};

export type OfferProductsFilterStrategies = {
  __typename?: 'OfferProductsFilterStrategies';
  nodes?: Maybe<Array<Maybe<OfferProductsFilterStrategy>>>;
};

export type OfferProductsFilterStrategy = {
  __typename?: 'OfferProductsFilterStrategy';
  checked?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type OfferRollup = Node & {
  __typename?: 'OfferRollup';
  id: Scalars['ID'];
  percentMargin?: Maybe<Metric>;
  percentMarkup?: Maybe<Metric>;
  percentOffMsrp?: Maybe<Metric>;
  percentOffWholesale?: Maybe<Metric>;
  totalCost?: Maybe<Metric>;
  totalItems: Metric;
  totalMsrp?: Maybe<Metric>;
  totalOfferPrice?: Maybe<Metric>;
  totalProducts: Metric;
  totalProfit?: Maybe<Metric>;
  totalUnits: Metric;
  totalWholesale?: Maybe<Metric>;
  unitOfferPrice?: Maybe<Metric>;
};

export type Stats = {
  __typename?: 'Stats';
  inOffer?: Maybe<Scalars['Int']>;
  notInOffer?: Maybe<Scalars['Int']>;
};

export enum PurchasingRule {
  AllowPickingitems = 'allow_pickingitems',
  PurchaseEntireoffer = 'purchase_entireoffer',
  AllowPickingquantities = 'allow_pickingquantities',
  AllowPickingsizes = 'allow_pickingsizes',
}

export type VisibleAttributes = {
  __typename?: 'VisibleAttributes';
  nodes: Array<Attribute>;
};

export type Attribute = {
  __typename?: 'Attribute';
  id: Scalars['ID'];
  attributeType: Scalars['String'];
  label: Scalars['String'];
  value: Scalars['String'];
};

export type ListingV2 = Node & {
  __typename?: 'ListingV2';
  allowCounterOffers: Scalars['Boolean'];
  allowPickingItems: Scalars['Boolean'];
  allowPickingQuantities: Scalars['Boolean'];
  allowPickingSizes: Scalars['Boolean'];
  buyerCompanyName?: Maybe<Scalars['String']>;
  buyers: Users;
  companyId: Scalars['String'];
  buyerCompanyId?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  created: Scalars['Int'];
  currencyId: Scalars['Int'];
  currencyCode: Scalars['String'];
  description: Scalars['String'];
  endDate?: Maybe<Scalars['Int']>;
  endNegotiationReasons: EndNegotiationReasons;
  expirationDate: Scalars['Int'];
  geoRestrictions: Array<Scalars['String']>;
  groupId: Scalars['String'];
  isDraftEdited?: Maybe<Scalars['Boolean']>;
  hasPackages?: Maybe<Scalars['Boolean']>;
  lastModified: Scalars['Int'];
  marketId: Scalars['String'];
  meta?: Maybe<ListingMeta>;
  metrics?: Maybe<ListingMetrics>;
  offers: ListingOffersV2;
  /** @deprecated We should not use offersRows without passing in an offer ID, using this may cause issues */
  offerRows: OfferRows;
  otherRestrictions?: Maybe<Scalars['String']>;
  parentGroupId: Scalars['String'];
  published?: Maybe<Scalars['Boolean']>;
  purchasingRule: Scalars['String'];
  seller: User;
  showMsrp: Scalars['Boolean'];
  showMsrpPct: Scalars['Boolean'];
  showSizes: Scalars['Boolean'];
  showWholesale: Scalars['Boolean'];
  showWholesalePct: Scalars['Boolean'];
  status: ListingStatus;
  title?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  visiblePricingOptions: Array<Scalars['String']>;
  visibleAttributes?: Maybe<VisibleAttributes>;
};

export type ListingV2OffersArgs = {
  buyerCompanyId?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type ListingV2OfferRowsArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
};

export type Users = {
  __typename?: 'Users';
  nodes?: Maybe<Array<User>>;
};

export type EndNegotiationReasons = {
  __typename?: 'EndNegotiationReasons';
  nodes: Array<EndNegotiationReason>;
};

export type EndNegotiationReason = {
  __typename?: 'EndNegotiationReason';
  id: Scalars['String'];
  type: Scalars['String'];
};

export type ListingMetrics = {
  __typename?: 'ListingMetrics';
  stats: ListingStats;
};

export type ListingStats = {
  __typename?: 'ListingStats';
  percentComplete: Metric;
  addedPackageCount: Metric;
  pricedPackageCount: Metric;
};

export type ListingOffersV2 = {
  __typename?: 'ListingOffersV2';
  nodes: Array<OfferV2>;
  actions: ListingOffersV2Actions;
};

export type OfferV2 = Node & {
  __typename?: 'OfferV2';
  bidLastModified: Scalars['Int'];
  buyerCompanyId: Scalars['ID'];
  buyerCompanyName?: Maybe<Scalars['String']>;
  buyerFinalPrice?: Maybe<Metric>;
  buyerPrice?: Maybe<Metric>;
  buyers: Buyers;
  creator: CompanyRole;
  creatorId: Scalars['ID'];
  creatorName: Scalars['String'];
  declineInfo: DeclineInfo;
  id: Scalars['ID'];
  isCurrent: Scalars['Boolean'];
  isDraftEdited?: Maybe<Scalars['Boolean']>;
  lastModified: Scalars['Int'];
  listingId: Scalars['ID'];
  listingTitle: Scalars['String'];
  offerRows?: Maybe<OfferRows>;
  seller: User;
  stats: Stats;
  status: ListingOfferStatus;
  submitted: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  version: Scalars['Int'];
};

export type OfferV2OfferRowsArgs = {
  listingId?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
};

export type SearchServiceFilterGroup = {
  declaredFilterName?: Maybe<DeclaredFilter>;
  declaredFilterValues?: Maybe<Array<Scalars['String']>>;
  filtersCondition: Scalars['String'];
  filters: Array<SearchServiceFilter>;
};

export enum DeclaredFilter {
  OfferId = 'OfferId',
  SizeLabel = 'SizeLabel',
  BuyerId = 'BuyerId',
}

export type SearchServiceFilter = {
  field: Scalars['String'];
  condition: Scalars['String'];
  values?: Maybe<Array<Maybe<Scalars['AnyObject']>>>;
};

export type OfferRows = {
  __typename?: 'OfferRows';
  pagination: OfferRowsPagination;
  totals?: Maybe<OfferRowsTotals>;
  nodes: Array<OfferRow>;
  categoryBreakdown?: Maybe<OfferRowCategories>;
  filters: OfferRowsFilters;
  rollups: OfferRowsRollups;
};

export type OfferRowsPagination = {
  __typename?: 'OfferRowsPagination';
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  total: Scalars['Int'];
  totalElements: Scalars['Int'];
};

export type OfferRowsTotals = {
  __typename?: 'OfferRowsTotals';
  avgCost?: Maybe<Scalars['Float']>;
  avgMargin?: Maybe<Scalars['Float']>;
  avgMarkup?: Maybe<Scalars['Float']>;
  avgMsrp?: Maybe<Scalars['Float']>;
  avgMsrpOff?: Maybe<Scalars['Float']>;
  avgRetail?: Maybe<Scalars['Float']>;
  avgUnitPrice?: Maybe<Scalars['Float']>;
  avgWhl?: Maybe<Scalars['Float']>;
  avgWhlOff?: Maybe<Scalars['Float']>;
  /** @deprecated use draftTotalUnits */
  totalUnits?: Maybe<Scalars['Float']>;
  /** @deprecated use draftTotalPrice */
  totalPrice?: Maybe<Scalars['Float']>;
  currentTotalPrice?: Maybe<Scalars['Float']>;
  currentTotalUnits: Scalars['Float'];
  draftTotalPrice?: Maybe<Scalars['Float']>;
  draftTotalUnits: Scalars['Float'];
  initialTotalUnits: Scalars['Float'];
  totalCost?: Maybe<Scalars['Float']>;
  totalMargin?: Maybe<Scalars['Float']>;
  totalMsrp?: Maybe<Scalars['Float']>;
  totalMsrpOff?: Maybe<Scalars['Float']>;
  totalProfit?: Maybe<Scalars['Float']>;
  totalRetail?: Maybe<Scalars['Float']>;
  totalUnpriced?: Maybe<Scalars['Int']>;
  totalWhl?: Maybe<Scalars['Float']>;
  totalWhlOff?: Maybe<Scalars['Float']>;
  uniqueProducts: Scalars['Int'];
  withoutImages: Scalars['Int'];
};

export type OfferRow = {
  __typename?: 'OfferRow';
  id: Scalars['String'];
  attributes: OfferRowAttributes;
  createdAt: Scalars['Int'];
  creatorCompanyRole: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  images: OfferRowImages;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  kind: OfferRowKind;
  offerStatus: ListingOfferStatus;
  packages: OfferRowPackages;
  productIds: OfferRowProductIds;
  products?: Maybe<OfferRowProducts>;
  skus: OfferRowSkus;
  updatedAt: Scalars['Int'];
  version?: Maybe<Scalars['Int']>;
  draftPercentageOffMsrp?: Maybe<Scalars['Float']>;
  currentPercentageOffMsrp?: Maybe<Scalars['Float']>;
  draftPercentageOffWholesale?: Maybe<Scalars['Float']>;
  currentPercentageOffWholesale?: Maybe<Scalars['Float']>;
  draftTotalPrice?: Maybe<Scalars['Float']>;
  currentTotalPrice?: Maybe<Scalars['Float']>;
  initialTotalPrice?: Maybe<Scalars['Float']>;
  draftUnitPrice?: Maybe<Scalars['Float']>;
  currentUnitPrice?: Maybe<Scalars['Float']>;
  initialUnitPrice?: Maybe<Scalars['Float']>;
  draftPackagePrice?: Maybe<Scalars['Float']>;
  currentPackagePrice?: Maybe<Scalars['Float']>;
  initialPackagePrice?: Maybe<Scalars['Float']>;
  margin?: Maybe<Scalars['Float']>;
  markup?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
  unitMsrp?: Maybe<Scalars['Float']>;
  unitRetail?: Maybe<Scalars['Float']>;
  unitWholesale?: Maybe<Scalars['Float']>;
  initialTotalUnits: Scalars['Int'];
  currentTotalUnits?: Maybe<Scalars['Int']>;
  draftTotalUnits: Scalars['Int'];
  /** previously: unitOfferPrice */
  unitPrice?: Maybe<Scalars['Float']>;
  theyChangedPackageDistribution?: Maybe<Scalars['Boolean']>;
  theyChangedPriceValueBy?: Maybe<Scalars['Float']>;
  theyChangedQuantityValueBy?: Maybe<Scalars['Float']>;
  weChangedPackageDistribution?: Maybe<Scalars['Boolean']>;
  weChangedPriceValueBy?: Maybe<Scalars['Float']>;
  weChangedQuantityValueBy?: Maybe<Scalars['Float']>;
};

export type OfferRowAttributes = {
  __typename?: 'OfferRowAttributes';
  nodes: Array<OfferRowAttribute>;
};

export type OfferRowAttribute = {
  __typename?: 'OfferRowAttribute';
  id: Scalars['String'];
  inturnType: Scalars['String'];
  label: Scalars['String'];
  value: Scalars['String'];
  position: Scalars['Int'];
};

export type OfferRowImages = {
  __typename?: 'OfferRowImages';
  nodes: Array<OfferRowImage>;
};

export type OfferRowImage = {
  __typename?: 'OfferRowImage';
  id: Scalars['String'];
  src: Scalars['String'];
  title: Scalars['String'];
  colorMatch: Scalars['Boolean'];
};

export enum OfferRowKind {
  Item = 'item',
  CasepackMulti = 'casepackMulti',
  CasepackSingle = 'casepackSingle',
}

export enum ListingOfferStatus {
  Accepted = 'ACCEPTED',
  Closed = 'CLOSED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Countered = 'COUNTERED',
  Processing = 'PROCESSING',
  Expired = 'EXPIRED',
}

export type OfferRowPackages = {
  __typename?: 'OfferRowPackages';
  nodes: Array<OfferRowPackage>;
};

export type OfferRowPackage = {
  __typename?: 'OfferRowPackage';
  id: Scalars['String'];
  categorySizes?: Maybe<OfferRowPackageCategorySizes>;
  currentPrice?: Maybe<Scalars['Float']>;
  currentUnits?: Maybe<Scalars['Int']>;
  currentPackageQuantity?: Maybe<Scalars['Int']>;
  draftPrice: Scalars['Float'];
  draftUnits: Scalars['Int'];
  draftPackageQuantity?: Maybe<Scalars['Int']>;
  initialPrice?: Maybe<Scalars['Float']>;
  initialUnits: Scalars['Int'];
  initialPackageQuantity: Scalars['Int'];
  packageCost?: Maybe<Scalars['Float']>;
  packageMsrp?: Maybe<Scalars['Float']>;
  packageWholesale?: Maybe<Scalars['Float']>;
  previousPrice?: Maybe<Scalars['Float']>;
  previousUnits?: Maybe<Scalars['Int']>;
  unitsPerPackage: Scalars['Int'];
  upc: Scalars['String'];
};

export type OfferRowPackageCategorySizes = {
  __typename?: 'OfferRowPackageCategorySizes';
  nodes: Array<OfferRowPackageCategorySize>;
};

export type OfferRowPackageCategorySize = {
  __typename?: 'OfferRowPackageCategorySize';
  category: Scalars['String'];
  /** sizes will be null when sizes are hidden */
  sizes?: Maybe<OfferRowPackageCategorySizeSizes>;
};

export type OfferRowPackageCategorySizeSizes = {
  __typename?: 'OfferRowPackageCategorySizeSizes';
  nodes: Array<OfferRowPackageCategorySizeSize>;
};

export type OfferRowPackageCategorySizeSize = {
  __typename?: 'OfferRowPackageCategorySizeSize';
  id: Scalars['String'];
  label: Scalars['String'];
  draftUnits: Scalars['Int'];
  currentUnits?: Maybe<Scalars['Int']>;
  initialUnits: Scalars['Int'];
  unitsPerPackageCategorySize: Scalars['Int'];
  hasMultipleDimensions: Scalars['Boolean'];
};

export type OfferRowProductIds = {
  __typename?: 'OfferRowProductIds';
  nodes: Array<OfferRowProductId>;
};

export type OfferRowProductId = {
  __typename?: 'OfferRowProductId';
  value: Scalars['String'];
};

export type OfferRowProducts = {
  __typename?: 'OfferRowProducts';
  nodes: Array<OfferRowProductDetail>;
};

export type OfferRowProductDetail = {
  __typename?: 'OfferRowProductDetail';
  uuid: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  sku: Scalars['String'];
  createdAt: Scalars['Int'];
  attributes: OfferRowAttributes;
  variants: OfferRowVariants;
  priceSummaries: OfferRowPriceSummaries;
  packages: OfferRowProductPackages;
};

export type OfferRowVariants = {
  __typename?: 'OfferRowVariants';
  nodes: Array<OfferRowVariant>;
};

export type OfferRowVariant = {
  __typename?: 'OfferRowVariant';
  uuid: Scalars['String'];
  productId: Scalars['String'];
  position: Scalars['Int'];
  markets: OfferRowVariantMarkets;
  images?: Maybe<OfferRowVariantImages>;
  options: OfferRowVariantOptions;
};

export type OfferRowVariantMarkets = {
  __typename?: 'OfferRowVariantMarkets';
  nodes: Array<OfferRowVariantMarket>;
};

export type OfferRowVariantMarket = {
  __typename?: 'OfferRowVariantMarket';
  uuid: Scalars['String'];
  name: Scalars['String'];
  currency: Scalars['String'];
  currencyCode: Scalars['String'];
  retail: Scalars['Float'];
  suggested: Scalars['Float'];
};

export type OfferRowVariantImages = {
  __typename?: 'OfferRowVariantImages';
  nodes: Array<OfferRowVariantImage>;
};

export type OfferRowVariantImage = {
  __typename?: 'OfferRowVariantImage';
  src: Scalars['String'];
  position: Scalars['Int'];
};

export type OfferRowVariantOptions = {
  __typename?: 'OfferRowVariantOptions';
  nodes: Array<OfferRowVariantOption>;
};

export type OfferRowVariantOption = {
  __typename?: 'OfferRowVariantOption';
  name: Scalars['String'];
  value: Scalars['String'];
  valueUuid: Scalars['String'];
  inturnType?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
};

export type OfferRowPriceSummaries = {
  __typename?: 'OfferRowPriceSummaries';
  nodes: Array<OfferRowPriceSummary>;
};

export type OfferRowPriceSummary = {
  __typename?: 'OfferRowPriceSummary';
  marketId: Scalars['String'];
  marketName: Scalars['String'];
  currencyCode: Scalars['String'];
  groupId: Scalars['String'];
  packageType: Scalars['String'];
  retail: Scalars['Float'];
  suggested: Scalars['Float'];
};

export type OfferRowProductPackages = {
  __typename?: 'OfferRowProductPackages';
  nodes: Array<OfferRowProductPackage>;
};

export type OfferRowProductPackage = {
  __typename?: 'OfferRowProductPackage';
  uuid: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  variants: OfferRowProductPackageVariants;
  groups: OfferRowProductPackageGroups;
};

export type OfferRowProductPackageVariants = {
  __typename?: 'OfferRowProductPackageVariants';
  nodes: Array<OfferRowProductPackageVariant>;
};

export type OfferRowProductPackageVariant = {
  __typename?: 'OfferRowProductPackageVariant';
  uuid: Scalars['String'];
  ratio: Scalars['Int'];
  position?: Maybe<Scalars['Int']>;
};

export type OfferRowProductPackageGroups = {
  __typename?: 'OfferRowProductPackageGroups';
  nodes: Array<OfferRowProductPackageGroup>;
};

export type OfferRowProductPackageGroup = {
  __typename?: 'OfferRowProductPackageGroup';
  uuid: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  status: Scalars['String'];
  path: Scalars['String'];
  total: Scalars['Int'];
  available: Scalars['Int'];
  unavailable: Scalars['Int'];
  marketId: Scalars['String'];
  marketName?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  isLocked: Scalars['Boolean'];
};

export type OfferRowSkus = {
  __typename?: 'OfferRowSkus';
  nodes: Array<OfferRowSku>;
};

export type OfferRowSku = {
  __typename?: 'OfferRowSku';
  value: Scalars['String'];
};

export type OfferRowCategories = {
  __typename?: 'OfferRowCategories';
  nodes: Array<OfferRowCategory>;
};

export type OfferRowCategory = {
  __typename?: 'OfferRowCategory';
  name: Scalars['String'];
  totals: OfferRowCategoryTotals;
  sizes?: Maybe<CategorySizes>;
};

export type OfferRowCategoryTotals = {
  __typename?: 'OfferRowCategoryTotals';
  /** @deprecated Use draftTotalUnits field */
  totalUnits: Scalars['Float'];
  draftTotalPrice?: Maybe<Scalars['Float']>;
  draftTotalUnits?: Maybe<Scalars['Float']>;
  totalMargin?: Maybe<Scalars['Float']>;
  totalMsrpOff?: Maybe<Scalars['Float']>;
  totalWhlOff?: Maybe<Scalars['Float']>;
  uniqueProducts: Scalars['Float'];
};

export type CategorySizes = {
  __typename?: 'CategorySizes';
  nodes: Array<CategorySize>;
};

export type CategorySize = {
  __typename?: 'CategorySize';
  name: Scalars['String'];
  /** @deprecated Use draftTotalUnits field */
  totalUnits?: Maybe<Scalars['Float']>;
  draftTotalUnits?: Maybe<Scalars['Float']>;
};

export type OfferRowsFilters = {
  __typename?: 'OfferRowsFilters';
  nodes: Array<OfferRowsFiltersNode>;
};

export type OfferRowsFiltersNode = {
  __typename?: 'OfferRowsFiltersNode';
  count: Scalars['Int'];
  label: Scalars['String'];
  inturnType?: Maybe<Scalars['String']>;
  options: OfferRowsFiltersNodeOptions;
};

export type OfferRowsFiltersNodeOptions = {
  __typename?: 'OfferRowsFiltersNodeOptions';
  nodes: Array<Scalars['String']>;
};

export type OfferRowsRollups = {
  __typename?: 'OfferRowsRollups';
  nodes: Array<OfferRowsRollupsNode>;
};

export type OfferRowsRollupsNode = {
  __typename?: 'OfferRowsRollupsNode';
  label: Scalars['String'];
  missing: Scalars['Boolean'];
  ranges: OfferRowsRollupsNodeRanges;
};

export type OfferRowsRollupsNodeRanges = {
  __typename?: 'OfferRowsRollupsNodeRanges';
  nodes: Array<OfferRowsRollupsNodeRangesNode>;
};

export type OfferRowsRollupsNodeRangesNode = {
  __typename?: 'OfferRowsRollupsNodeRangesNode';
  label: Scalars['String'];
  value: Scalars['Float'];
};

export type ListingOffersV2Actions = {
  __typename?: 'ListingOffersV2Actions';
  accept?: Maybe<Scalars['Boolean']>;
  add?: Maybe<Scalars['Boolean']>;
  canAlterOffer?: Maybe<Scalars['Boolean']>;
  canUploadPDF?: Maybe<Scalars['Boolean']>;
  counterOffer?: Maybe<Scalars['Boolean']>;
  create?: Maybe<Scalars['Boolean']>;
  createPo?: Maybe<Scalars['Boolean']>;
  customPo?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
  draftIsEmpty?: Maybe<Scalars['Boolean']>;
  endNegotiation?: Maybe<Scalars['Int']>;
  pickingQuantities?: Maybe<Scalars['Boolean']>;
  pickingSizes?: Maybe<Scalars['Boolean']>;
  priceByMsrp?: Maybe<Scalars['Boolean']>;
  priceByWholesale?: Maybe<Scalars['Boolean']>;
  remove?: Maybe<Scalars['Boolean']>;
  revoke?: Maybe<Scalars['Boolean']>;
  setActualizedData?: Maybe<Scalars['Boolean']>;
  showMsrp?: Maybe<Scalars['Boolean']>;
  showSizes?: Maybe<Scalars['Boolean']>;
  showWholesale?: Maybe<Scalars['Boolean']>;
  submit?: Maybe<Scalars['Boolean']>;
  toCSV?: Maybe<Scalars['Boolean']>;
  toHtml?: Maybe<Scalars['Boolean']>;
  upload?: Maybe<Scalars['Int']>;
};

export enum ListingStatus {
  Accepted = 'ACCEPTED',
  Closed = 'CLOSED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Named = 'NAMED',
  Processing = 'PROCESSING',
  Published = 'PUBLISHED',
  Received = 'RECEIVED',
  Sent = 'SENT',
  Unpublished = 'UNPUBLISHED',
}

export type ListingCompanyOffers = {
  __typename?: 'ListingCompanyOffers';
  nodes: Array<Offer>;
  actions?: Maybe<ListingCompanyOffersActions>;
};

export type ListingCompanyOffersActions = {
  __typename?: 'ListingCompanyOffersActions';
  toHtml?: Maybe<Scalars['Boolean']>;
  toCSV?: Maybe<Scalars['Boolean']>;
  create?: Maybe<Scalars['Boolean']>;
  add?: Maybe<Scalars['Boolean']>;
  accept?: Maybe<Scalars['Boolean']>;
  counterOffer?: Maybe<Scalars['Boolean']>;
  createPo?: Maybe<Scalars['Boolean']>;
  customPo?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
  pickingQuantities?: Maybe<Scalars['Boolean']>;
  pickingSizes?: Maybe<Scalars['Boolean']>;
  priceByMSRP?: Maybe<Scalars['Boolean']>;
  priceByWholesale?: Maybe<Scalars['Boolean']>;
  remove?: Maybe<Scalars['Boolean']>;
  revoke?: Maybe<Scalars['Boolean']>;
  showSizes?: Maybe<Scalars['Boolean']>;
  submit?: Maybe<Scalars['Boolean']>;
  upload?: Maybe<Scalars['Int']>;
  draftIsEmpty?: Maybe<Scalars['Boolean']>;
  canAlterOffer?: Maybe<Scalars['Boolean']>;
  canUploadPDF?: Maybe<Scalars['Boolean']>;
  endNegotiation?: Maybe<Scalars['Int']>;
};

export type ListingsV2 = {
  __typename?: 'ListingsV2';
  nodes: Array<ListingsV2Listing>;
  pagination: CoreApiPagination;
  filters: CoreApiFiltersResponse;
  key: Scalars['String'];
};

export type ListingsV2FiltersArgs = {
  label?: Maybe<Scalars['String']>;
};

export type ListingsV2Listing = {
  __typename?: 'ListingsV2Listing';
  acceptedAt: Scalars['Int'];
  allowCounteroffers: Scalars['Boolean'];
  allowPickingitems: Scalars['Boolean'];
  allowPickingquantities: Scalars['Boolean'];
  allowPickingsizes: Scalars['Boolean'];
  buyerCompany?: Maybe<Company>;
  channelId: Scalars['String'];
  companyId: Scalars['String'];
  creator: CompanyRole;
  creatorId: Scalars['String'];
  creatorName: Scalars['String'];
  endDate: Scalars['Int'];
  hasPackages: Scalars['Boolean'];
  id: Scalars['ID'];
  isEdited: Scalars['Boolean'];
  itemCount: Scalars['Int'];
  listingCurrencyCode?: Maybe<Scalars['String']>;
  listingId: Scalars['String'];
  listingPublishedAt?: Maybe<Scalars['Int']>;
  marketId: Scalars['String'];
  mostRecentOfferId: Scalars['String'];
  offerLastModified?: Maybe<Scalars['Int']>;
  offerSubmittedAt?: Maybe<Scalars['Int']>;
  offers: ListingOffersV2;
  /** @deprecated We should not use offersRows without passing in an offer ID, using this may cause issues */
  offerRows: OfferRows;
  sellerCompany: Company;
  status: ListingStatus;
  title: Scalars['String'];
  unitCount: Scalars['Int'];
  version: Scalars['Int'];
};

export type ListingsV2ListingOffersArgs = {
  buyerCompanyUuid?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};

export type ListingsV2ListingOfferRowsArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type Markets = {
  __typename?: 'Markets';
  nodes: Array<Market>;
};

export type Market = {
  __typename?: 'Market';
  id: Scalars['ID'];
  isoCurrencyCode: Scalars['String'];
  name: Scalars['String'];
  symbol: Scalars['String'];
};

export type ChannelMarkets = {
  __typename?: 'ChannelMarkets';
  nodes: Array<ChannelMarket>;
};

export type ChannelMarket = {
  __typename?: 'ChannelMarket';
  id: Scalars['ID'];
  name: Scalars['String'];
  currency: ChannelMarketCurrency;
};

export type ChannelMarketCurrency = {
  __typename?: 'ChannelMarketCurrency';
  id: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  symbol: Scalars['String'];
};

export type Me = Node & {
  __typename?: 'Me';
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  categories?: Maybe<ProductCategories>;
  companyAvatarUrl?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['ID']>;
  companyUuid: Scalars['ID'];
  companyName?: Maybe<Scalars['String']>;
  companyRole?: Maybe<CompanyRole>;
  countryCode?: Maybe<Scalars['String']>;
  connectionStatus?: Maybe<ConnectionStatus>;
  department?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  hasOffersV2?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isSimpleBuyer?: Maybe<Scalars['Boolean']>;
  hideClarity?: Maybe<Scalars['Boolean']>;
  isSupport?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  onboardingCompletedAt?: Maybe<Scalars['Date']>;
  permissions?: Maybe<Permissions>;
  phoneNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  userRole?: Maybe<Scalars['String']>;
  uuid: Scalars['ID'];
  visible?: Maybe<Scalars['Boolean']>;
  zip?: Maybe<Scalars['String']>;
};

export type ProductCategories = {
  __typename?: 'ProductCategories';
  nodes?: Maybe<Array<Maybe<ProductCategory>>>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  id: Scalars['Float'];
  name: Scalars['String'];
  checked?: Maybe<Scalars['Boolean']>;
  grouping: Scalars['String'];
};

export enum ConnectionStatus {
  Contact = 'CONTACT',
  None = 'NONE',
}

export type Permissions = {
  __typename?: 'Permissions';
  allocation?: Maybe<Scalars['Boolean']>;
  editCompanyProfile?: Maybe<Scalars['Boolean']>;
  hasCasepacks?: Maybe<Scalars['Boolean']>;
  hasInventory?: Maybe<Scalars['Boolean']>;
  hasItems?: Maybe<Scalars['Boolean']>;
};

export type MessageThreadsResponse = MessageThreads | GenericError;

export type MessageThreads = {
  __typename?: 'MessageThreads';
  pagination: MessageThreadsPagination;
  nodes: Array<MessageThread>;
};

export type MessageThreadsPagination = Pagination & {
  __typename?: 'MessageThreadsPagination';
  currentPage: Scalars['Int'];
  perPage: Scalars['Int'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type Pagination = {
  currentPage: Scalars['Int'];
  perPage: Scalars['Int'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type MessageThread = Node & {
  __typename?: 'MessageThread';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  isRead?: Maybe<Scalars['Boolean']>;
  participants: Participants;
  updatedAt: Scalars['Date'];
  messages: MessageThreadMessages;
};

export type Participants = {
  __typename?: 'Participants';
  nodes: Array<User>;
};

export type MessageThreadMessages = {
  __typename?: 'MessageThreadMessages';
  nodes: Array<MessageThreadMessage>;
  pagination?: Maybe<MessageThreadMessagesPagination>;
};

export type MessageThreadMessage = {
  __typename?: 'MessageThreadMessage';
  content: Scalars['String'];
  createdAt: Scalars['Date'];
  creator: User;
  creatorId: Scalars['ID'];
  id: Scalars['ID'];
  notifiedAt?: Maybe<Scalars['Date']>;
  readAt?: Maybe<Scalars['Date']>;
  status: MessageThreadMessageStatus;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum MessageThreadMessageStatus {
  Delivered = 'DELIVERED',
  Read = 'READ',
}

export type MessageThreadMessagesPagination = MessagesPagination & {
  __typename?: 'MessageThreadMessagesPagination';
  currentPage: Scalars['Int'];
  perPage: Scalars['Int'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type MessagesPagination = {
  currentPage: Scalars['Int'];
  perPage: Scalars['Int'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type MessageThreadMessagesResponse =
  | MessageThreadMessages
  | GenericError;

export type MetaData = {
  __typename?: 'MetaData';
  actionNames: Array<Scalars['String']>;
  actions: MetaDataActions;
  countryCodes?: Maybe<CountryCodes>;
  stateCodes?: Maybe<StateCodes>;
};

export type MetaDataActions = {
  __typename?: 'MetaDataActions';
  accessAllListings?: Maybe<Scalars['Boolean']>;
  allocation?: Maybe<Scalars['Boolean']>;
  appHeaderV3?: Maybe<Scalars['Boolean']>;
  availableToSell?: Maybe<Scalars['Boolean']>;
  companyProfile?: Maybe<Scalars['Boolean']>;
  createListings?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use createOfferV3 */
  createOffer?: Maybe<Scalars['Boolean']>;
  createOfferV3?: Maybe<Scalars['Boolean']>;
  dashboard?: Maybe<Scalars['Boolean']>;
  discovery?: Maybe<Scalars['Boolean']>;
  documentServiceBulkUpload?: Maybe<Scalars['Boolean']>;
  editCompanyProfile?: Maybe<Scalars['Boolean']>;
  filterRedundantGroups?: Maybe<Scalars['Boolean']>;
  hasCasepacks?: Maybe<Scalars['Boolean']>;
  hasInventory?: Maybe<Scalars['Boolean']>;
  horizontalSizing?: Maybe<Scalars['Boolean']>;
  importInventory?: Maybe<Scalars['Boolean']>;
  inventoryDynamicFilters?: Maybe<Scalars['Boolean']>;
  inventoryLinesheet?: Maybe<Scalars['Boolean']>;
  linesheet?: Maybe<Scalars['Boolean']>;
  manageCompanyRelationships?: Maybe<Scalars['Boolean']>;
  manageInventory?: Maybe<Scalars['Boolean']>;
  manageListings?: Maybe<Scalars['Boolean']>;
  manageOffers?: Maybe<Scalars['Boolean']>;
  manageUsers?: Maybe<Scalars['Boolean']>;
  movingUnits?: Maybe<Scalars['Boolean']>;
  negotiationPoExport?: Maybe<Scalars['Boolean']>;
  notInOffer?: Maybe<Scalars['Boolean']>;
  offerOverview?: Maybe<Scalars['Boolean']>;
  sidebarNavigation?: Maybe<Scalars['Boolean']>;
  servicesV2?: Maybe<Scalars['Boolean']>;
  temporalBulkUpdateQty?: Maybe<Scalars['Boolean']>;
  temporalBulkUpdatePrice?: Maybe<Scalars['Boolean']>;
  testFeature?: Maybe<Scalars['Boolean']>;
  viewAnalytics?: Maybe<Scalars['Boolean']>;
  viewReports?: Maybe<Scalars['Boolean']>;
  variantPriceAveraging?: Maybe<Scalars['Boolean']>;
  zendesk?: Maybe<Scalars['Boolean']>;
  reportingLink?: Maybe<Scalars['Boolean']>;
  enableAdvancedAnalytics?: Maybe<Scalars['Boolean']>;
  counterOfferUploadRevamp?: Maybe<Scalars['Boolean']>;
  downloadOfferRevamp?: Maybe<Scalars['Boolean']>;
  /**
   * (EN-1305): Allows us to phase in the usage of the new 'cases' metric to reflect how many
   * casepacks we have available. Created 11.23.2020 by Pod Alpha.
   */
  showCases?: Maybe<Scalars['Boolean']>;
  /**
   * (EN-3448): Makes the IUI dashboard show all products, regardless of market. Without it, when
   * you select a market, you only see products that HAVE a price in that market, resulting in some
   * weird behavior. Most customers don't have this use case, but we are testing for now.
   * Created 2.2.2021 by Pod Bravo. (Talk to Dan).
   */
  noMarketFilterInDashboard?: Maybe<Scalars['Boolean']>;
  /** (EN-3829): Gives user option to resync channels manaully */
  hasAccountResync?: Maybe<Scalars['Boolean']>;
  /** (EN-5271): Ability to toggle Clone functionality per company */
  hideClone?: Maybe<Scalars['Boolean']>;
  /** (EN-5066): Gives option to run Temporal version of Submit Offer Workflow */
  temporalWorkflowSubmitOffer?: Maybe<Scalars['Boolean']>;
  /** (EN-5524): Gives option to show the withdraw option in negotiation section */
  withdrawOffer?: Maybe<Scalars['Boolean']>;
  /** (EN-6763): Uses a better performance approach to make a single package qty update */
  singlePackageQty?: Maybe<Scalars['Boolean']>;
  /**
   * (EN-6659): Gives option to do partial replace by the given attribute the products
   * that match the attribute with the products in the import file.
   */
  partialReplaceAttribute?: Maybe<Scalars['String']>;
};

export type CountryCodes = {
  __typename?: 'CountryCodes';
  nodes?: Maybe<Array<Maybe<CountryCode>>>;
};

export type CountryCode = {
  __typename?: 'CountryCode';
  value?: Maybe<Scalars['String']>;
};

export type StateCodes = {
  __typename?: 'StateCodes';
  nodes?: Maybe<Array<Maybe<StateCode>>>;
};

export type StateCode = {
  __typename?: 'StateCode';
  value?: Maybe<Scalars['String']>;
};

export type Notifications = NotificationsSuccess | NotificationsError;

export type NotificationsSuccess = {
  __typename?: 'NotificationsSuccess';
  nodes: Array<NotificationSuccess>;
};

export type NotificationSuccess = Activity & {
  __typename?: 'NotificationSuccess';
  id: Scalars['ID'];
  action: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  avatar: Scalars['String'];
  createdAt: Scalars['Int'];
  flagColor: NotificationFlagColor;
  isDismissed: Scalars['Boolean'];
  isRead: Scalars['Boolean'];
  message: Scalars['String'];
  type: ActivityKind;
  updatedAt: Scalars['Int'];
  userId: Scalars['ID'];
  actionData: NotificationActionData;
  i18n: NotificationI18nParams;
};

export type Activity = {
  id: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  createdAt: Scalars['Int'];
  isDismissed: Scalars['Boolean'];
  isRead: Scalars['Boolean'];
  type: ActivityKind;
  updatedAt: Scalars['Int'];
  userId: Scalars['ID'];
};

export enum ActivityKind {
  Process = 'PROCESS',
  Notification = 'NOTIFICATION',
  NotificationALL = 'NOTIFICATION_ALL',
  ProcessALL = 'PROCESS_ALL',
}

export enum NotificationFlagColor {
  Blue = 'BLUE',
  Yellow = 'YELLOW',
  Red = 'RED',
  Green = 'GREEN',
}

export type NotificationActionData = {
  __typename?: 'NotificationActionData';
  listingId?: Maybe<Scalars['ID']>;
  buyerCompanyId?: Maybe<Scalars['ID']>;
};

export type NotificationI18nParams = {
  __typename?: 'NotificationI18nParams';
  lastName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  offerName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
};

export type NotificationsError = Error & {
  __typename?: 'NotificationsError';
  kind: ErrorKind;
  message: Scalars['String'];
  status: Scalars['String'];
};

export type OfferCasepacks = {
  __typename?: 'OfferCasepacks';
  nodes?: Maybe<Array<Maybe<OfferCasepack>>>;
  key?: Maybe<Scalars['String']>;
  pagination?: Maybe<OfferProductsPagination>;
  filters?: Maybe<OfferProductsFilters>;
};

export type OfferCasepack = OfferMultiItemCasepack | OfferSingleItemCasepack;

export type OfferMultiItemCasepack = InventoryProduct & {
  __typename?: 'OfferMultiItemCasepack';
  attributes: Scalars['AnyObject'];
  allocations: Allocations;
  casepackItems: CasepackItems;
  catalogId: Scalars['ID'];
  companyId: Scalars['ID'];
  createdAt: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  images: InventoryItemImages;
  kind: Scalars['String'];
  prices: Prices;
  quantity?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  totalUnits: Scalars['Int'];
  unitsPerCasepack: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Int']>;
  bid?: Maybe<Bid>;
};

export type OfferSingleItemCasepack = InventorySingleItem &
  InventoryProduct & {
    __typename?: 'OfferSingleItemCasepack';
    allocations: Allocations;
    attributes: Scalars['AnyObject'];
    catalogId: Scalars['ID'];
    companyId: Scalars['ID'];
    createdAt: Scalars['Int'];
    description?: Maybe<Scalars['String']>;
    externalId: Scalars['ID'];
    images: InventoryItemImages;
    kind: Scalars['String'];
    id: Scalars['ID'];
    prices: Prices;
    quantity?: Maybe<Scalars['Int']>;
    sku: Scalars['String'];
    sizes: InventorySizes;
    style?: Maybe<Scalars['String']>;
    title: Scalars['String'];
    totalUnits: Scalars['Int'];
    unitsPerCasepack: Scalars['Int'];
    updatedAt?: Maybe<Scalars['Int']>;
    bid?: Maybe<Bid>;
  };

export type OfferProductsRollup = {
  __typename?: 'OfferProductsRollup';
  id: Scalars['ID'];
  allHavePrice: Metric;
  percentMargin: Metric;
  percentMarkup: Metric;
  percentOffMsrp: Metric;
  percentOffWholesale: Metric;
  totalCost: Metric;
  totalCasepacks: Metric;
  totalItems: Metric;
  totalMsrp: Metric;
  totalOfferPrice: Metric;
  totalProfit: Metric;
  totalUnits: Metric;
  totalWholesale: Metric;
  unitOfferPrice: Metric;
};

export type OfferRollupSummary = Node & {
  __typename?: 'OfferRollupSummary';
  id: Scalars['ID'];
  percentMargin?: Maybe<Metric>;
  percentMarkup?: Maybe<Metric>;
  percentOffMsrp?: Maybe<Metric>;
  percentOffWholesale?: Maybe<Metric>;
  totalCost?: Maybe<Metric>;
  totalItems?: Maybe<Metric>;
  totalMsrp?: Maybe<Metric>;
  totalOfferPrice?: Maybe<Metric>;
  totalProfit?: Maybe<Metric>;
  totalUnits?: Maybe<Metric>;
  totalWholesale?: Maybe<Metric>;
  unitOfferPrice?: Maybe<Metric>;
  totalProducts?: Maybe<Metric>;
};

export type OffersSummary = Node & {
  __typename?: 'OffersSummary';
  id: Scalars['ID'];
  accepted?: Maybe<Metric>;
  draft?: Maybe<Metric>;
  ended?: Maybe<Metric>;
  incoming?: Maybe<Metric>;
  outgoing?: Maybe<Metric>;
  unpublished?: Maybe<Metric>;
};

export type Processes = ProcessesSuccess | ProcessesError;

export type ProcessesSuccess = {
  __typename?: 'ProcessesSuccess';
  nodes: Array<ProcessSuccess>;
};

export type ProcessSuccess = Activity & {
  __typename?: 'ProcessSuccess';
  actionData?: Maybe<Scalars['AnyObject']>;
  context?: Maybe<Scalars['AnyObject']>;
  createdAt: Scalars['Int'];
  description: Scalars['String'];
  event: Scalars['String'];
  icon: Scalars['String'];
  id: Scalars['ID'];
  isDismissed: Scalars['Boolean'];
  isRead: Scalars['Boolean'];
  state: ProcessState;
  title: Scalars['String'];
  type: ActivityKind;
  updatedAt: Scalars['Int'];
  userId: Scalars['ID'];
  stages: Array<ProcessStage>;
};

export enum ProcessState {
  Done = 'DONE',
  Error = 'ERROR',
  Processing = 'PROCESSING',
}

export type ProcessStage = {
  __typename?: 'ProcessStage';
  description: ProcessStageDescription;
  order: Scalars['Int'];
  status: ProcessStageStatus;
  details: ProcessStageDetails;
};

export enum ProcessStageDescription {
  AllocateInventory = 'ALLOCATE_INVENTORY',
  CloseOffer = 'CLOSE_OFFER',
  CloneListing = 'CLONE_LISTING',
  Conversion = 'CONVERSION',
  DeletePackages = 'DELETE_PACKAGES',
  DeleteProducts = 'DELETE_PRODUCTS',
  ImageSync = 'IMAGE_SYNC',
  IndexInventory = 'INDEX_INVENTORY',
  MatchingImages = 'MATCHING_IMAGES',
  MoveNegotiationUnits = 'MOVE_NEGOTIATION_UNITS',
  MovePackages = 'MOVE_PACKAGES',
  MoveProducts = 'MOVE_PRODUCTS',
  Normalization = 'NORMALIZATION',
  OfferPublish = 'OFFER_PUBLISH',
  OfferCounter = 'OFFER_COUNTER',
  Persistence = 'PERSISTENCE',
  PersistingImages = 'PERSISTING_IMAGES',
  PricingProducts = 'PRICING_PRODUCTS',
  RetrievingOfferInformation = 'RETRIEVING_OFFER_INFORMATION',
  SavingImages = 'SAVING_IMAGES',
  SyncListings = 'SYNC_LISTINGS',
  NegotiationUpdate = 'NEGOTIATION_UPDATE',
  UploadCounterOffer = 'UPLOAD_COUNTER_OFFER',
  UpdateOffer = 'UPDATE_OFFER',
  UnknownProcess = 'UNKNOWN_PROCESS',
  Lotus = 'LOTUS',
  Mapping = 'MAPPING',
  CopyInventory = 'COPY_INVENTORY',
  ApplyQuantities = 'APPLY_QUANTITIES',
  Indexation = 'INDEXATION',
  Validation = 'VALIDATION',
  SubmitOffer = 'SUBMIT_OFFER',
  SendingEmail = 'SENDING_EMAIL',
  WithdrawingOffer = 'WITHDRAWING_OFFER',
  SaveOfferSummary = 'SAVE_OFFER_SUMMARY',
  ArchiveListing = 'ARCHIVE_LISTING',
  CleanIndexes = 'CLEAN_INDEXES',
}

export enum ProcessActions {
  Import = "IMPORT",
  ImageSync = "IMAGE_SYNC",
  RemoveQuantities = "REMOVE_QUANTITIES",
  MoveQuantities = "MOVE_QUANTITIES",
  RemoveOfferQuantities = "REMOVE_OFFER_QUANTITIES",
  CloseOffer = "CLOSE_OFFER",
  CloneOffer = "CLONE_OFFER",
  WithdrawOffer = "WITHDRAW_OFFER",
  ClearDraft = "CLEAR_DRAFT",
  SubmitOffer = "SUBMIT_OFFER",
  BulkUpdateOffer = "BULK_UPDATE_OFFER",
  UploadCounterOffer = 'UPLOAD_COUNTER_OFFER',
  MoveProducts = 'MOVE_PRODUCTS',
}

export enum ProcessStageStatus {
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Error = 'ERROR',
}

export type ProcessStageDetails = {
  __typename?: 'ProcessStageDetails';
  error?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};

export type ProcessesError = Error & {
  __typename?: 'ProcessesError';
  kind: ErrorKind;
  message: Scalars['String'];
};

export type ProductGroup = Node & {
  __typename?: 'ProductGroup';
  id: Scalars['ID'];
  packages?: Maybe<Packages>;
  packageFilters?: Maybe<Filters>;
  products?: Maybe<Products>;
  productFilters?: Maybe<Filters>;
};

export type ProductGroupPackagesArgs = {
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  filters?: Maybe<Array<Maybe<FilterInput>>>;
};

export type ProductGroupPackageFiltersArgs = {
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type ProductGroupProductsArgs = {
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  filters?: Maybe<Array<Maybe<FilterInput>>>;
};

export type ProductGroupProductFiltersArgs = {
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  filters?: Maybe<Array<Maybe<FilterInput>>>;
};

export type FilterInput = {
  id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Packages = {
  __typename?: 'Packages';
  nodes?: Maybe<Array<Maybe<Package>>>;
};

export type Package = {
  __typename?: 'Package';
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  price?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type Filters = {
  __typename?: 'Filters';
  nodes?: Maybe<Array<Maybe<Filter>>>;
};

export type Filter = {
  __typename?: 'Filter';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  values?: Maybe<FilterValues>;
};

export type FilterValues = {
  __typename?: 'FilterValues';
  nodes?: Maybe<Array<Maybe<FilterValue>>>;
};

export type FilterValue = {
  __typename?: 'FilterValue';
  quantity?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type Products = {
  __typename?: 'Products';
  nodes?: Maybe<Array<Maybe<Product>>>;
};

export type Product = {
  __typename?: 'Product';
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  price?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type SearchServiceProducts = {
  __typename?: 'SearchServiceProducts';
  nodes: Array<SearchServiceProduct>;
  meta: SearchServiceProductMeta;
};

export type SearchServiceProduct = {
  __typename?: 'SearchServiceProduct';
  attributes: SearchServiceProductAttributes;
  kind: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  quantitySummaries: SearchServiceProductQuantitySummaries;
  options: SearchServiceProductOptions;
  sizeSummaries: SearchServiceProductSizeSummaries;
  sku: Scalars['String'];
  variants: SearchServiceProductVariants;
  uuid: Scalars['ID'];
};

export type SearchServiceProductAttributes = {
  __typename?: 'SearchServiceProductAttributes';
  nodes: Array<SearchServiceProductAttribute>;
};

export type SearchServiceProductAttribute = {
  __typename?: 'SearchServiceProductAttribute';
  inturnType: Scalars['String'];
  label: Scalars['String'];
  position: Scalars['Int'];
  type: Scalars['String'];
  uuid?: Maybe<Scalars['ID']>;
  value: Scalars['String'];
};

export type SearchServiceProductQuantitySummaries = {
  __typename?: 'SearchServiceProductQuantitySummaries';
  nodes: Array<SearchServiceProductQuantitySummary>;
};

export type SearchServiceProductQuantitySummary = {
  __typename?: 'SearchServiceProductQuantitySummary';
  availableQuantity: Scalars['Int'];
  groupId: Scalars['ID'];
  groupType: Scalars['String'];
  packageType: Scalars['String'];
  totalAvailable: Scalars['Int'];
  totalQuantity: Scalars['Int'];
};

export type SearchServiceProductOptions = {
  __typename?: 'SearchServiceProductOptions';
  nodes: Array<SearchServiceProductOption>;
};

export type SearchServiceProductOption = {
  __typename?: 'SearchServiceProductOption';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type SearchServiceProductSizeSummaries = {
  __typename?: 'SearchServiceProductSizeSummaries';
  nodes: Array<SearchServiceProductSizeSummary>;
};

export type SearchServiceProductSizeSummary = {
  __typename?: 'SearchServiceProductSizeSummary';
  groupId: Scalars['ID'];
  packageType: Scalars['String'];
  sizePerGroupSummaries: SearchServiceProductSizeSummarySizePerGroupSummaries;
};

export type SearchServiceProductSizeSummarySizePerGroupSummaries = {
  __typename?: 'SearchServiceProductSizeSummarySizePerGroupSummaries';
  nodes: Array<SearchServiceProductSizeSummarySizePerGroupSummary>;
};

export type SearchServiceProductSizeSummarySizePerGroupSummary = {
  __typename?: 'SearchServiceProductSizeSummarySizePerGroupSummary';
  totalAvailable: Scalars['Int'];
  totalQuantity: Scalars['Int'];
  value: Scalars['String'];
};

export type SearchServiceProductVariants = {
  __typename?: 'SearchServiceProductVariants';
  nodes: Array<SearchServiceProductVariant>;
};

export type SearchServiceProductVariant = {
  __typename?: 'SearchServiceProductVariant';
  images: SearchServiceProductVariantImages;
  markets: SearchServiceProductVariantMarkets;
  productID: Scalars['String'];
  uuid: Scalars['ID'];
};

export type SearchServiceProductVariantImages = {
  __typename?: 'SearchServiceProductVariantImages';
  nodes?: Maybe<Array<SearchServiceProductVariantImage>>;
};

export type SearchServiceProductVariantImage = {
  __typename?: 'SearchServiceProductVariantImage';
  colorMatch: Scalars['Boolean'];
  position: Scalars['Int'];
  productImageID: Scalars['ID'];
  url: Scalars['String'];
};

export type SearchServiceProductVariantMarkets = {
  __typename?: 'SearchServiceProductVariantMarkets';
  nodes: Array<SearchServiceProductVariantMarket>;
};

export type SearchServiceProductVariantMarket = {
  __typename?: 'SearchServiceProductVariantMarket';
  cost?: Maybe<Scalars['Float']>;
  currency: Scalars['String'];
  currencyCode: Scalars['String'];
  marketUUID: Scalars['ID'];
  name: Scalars['String'];
  prices: SearchServiceProductVariantMarketPrices;
  retail?: Maybe<Scalars['Float']>;
  suggested?: Maybe<Scalars['Float']>;
  wholesale?: Maybe<Scalars['Float']>;
};

export type SearchServiceProductVariantMarketPrices = {
  __typename?: 'SearchServiceProductVariantMarketPrices';
  nodes: Array<Metric>;
};

export type SearchServiceProductMeta = {
  __typename?: 'SearchServiceProductMeta';
  filters: SearchServiceProductFilters;
  pagination: SearchServiceProductPagination;
  rollups: SearchServiceProductRollups;
  totalUnits: Scalars['Int'];
  totals: SearchServiceProductTotals;
  key: Scalars['String'];
};

export type SearchServiceProductFilters = {
  __typename?: 'SearchServiceProductFilters';
  nodes: Array<SearchServiceProductFilter>;
};

export type SearchServiceProductFilter = {
  __typename?: 'SearchServiceProductFilter';
  count: Scalars['Int'];
  label: Scalars['String'];
  options: SearchServiceProductFilterOptions;
  inturnType?: Maybe<Scalars['String']>;
};

export type SearchServiceProductFilterOptions = {
  __typename?: 'SearchServiceProductFilterOptions';
  nodes: Array<Scalars['String']>;
};

export type SearchServiceProductPagination = {
  __typename?: 'SearchServiceProductPagination';
  totalElements: Scalars['Int'];
};

export type SearchServiceProductRollups = {
  __typename?: 'SearchServiceProductRollups';
  nodes: Array<SearchServiceProductRollup>;
};

export type SearchServiceProductRollup = {
  __typename?: 'SearchServiceProductRollup';
  type: Scalars['String'];
  rollupMarkets: SearchServiceProductMarketRollups;
};

export type SearchServiceProductMarketRollups = {
  __typename?: 'SearchServiceProductMarketRollups';
  nodes: Array<SearchServiceProductMarketRollup>;
};

export type SearchServiceProductMarketRollup = {
  __typename?: 'SearchServiceProductMarketRollup';
  marketId: Scalars['String'];
  marketName?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  options: SearchServiceProductMarketRollupOptions;
};

export type SearchServiceProductMarketRollupOptions = {
  __typename?: 'SearchServiceProductMarketRollupOptions';
  nodes: Array<SearchServiceProductMarketRollupOption>;
};

export type SearchServiceProductMarketRollupOption = {
  __typename?: 'SearchServiceProductMarketRollupOption';
  allocated: SearchServiceProductMarketRollupOptionRanges;
  label: Scalars['String'];
  missing: Scalars['Boolean'];
  ranges: SearchServiceProductMarketRollupOptionRanges;
  unallocated: SearchServiceProductMarketRollupOptionRanges;
};

export type SearchServiceProductMarketRollupOptionRanges = {
  __typename?: 'SearchServiceProductMarketRollupOptionRanges';
  nodes: Array<SearchServiceProductMarketRollupOptionRange>;
};

export type SearchServiceProductMarketRollupOptionRange = {
  __typename?: 'SearchServiceProductMarketRollupOptionRange';
  label: Scalars['String'];
  value: Scalars['Float'];
};

export type SearchServiceProductTotals = {
  __typename?: 'SearchServiceProductTotals';
  availableQuantity: Scalars['Int'];
  totalQuantity: Scalars['Int'];
  withoutImages: Scalars['Int'];
};

export type SearchServicePackages = {
  __typename?: 'SearchServicePackages';
  nodes: Array<SearchServicePackage>;
  meta: SearchServicePackageMeta;
};

export type SearchServicePackage = {
  __typename?: 'SearchServicePackage';
  name: Scalars['String'];
  unitsPerPackage: Scalars['Int'];
  groups: SearchServicePackageGroups;
  inturnPackageId: Scalars['String'];
  kind: Scalars['String'];
  type: Scalars['String'];
  prices: SearchServicePackagePrices;
  products: SearchServicePackageProducts;
  variants: SearchServicePackageVariants;
  uuid: Scalars['ID'];
};

export type SearchServicePackageGroups = {
  __typename?: 'SearchServicePackageGroups';
  nodes: Array<SearchServicePackageGroup>;
};

export type SearchServicePackageGroup = {
  __typename?: 'SearchServicePackageGroup';
  groupId: Scalars['ID'];
  totalQuantity: Scalars['Int'];
  totalAvailable: Scalars['Int'];
  unitsTotalQuantity: Scalars['Int'];
  unitsTotalAvailable: Scalars['Int'];
  type: Scalars['String'];
  sizeSummaries: SearchServicePackageGroupSizeSummaries;
};

export type SearchServicePackageGroupSizeSummaries = {
  __typename?: 'SearchServicePackageGroupSizeSummaries';
  nodes: Array<SearchServicePackageGroupSizeSummary>;
};

export type SearchServicePackageGroupSizeSummary = {
  __typename?: 'SearchServicePackageGroupSizeSummary';
  totalAvailable: Scalars['Int'];
  totalQuantity: Scalars['Int'];
  value: Scalars['String'];
};

export type SearchServicePackagePrices = {
  __typename?: 'SearchServicePackagePrices';
  nodes: Array<SearchServicePackagePrice>;
};

export type SearchServicePackagePrice = {
  __typename?: 'SearchServicePackagePrice';
  cost: Metric;
  currencyCode: Scalars['String'];
  marketUUID: Scalars['ID'];
  retail: Metric;
  wholesale: Metric;
  suggested: Metric;
};

export type SearchServicePackageProducts = {
  __typename?: 'SearchServicePackageProducts';
  nodes: Array<SearchServiceProduct>;
};

export type SearchServicePackageVariants = {
  __typename?: 'SearchServicePackageVariants';
  nodes: Array<SearchServicePackageVariant>;
};

export type SearchServicePackageVariant = {
  __typename?: 'SearchServicePackageVariant';
  images: SearchServicePackageVariantImages;
  markets: SearchServicePackageVariantMarkets;
  options: SearchServicePackageVariantOptions;
  productID: Scalars['String'];
  ratio: Scalars['Float'];
  uuid: Scalars['ID'];
};

export type SearchServicePackageVariantImages = {
  __typename?: 'SearchServicePackageVariantImages';
  nodes: Array<SearchServicePackageVariantImage>;
};

export type SearchServicePackageVariantImage = {
  __typename?: 'SearchServicePackageVariantImage';
  colorMatch: Scalars['Boolean'];
  position: Scalars['Int'];
  productImageID: Scalars['ID'];
  url: Scalars['String'];
};

export type SearchServicePackageVariantMarkets = {
  __typename?: 'SearchServicePackageVariantMarkets';
  nodes: Array<SearchServicePackageVariantMarket>;
};

export type SearchServicePackageVariantMarket = {
  __typename?: 'SearchServicePackageVariantMarket';
  cost?: Maybe<Scalars['Float']>;
  currency: Scalars['String'];
  currencyCode: Scalars['String'];
  marketUUID: Scalars['ID'];
  name: Scalars['String'];
  prices: SearchServicePackageVariantMarketPrices;
  retail?: Maybe<Scalars['Float']>;
  suggested?: Maybe<Scalars['Float']>;
  wholesale?: Maybe<Scalars['Float']>;
};

export type SearchServicePackageVariantMarketPrices = {
  __typename?: 'SearchServicePackageVariantMarketPrices';
  nodes: Array<Metric>;
};

export type SearchServicePackageVariantOptions = {
  __typename?: 'SearchServicePackageVariantOptions';
  nodes: Array<SearchServicePackageVariantOption>;
};

export type SearchServicePackageVariantOption = {
  __typename?: 'SearchServicePackageVariantOption';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type SearchServicePackageMeta = {
  __typename?: 'SearchServicePackageMeta';
  filters: SearchServiceProductFilters;
  pagination: SearchServicePackagePagination;
  rollups: SearchServiceProductRollups;
  totalUnits: Scalars['Int'];
  totals: SearchServicePackageTotals;
  key: Scalars['String'];
};

export type SearchServicePackagePagination = {
  __typename?: 'SearchServicePackagePagination';
  totalElements: Scalars['Int'];
};

export type SearchServicePackageTotals = {
  __typename?: 'SearchServicePackageTotals';
  availableQuantity: Scalars['Int'];
  totalQuantity: Scalars['Int'];
  unitsAvailableQuantity: Scalars['Int'];
  unitsTotalQuantity: Scalars['Int'];
  withoutImages: Scalars['Int'];
};

export type SearchServiceActiveFilters = {
  __typename?: 'SearchServiceActiveFilters';
  filterGroupsCondition: Scalars['String'];
  filterGroups: Array<SearchServiceActiveFilterGroup>;
};

export type SearchServiceActiveFilterGroup = {
  __typename?: 'SearchServiceActiveFilterGroup';
  filtersCondition: Scalars['String'];
  filters: Array<SearchServiceActiveFilterData>;
};

export type SearchServiceActiveFilterData = {
  __typename?: 'SearchServiceActiveFilterData';
  field: Scalars['String'];
  condition: Scalars['String'];
  values?: Maybe<Array<Maybe<Scalars['AnyObject']>>>;
};

export enum FilterKeyEntityType {
  Products = 'products',
  Packages = 'packages',
  Negotiations = 'negotiations',
}

export type SearchQueryType = {
  search: SearchType;
};

export type SearchType = {
  filterGroups: Array<Maybe<SearchServiceFilterGroup>>;
  filterGroupsCondition: Scalars['String'];
};

export type SearchServiceFilterKey = {
  __typename?: 'SearchServiceFilterKey';
  data: Scalars['String'];
};

export type Transactions = {
  __typename?: 'Transactions';
  nodes: Array<Transaction>;
};

export type Transaction = Node & {
  __typename?: 'Transaction';
  id: Scalars['ID'];
  totalItems: Scalars['Int'];
  totalUnits: Scalars['Int'];
  finalPrice: Scalars['Float'];
  totalMsrp: Scalars['Float'];
  totalWholesale: Scalars['Float'];
  description: Scalars['String'];
  createdAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
  isoCurrencyCode: Scalars['String'];
};

export enum Fed_CompanyRole {
  Seller = 'SELLER',
  Buyer = 'BUYER',
}

export type Fed_OffersConnection = {
  __typename?: 'FED_OffersConnection';
  nodes?: Maybe<Array<Maybe<Fed_Offer>>>;
};

export type Fed_Offer = Node & {
  __typename?: 'FED_Offer';
  id: Scalars['ID'];
  title: Scalars['String'];
  version: Scalars['Int'];
  declineInfo?: Maybe<Fed_DeclineInfo>;
  isCurrent: Scalars['Boolean'];
  status: Fed_OfferStatus;
  isDraftEdited?: Maybe<Scalars['Boolean']>;
  parentListing?: Maybe<Fed_Listing>;
  acceptedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  submittedAt?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
  seller: Fed_User;
  creator?: Maybe<Fed_User>;
  rollups?: Maybe<Fed_OfferRollups>;
  offerRows?: Maybe<Fed_OfferRows>;
};

export type Fed_OfferRollupsArgs = {
  listingCreatorCompanyId?: Maybe<Scalars['String']>;
  buyerCompanyId?: Maybe<Scalars['String']>;
  filterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
};

export type Fed_OfferOfferRowsArgs = {
  filterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
  buyerCompanyUUID?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sortDirection?: Maybe<Scalars['String']>;
  sortKey?: Maybe<Scalars['String']>;
  sortScope?: Maybe<Scalars['String']>;
  sortScopeValue?: Maybe<Scalars['String']>;
};

export type Fed_DeclineInfo = {
  __typename?: 'FED_DeclineInfo';
  user?: Maybe<Fed_User>;
  reasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  comment?: Maybe<Scalars['String']>;
};

export type Fed_User = Node & {
  __typename?: 'FED_User';
  id: Scalars['ID'];
  userId: Scalars['String'];
  avatarUrl?: Maybe<Scalars['String']>;
  company?: Maybe<Fed_Company>;
  companyId?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  isPersonalEmail?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  onboardingCompletedAt?: Maybe<Scalars['Date']>;
  role?: Maybe<Fed_UserRole>;
  includeDeletedUsers?: Maybe<Scalars['Boolean']>;
};

export type Fed_Company = Node & {
  __typename?: 'FED_Company';
  id: Scalars['ID'];
  companyId: Scalars['String'];
  name: Scalars['String'];
  role: Fed_CompanyRole;
  avatarUrl?: Maybe<Scalars['String']>;
  /** @deprecated Configuration can be only received for seller's company by seller. Using this field by buyer will lead to an error. vertoFormat can be received from customPo field in FED_Listing */
  configuration?: Maybe<Fed_CompanyConfiguration>;
};

export type Fed_CompanyConfiguration = {
  __typename?: 'FED_CompanyConfiguration';
  companyId: Scalars['ID'];
  vertoFormat?: Maybe<Scalars['String']>;
  buyerAttributes: Array<Fed_BuyerAttribute>;
};

export type Fed_CompanyConfigurationBuyerAttributesArgs = {
  groupId: Scalars['String'];
};

export type Fed_BuyerAttribute = {
  __typename?: 'FED_BuyerAttribute';
  attributeType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum Fed_UserRole {
  Admin = 'ADMIN',
  Manager = 'MANAGER',
}

export enum Fed_OfferStatus {
  Accepted = 'ACCEPTED',
  Closed = 'CLOSED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Countered = 'COUNTERED',
  Processing = 'PROCESSING',
  Expired = 'EXPIRED',
}

export type Fed_Listing = Node & {
  __typename?: 'FED_Listing';
  offers: Array<Fed_Offer>;
  id: Scalars['ID'];
  creator?: Maybe<Fed_User>;
  buyers: Array<Fed_User>;
  buyerCompanies?: Maybe<Array<Maybe<Fed_Company>>>;
  market?: Maybe<Fed_Market>;
  parentGroup?: Maybe<Fed_Group>;
  group?: Maybe<Fed_Group>;
  endNegotiationReasons: Array<Maybe<Fed_EndNegotiationReason>>;
  otherRestrictions?: Maybe<Scalars['String']>;
  status?: Maybe<Fed_ListingStatus>;
  state: Fed_ListingState;
  title: Scalars['String'];
  visibleAttributes?: Maybe<Array<Scalars['String']>>;
  canAccept?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  allowCounterOffers?: Maybe<Scalars['Boolean']>;
  allowPickingItems?: Maybe<Scalars['Boolean']>;
  allowPickingQuantities?: Maybe<Scalars['Boolean']>;
  allowPickingSizes?: Maybe<Scalars['Boolean']>;
  showMsrp?: Maybe<Scalars['Boolean']>;
  showMsrpPct?: Maybe<Scalars['Boolean']>;
  showSizes?: Maybe<Scalars['Boolean']>;
  showWholesale?: Maybe<Scalars['Boolean']>;
  showWholesalePct?: Maybe<Scalars['Boolean']>;
  expirationDateTime?: Maybe<Scalars['Date']>;
  endDateTime?: Maybe<Scalars['Date']>;
  lastModifiedDateTime?: Maybe<Scalars['Date']>;
  archivedAt?: Maybe<Scalars['Date']>;
  publishedDateTime?: Maybe<Scalars['Date']>;
  customPo?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  truckload?: Maybe<Fed_ListingTruckload>;
};

export type Fed_Market = Node & {
  __typename?: 'FED_Market';
  id: Scalars['ID'];
  name: Scalars['String'];
  currency?: Maybe<Fed_Currency>;
};

export type Fed_Currency = Node & {
  __typename?: 'FED_Currency';
  id: Scalars['ID'];
  code: Scalars['String'];
  name: Scalars['String'];
  symbol: Scalars['String'];
  isoNumber?: Maybe<Scalars['Int']>;
};

export type Fed_Group = {
  __typename?: 'FED_Group';
  id: Scalars['ID'];
  name: Scalars['String'];
  locked: Scalars['Boolean'];
};

export type Fed_EndNegotiationReason = {
  __typename?: 'FED_EndNegotiationReason';
  id: Scalars['String'];
  type: Scalars['String'];
  description: Scalars['String'];
  companyRole: Scalars['String'];
};

export enum Fed_ListingStatus {
  Invalid = 'INVALID',
  Named = 'NAMED',
  Processing = 'PROCESSING',
  Published = 'PUBLISHED',
  Expired = 'EXPIRED',
  Closed = 'CLOSED',
}

export enum Fed_ListingState {
  Invalid = 'INVALID',
  Unpublished = 'UNPUBLISHED',
  Sent = 'SENT',
  Received = 'RECEIVED',
  Accepted = 'ACCEPTED',
  Ended = 'ENDED',
  Expired = 'EXPIRED',
}

export type Fed_ListingTruckload = {
  __typename?: 'FED_ListingTruckload';
  truckloadMaxWeightPerTruck: Scalars['Float'];
  truckloadNumberOfTrucksForSize: Scalars['Int'];
  truckloadMinimumSize?: Maybe<Scalars['Int']>;
  truckloadMaximumSize?: Maybe<Scalars['Int']>;
};

export type Fed_SearchServiceFilterGroup = {
  declaredFilterName?: Maybe<Fed_DeclaredFilter>;
  declaredFilterValues?: Maybe<Array<Scalars['String']>>;
  filtersCondition: Scalars['String'];
  filters: Array<Fed_SearchServiceFilter>;
};

export enum Fed_DeclaredFilter {
  OfferId = 'OfferId',
  SizeLabel = 'SizeLabel',
  BuyerId = 'BuyerId',
}

export type Fed_SearchServiceFilter = {
  field: Scalars['String'];
  condition: Scalars['String'];
  values?: Maybe<Array<Maybe<Scalars['AnyObject']>>>;
};

export type Fed_OfferRollups = {
  __typename?: 'FED_OfferRollups';
  totals: Fed_OfferRollupsTotalRollup;
  categories: Array<Fed_OfferRollupsCategory>;
  sizesByCategory: Array<Fed_OfferRollupsSizeByCategory>;
  filters: Fed_OfferRowsFilters;
  labelRollups: Array<Fed_LabelRollups>;
  categoryRollups?: Maybe<Array<Fed_CategoryRollups>>;
  truckloadTotals?: Maybe<Fed_OfferRollupsTruckloadTotalRollup>;
};

export type Fed_OfferRollupsTruckloadTotalsArgs = {
  filterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
};

export type Fed_OfferRollupsTotalRollup = {
  __typename?: 'FED_OfferRollupsTotalRollup';
  avgCost?: Maybe<Scalars['Float']>;
  avgMargin?: Maybe<Scalars['Float']>;
  avgMarkup?: Maybe<Scalars['Float']>;
  avgMsrp?: Maybe<Scalars['Float']>;
  avgMsrpOff?: Maybe<Scalars['Float']>;
  avgRetail?: Maybe<Scalars['Float']>;
  avgUnitPrice?: Maybe<Scalars['Float']>;
  avgCasePrice?: Maybe<Scalars['Float']>;
  avgWhl?: Maybe<Scalars['Float']>;
  avgWhlOff?: Maybe<Scalars['Float']>;
  currentTotalPrice?: Maybe<Scalars['Float']>;
  currentTotalUnits?: Maybe<Scalars['Float']>;
  draftTotalPrice?: Maybe<Scalars['Float']>;
  draftTotalUnits?: Maybe<Scalars['Float']>;
  initialTotalUnits?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
  totalCostUnpriced?: Maybe<Scalars['Int']>;
  totalMargin?: Maybe<Scalars['Float']>;
  totalMarginUnpriced?: Maybe<Scalars['Int']>;
  totalMsrp?: Maybe<Scalars['Float']>;
  totalMsrpOff?: Maybe<Scalars['Float']>;
  totalProfit?: Maybe<Scalars['Float']>;
  totalProfitUnpriced?: Maybe<Scalars['Int']>;
  totalRetail?: Maybe<Scalars['Float']>;
  totalRetailUnpriced?: Maybe<Scalars['Int']>;
  totalUnpriced?: Maybe<Scalars['Int']>;
  totalWhl?: Maybe<Scalars['Float']>;
  totalWhlOff?: Maybe<Scalars['Float']>;
  uniqueProducts?: Maybe<Scalars['Int']>;
  totalProductsInOffer?: Maybe<Scalars['Int']>;
  withoutImages?: Maybe<Scalars['Int']>;
  totalElements?: Maybe<Scalars['Int']>;
  totalCases?: Maybe<Scalars['Int']>;
  totalCasepacks?: Maybe<Scalars['Int']>;
  totalCasepacksUnits?: Maybe<Scalars['Int']>;
  totalItems?: Maybe<Scalars['Int']>;
  totalLooseItemsUnits?: Maybe<Scalars['Int']>;
};

export type Fed_OfferRollupsCategory = {
  __typename?: 'FED_OfferRollupsCategory';
  name: Scalars['String'];
  totals: Fed_OfferRollupsCategoryTotals;
};

export type Fed_OfferRollupsCategoryTotals = {
  __typename?: 'FED_OfferRollupsCategoryTotals';
  draftTotalPrice?: Maybe<Scalars['Float']>;
  draftTotalUnits?: Maybe<Scalars['Float']>;
  totalMargin?: Maybe<Scalars['Float']>;
  totalMsrpOff?: Maybe<Scalars['Float']>;
  totalWhlOff?: Maybe<Scalars['Float']>;
  uniqueProducts: Scalars['Float'];
};

export type Fed_OfferRollupsSizeByCategory = {
  __typename?: 'FED_OfferRollupsSizeByCategory';
  name: Scalars['String'];
  /**
   * This sizes array can comes empty if the request was made
   * by a buyer and the Show sizes setting has been set in false.
   */
  sizes: Array<Fed_OfferRollupsSize>;
  totals?: Maybe<Fed_OfferRollupsCategoryTotals>;
};

export type Fed_OfferRollupsSize = {
  __typename?: 'FED_OfferRollupsSize';
  name: Scalars['String'];
  draftTotalUnits?: Maybe<Scalars['Float']>;
};

export type Fed_OfferRowsFilters = {
  __typename?: 'FED_OfferRowsFilters';
  nodes: Array<Fed_OfferRowsFiltersNode>;
};

export type Fed_OfferRowsFiltersNode = {
  __typename?: 'FED_OfferRowsFiltersNode';
  count: Scalars['Int'];
  label: Scalars['String'];
  inturnType?: Maybe<Scalars['String']>;
  options: Fed_OfferRowsFiltersNodeOptions;
};

export type Fed_OfferRowsFiltersNodeOptions = {
  __typename?: 'FED_OfferRowsFiltersNodeOptions';
  nodes: Array<Scalars['String']>;
};

export type Fed_LabelRollups = {
  __typename?: 'FED_LabelRollups';
  label: Scalars['String'];
  missing: Scalars['Boolean'];
  ranges: Array<Fed_LabelRollupsNodeRanges>;
};

export type Fed_LabelRollupsNodeRanges = {
  __typename?: 'FED_LabelRollupsNodeRanges';
  label: Scalars['String'];
  value: Scalars['Float'];
};

export type Fed_CategoryRollups = {
  __typename?: 'FED_CategoryRollups';
  name: Scalars['String'];
  totals: Fed_OfferRollupsTotalRollup;
};

export type Fed_OfferRollupsTruckloadTotalRollup = {
  __typename?: 'FED_OfferRollupsTruckloadTotalRollup';
  totalGrossWeight?: Maybe<Scalars['Float']>;
  totalCube?: Maybe<Scalars['Float']>;
  totalTrucks?: Maybe<Scalars['Float']>;
  totalQuantity?: Maybe<Scalars['Int']>;
  totalUnits?: Maybe<Scalars['Int']>;
  totalCases?: Maybe<Scalars['Int']>;
};

export type Fed_OfferRows = {
  __typename?: 'FED_OfferRows';
  pagination: Fed_OfferRowsPagination;
  nodes: Array<Fed_OfferRow>;
  filters: Fed_OfferRowsFilters;
};

export type Fed_OfferRowsPagination = {
  __typename?: 'FED_OfferRowsPagination';
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  total: Scalars['Int'];
  totalElements: Scalars['Int'];
};

export type Fed_OfferRow = {
  __typename?: 'FED_OfferRow';
  id: Scalars['String'];
  attributes: Fed_OfferRowAttributes;
  createdAt: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  images: Fed_OfferRowImages;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  kind: Fed_OfferRowKind;
  packages: Fed_OfferRowPackages;
  productIds: Fed_OfferRowProductIds;
  products?: Maybe<Fed_OfferRowProducts>;
  skus: Fed_OfferRowSkus;
  updatedAt: Scalars['Int'];
  version?: Maybe<Scalars['Int']>;
  draftPercentageOffMsrp?: Maybe<Scalars['Float']>;
  currentPercentageOffMsrp?: Maybe<Scalars['Float']>;
  draftPercentageOffWholesale?: Maybe<Scalars['Float']>;
  currentPercentageOffWholesale?: Maybe<Scalars['Float']>;
  draftTotalPrice?: Maybe<Scalars['Float']>;
  currentTotalPrice?: Maybe<Scalars['Float']>;
  initialTotalPrice?: Maybe<Scalars['Float']>;
  draftUnitPrice?: Maybe<Scalars['Float']>;
  currentUnitPrice?: Maybe<Scalars['Float']>;
  initialUnitPrice?: Maybe<Scalars['Float']>;
  draftPackagePrice?: Maybe<Scalars['Float']>;
  currentPackagePrice?: Maybe<Scalars['Float']>;
  initialPackagePrice?: Maybe<Scalars['Float']>;
  margin?: Maybe<Scalars['Float']>;
  markup?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
  unitMsrp?: Maybe<Scalars['Float']>;
  unitRetail?: Maybe<Scalars['Float']>;
  unitWholesale?: Maybe<Scalars['Float']>;
  initialTotalUnits: Scalars['Int'];
  currentTotalUnits?: Maybe<Scalars['Int']>;
  draftTotalUnits: Scalars['Int'];
  /** previously: unitOfferPrice */
  unitPrice?: Maybe<Scalars['Float']>;
  theyChangedPackageDistribution?: Maybe<Scalars['Boolean']>;
  theyChangedPriceValueBy?: Maybe<Scalars['Float']>;
  theyChangedQuantityValueBy?: Maybe<Scalars['Float']>;
  weChangedPackageDistribution?: Maybe<Scalars['Boolean']>;
  weChangedPriceValueBy?: Maybe<Scalars['Float']>;
  weChangedQuantityValueBy?: Maybe<Scalars['Float']>;
  historicAnalyticData?: FED_OfferRowHistoricAnalyticData;
};

export type Fed_OfferRowAttributes = {
  __typename?: 'FED_OfferRowAttributes';
  nodes: Array<Fed_OfferRowAttribute>;
};

export type Fed_OfferRowAttribute = {
  __typename?: 'FED_OfferRowAttribute';
  id: Scalars['String'];
  inturnType: Scalars['String'];
  label: Scalars['String'];
  value: Scalars['String'];
  position: Scalars['Int'];
};

export type Fed_OfferRowImages = {
  __typename?: 'FED_OfferRowImages';
  nodes: Array<Fed_OfferRowImage>;
};

export type Fed_OfferRowImage = {
  __typename?: 'FED_OfferRowImage';
  id: Scalars['String'];
  src: Scalars['String'];
  title: Scalars['String'];
  colorMatch: Scalars['Boolean'];
};

export enum BidPricingField {
  Wholesale = 'wholesale',
  Msrp = 'msrp',
}

export enum BidPricingMethod {
  UnitPrice = 'unitPrice',
  Percent = 'percent',
}

export type FED_OfferHistoricAnalyticFloatField = {
  __typename?: 'FED_OfferHistoricAnalyticFloatField';
  value?: Maybe<Scalars['Float']>;
  isMultivalued?: Maybe<Scalars['Boolean']>;
};

export type FED_OfferHistoricAnalyticIntField = {
  __typename?: 'FED_OfferHistoricAnalyticIntField';
  value?: Maybe<Scalars['Int']>;
  isMultivalued?: Maybe<Scalars['Boolean']>;
};

export enum FED_OfferHistoricAnalyticDataContentKey {
  Price = 'price',
  Quantity = 'quantity',
  WholeSalePercentage = 'wholeSalePercentage',
  MsrpPercentage = 'msrpPercentage',
}

export type FED_OfferHistoricAnalyticDataContent = {
  __typename?: 'FED_OfferHistoricAnalyticDataContent';
  [FED_OfferHistoricAnalyticDataContentKey.Price]: FED_OfferHistoricAnalyticFloatField;
  [FED_OfferHistoricAnalyticDataContentKey.Quantity]: FED_OfferHistoricAnalyticIntField;
  [FED_OfferHistoricAnalyticDataContentKey.WholeSalePercentage]: FED_OfferHistoricAnalyticFloatField;
  [FED_OfferHistoricAnalyticDataContentKey.MsrpPercentage]: FED_OfferHistoricAnalyticFloatField;
}

export enum FED_OfferHistoricAnalyticDataValueKey {
  Price = 'price',
  Quantity = 'quantity',
}

export type FED_OfferHistoricAnalyticDataValue = {
  __typename?: 'FED_OfferHistoricAnalyticDataValue';
  [FED_OfferHistoricAnalyticDataValueKey.Price]: FED_OfferHistoricAnalyticFloatField;
  [FED_OfferHistoricAnalyticDataValueKey.Quantity]: FED_OfferHistoricAnalyticIntField;
}

export enum FED_OfferHistoricAnalyticDataPercentKey {
  WholeSalePercentage = 'wholeSalePercentage',
  MsrpPercentage = 'msrpPercentage',
}

export type FED_OfferHistoricAnalyticDataPercent = {
  __typename?: 'FED_OfferHistoricAnalyticDataPercent';
  [FED_OfferHistoricAnalyticDataPercentKey.WholeSalePercentage]: FED_OfferHistoricAnalyticFloatField;
  [FED_OfferHistoricAnalyticDataPercentKey.MsrpPercentage]: FED_OfferHistoricAnalyticFloatField;
}

export enum FED_OfferHistoricAnalyticQuantityColumn {
  LastUnitsSoldToAll = 'last_units_sold_to_all',
  LastUnitsOfferedToAll = 'last_units_offered_to_all',
  HighestUnitsSoldToAll = 'highest_units_sold_to_all',
  HighestUnitsOfferedToAll = 'highest_units_offered_to_all',
  LastUnitsSoldToThisBuyer = 'last_units_sold_to_this_buyer',
  LastUnitsOfferedToThisBuyer = 'last_units_offered_to_this_buyer',
  HighestUnitsSoldToThisBuyer = 'highest_units_sold_to_this_buyer',
  HighestUnitsOfferedToThisBuyer = 'highest_units_offered_to_this_buyer',
}

export enum FED_OfferHistoricAnalyticPriceColumn {
  LastUnitPriceSold = 'last_unit_price_sold',
  LastPercentOffWholesaleSold = 'last_percent_off_wholesale_sold',
  LastPercentOffMsrpSold = "last_percent_off_msrp_sold",
  HighestUnitPriceSold = 'highest_unit_price_sold',
  LowestPercentOffWholesaleSold = 'lowest_percent_off_wholesale_sold',
  LowestPercentOffMsrpSold = 'lowest_percent_off_msrp_sold',
  LastUnitPriceOffered  = 'last_unit_price_offered',
  LastPercentOffWholesaleOffered = 'last_percent_off_wholesale_offered',
  LastPercentOffMsrpOffered = 'last_percent_off_msrp_offered',
  HighestUnitPriceOffered = 'highest_unit_price_offered',
  LowestPercentOffWholesaleOffered = 'lowest_percent_off_wholesale_offered',
  LowestPercentOffMsrpOffered = 'lowest_percent_off_msrp_offered',
  LastUnitPriceSoldToBuyer = 'last_unit_price_sold_to_buyer',
  LastPercentOffWholesaleSoldToBuyer = 'last_percent_off_wholesale_sold_to_buyer',
  LastPercentOffMsrpSoldToBuyer = "last_percent_off_msrp_sold_to_buyer",
  HighestUnitPriceSoldToBuyer = 'highest_unit_price_sold_to_buyer',
  LowestPercentOffWholesaleSoldToBuyer = 'lowest_percent_off_wholesale_sold_to_buyer',
  LowestPercentOffMsrpSoldToBuyer = 'lowest_percent_off_msrp_sold_to_buyer',
  LastUnitPriceOfferedToBuyer  = 'last_unit_price_offered_to_buyer',
  LastPercentOffWholesaleOfferedToBuyer = 'last_percent_off_wholesale_offered_to_buyer',
  LastPercentOffMsrpOfferedToBuyer = 'last_percent_off_msrp_offered_to_buyer',
  HighestUnitPriceOfferedToBuyer = 'highest_unit_price_offered_to_buyer',
  LowestPercentOffWholesaleOfferedToBuyer = 'lowest_percent_off_wholesale_offered_to_buyer',
  LowestPercentOffMsrpOfferedToBuyer = 'lowest_percent_off_msrp_offered_to_buyer',
}

export enum FED_OfferRowHistoricAnalyticDataKey {
  HighestOffered = 'highestOffered',
  HighestOfferedToBuyer = 'highestOfferedToBuyer',
  HighestSold = 'highestSold',
  HighestSoldToBuyer = 'highestSoldToBuyer',
  LowestOffered = 'lowestOffered',
  LowestOfferedToBuyer = 'lowestOfferedToBuyer',
  LowestSold = 'lowestSold',
  LowestSoldToBuyer = 'lowestSoldToBuyer',
  LatestOffered = 'latestOffered',
  LatestOfferedToBuyer = 'latestOfferedToBuyer',
  LatestSold = 'latestSold',
  LatestSoldToBuyer = 'latestSoldToBuyer',
}

export type FED_OfferRowHistoricAnalyticData = {
  __typename?: 'FED_OfferRowHistoricAnalyticData';
  matchType?: Maybe<Scalars['String']>;
  highestOffered: FED_OfferHistoricAnalyticDataValue;
  highestOfferedToBuyer: FED_OfferHistoricAnalyticDataValue;
  highestSold: FED_OfferHistoricAnalyticDataValue;
  highestSoldToBuyer: FED_OfferHistoricAnalyticDataValue;
  lowestOffered: FED_OfferHistoricAnalyticDataPercent;
  lowestOfferedToBuyer: FED_OfferHistoricAnalyticDataPercent;
  lowestSold: FED_OfferHistoricAnalyticDataPercent;
  lowestSoldToBuyer: FED_OfferHistoricAnalyticDataPercent;
  latestOffered: FED_OfferHistoricAnalyticDataContent;
  latestOfferedToBuyer: FED_OfferHistoricAnalyticDataContent;
  latestSold: FED_OfferHistoricAnalyticDataContent;
  latestSoldToBuyer: FED_OfferHistoricAnalyticDataContent;
}

export enum Fed_OfferRowKind {
  Item = 'item',
  CasepackMulti = 'casepackMulti',
  CasepackSingle = 'casepackSingle',
}

export type Fed_OfferRowPackages = {
  __typename?: 'FED_OfferRowPackages';
  nodes: Array<Fed_OfferRowPackage>;
};

export type Fed_OfferRowPackage = {
  __typename?: 'FED_OfferRowPackage';
  id: Scalars['String'];
  categorySizes?: Maybe<Fed_OfferRowPackageCategorySizes>;
  currentPrice?: Maybe<Scalars['Float']>;
  currentUnits?: Maybe<Scalars['Int']>;
  currentPackageQuantity?: Maybe<Scalars['Int']>;
  draftPrice: Scalars['Float'];
  draftUnits: Scalars['Int'];
  draftPackageQuantity?: Maybe<Scalars['Int']>;
  initialPrice?: Maybe<Scalars['Float']>;
  initialUnits: Scalars['Int'];
  initialPackageQuantity: Scalars['Int'];
  packageCost?: Maybe<Scalars['Float']>;
  packageMsrp?: Maybe<Scalars['Float']>;
  packageWholesale?: Maybe<Scalars['Float']>;
  previousPrice?: Maybe<Scalars['Float']>;
  previousUnits?: Maybe<Scalars['Int']>;
  unitsPerPackage: Scalars['Int'];
  upc: Scalars['String'];
};

export type Fed_OfferRowPackageCategorySizes = {
  __typename?: 'FED_OfferRowPackageCategorySizes';
  nodes: Array<Fed_OfferRowPackageCategorySize>;
};

export type Fed_OfferRowPackageCategorySize = {
  __typename?: 'FED_OfferRowPackageCategorySize';
  category: Scalars['String'];
  /** sizes will be null when sizes are hidden */
  sizes?: Maybe<Fed_OfferRowPackageCategorySizeSizes>;
};

export type Fed_OfferRowPackageCategorySizeSizes = {
  __typename?: 'FED_OfferRowPackageCategorySizeSizes';
  nodes: Array<Fed_OfferRowPackageCategorySizeSize>;
};

export type Fed_OfferRowPackageCategorySizeSize = {
  __typename?: 'FED_OfferRowPackageCategorySizeSize';
  id: Scalars['String'];
  label: Scalars['String'];
  draftUnits: Scalars['Int'];
  currentUnits?: Maybe<Scalars['Int']>;
  initialUnits: Scalars['Int'];
  unitsPerPackageCategorySize: Scalars['Int'];
  hasMultipleDimensions: Scalars['Boolean'];
};

export type Fed_OfferRowProductIds = {
  __typename?: 'FED_OfferRowProductIds';
  nodes: Array<Fed_OfferRowProductId>;
};

export type Fed_OfferRowProductId = {
  __typename?: 'FED_OfferRowProductId';
  value: Scalars['String'];
};

export type Fed_OfferRowProducts = {
  __typename?: 'FED_OfferRowProducts';
  nodes: Array<Fed_OfferRowProductDetail>;
};

export type Fed_OfferRowProductDetail = {
  __typename?: 'FED_OfferRowProductDetail';
  uuid: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  sku: Scalars['String'];
  createdAt: Scalars['Int'];
  attributes: Fed_OfferRowAttributes;
  variants: Fed_OfferRowVariants;
  priceSummaries: Fed_OfferRowPriceSummaries;
  packages: Fed_OfferRowProductPackages;
};

export type Fed_OfferRowVariants = {
  __typename?: 'FED_OfferRowVariants';
  nodes: Array<Fed_OfferRowVariant>;
};

export type Fed_OfferRowVariant = {
  __typename?: 'FED_OfferRowVariant';
  uuid: Scalars['String'];
  productId: Scalars['String'];
  position: Scalars['Int'];
  markets: Fed_OfferRowVariantMarkets;
  images?: Maybe<Fed_OfferRowVariantImages>;
  options: Fed_OfferRowVariantOptions;
};

export type Fed_OfferRowVariantMarkets = {
  __typename?: 'FED_OfferRowVariantMarkets';
  nodes: Array<Fed_OfferRowVariantMarket>;
};

export type Fed_OfferRowVariantMarket = {
  __typename?: 'FED_OfferRowVariantMarket';
  uuid: Scalars['String'];
  name: Scalars['String'];
  currency: Scalars['String'];
  currencyCode: Scalars['String'];
  retail: Scalars['Float'];
  suggested: Scalars['Float'];
};

export type Fed_OfferRowVariantImages = {
  __typename?: 'FED_OfferRowVariantImages';
  nodes: Array<Fed_OfferRowVariantImage>;
};

export type Fed_OfferRowVariantImage = {
  __typename?: 'FED_OfferRowVariantImage';
  src: Scalars['String'];
  position: Scalars['Int'];
};

export type Fed_OfferRowVariantOptions = {
  __typename?: 'FED_OfferRowVariantOptions';
  nodes: Array<Fed_OfferRowVariantOption>;
};

export type Fed_OfferRowVariantOption = {
  __typename?: 'FED_OfferRowVariantOption';
  name: Scalars['String'];
  value: Scalars['String'];
  valueUuid: Scalars['String'];
  inturnType?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
};

export type Fed_OfferRowPriceSummaries = {
  __typename?: 'FED_OfferRowPriceSummaries';
  nodes: Array<Fed_OfferRowPriceSummary>;
};

export type Fed_OfferRowPriceSummary = {
  __typename?: 'FED_OfferRowPriceSummary';
  marketId: Scalars['String'];
  marketName: Scalars['String'];
  currencyCode: Scalars['String'];
  groupId: Scalars['String'];
  packageType: Scalars['String'];
  retail: Scalars['Float'];
  suggested: Scalars['Float'];
};

export type Fed_OfferRowProductPackages = {
  __typename?: 'FED_OfferRowProductPackages';
  nodes: Array<Fed_OfferRowProductPackage>;
};

export type Fed_OfferRowProductPackage = {
  __typename?: 'FED_OfferRowProductPackage';
  uuid: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  variants: Fed_OfferRowProductPackageVariants;
  groups: Fed_OfferRowProductPackageGroups;
};

export type Fed_OfferRowProductPackageVariants = {
  __typename?: 'FED_OfferRowProductPackageVariants';
  nodes: Array<Fed_OfferRowProductPackageVariant>;
};

export type Fed_OfferRowProductPackageVariant = {
  __typename?: 'FED_OfferRowProductPackageVariant';
  uuid: Scalars['String'];
  ratio: Scalars['Int'];
  position?: Maybe<Scalars['Int']>;
};

export type Fed_OfferRowProductPackageGroups = {
  __typename?: 'FED_OfferRowProductPackageGroups';
  nodes: Array<Fed_OfferRowProductPackageGroup>;
};

export type Fed_OfferRowProductPackageGroup = {
  __typename?: 'FED_OfferRowProductPackageGroup';
  uuid: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  status: Scalars['String'];
  path: Scalars['String'];
  total: Scalars['Int'];
  available: Scalars['Int'];
  unavailable: Scalars['Int'];
  marketId: Scalars['String'];
  marketName?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  isLocked: Scalars['Boolean'];
};

export type Fed_OfferRowSkus = {
  __typename?: 'FED_OfferRowSkus';
  nodes: Array<Fed_OfferRowSku>;
};

export type Fed_OfferRowSku = {
  __typename?: 'FED_OfferRowSku';
  value: Scalars['String'];
};

export enum Fed_SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type Fed_ListingsConnection = {
  __typename?: 'FED_ListingsConnection';
  nodes: Array<Fed_Listing>;
  pagination: Fed_ListingsPagination;
  counts: Fed_ListingsCounts;
};

export type Fed_ListingsPagination = {
  __typename?: 'FED_ListingsPagination';
  limit?: Maybe<Scalars['Int']>;
  count: Scalars['Int'];
  offset: Scalars['Int'];
  total: Scalars['Int'];
};

export type Fed_ListingsCounts = {
  __typename?: 'FED_ListingsCounts';
  states: Array<StatesFieldCount>;
  markets: Array<MarketsFieldCount>;
  companies: Array<CompaniesFieldCount>;
  parentGroups: Array<ParentGroupsFieldCount>;
};

export type StatesFieldCount = FieldCount & {
  __typename?: 'StatesFieldCount';
  key?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};

export type FieldCount = {
  key?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};

export type MarketsFieldCount = FieldCount & {
  __typename?: 'MarketsFieldCount';
  key?: Maybe<Scalars['String']>;
  entity?: Maybe<Fed_Market>;
  count?: Maybe<Scalars['Int']>;
};

export type CompaniesFieldCount = FieldCount & {
  __typename?: 'CompaniesFieldCount';
  key?: Maybe<Scalars['String']>;
  entity?: Maybe<Fed_Company>;
  count?: Maybe<Scalars['Int']>;
};

export type ParentGroupsFieldCount = FieldCount & {
  __typename?: 'ParentGroupsFieldCount';
  key?: Maybe<Scalars['String']>;
  entity?: Maybe<Fed_Group>;
  count?: Maybe<Scalars['Int']>;
};

export type Fed_MarketsConnection = {
  __typename?: 'FED_MarketsConnection';
  nodes?: Maybe<Array<Maybe<Fed_Market>>>;
};

export type UserFilter = {
  name: Scalars['String'];
  mode: Scalars['String'];
  value: Scalars['AnyObject'];
};

export type Fed_Users = {
  __typename?: 'FED_Users';
  nodes: Array<Fed_User>;
};

export type Fed_CurrenciesConnection = {
  __typename?: 'FED_CurrenciesConnection';
  nodes?: Maybe<Array<Fed_Currency>>;
};

export enum Fed_GroupType {
  Invalid = 'INVALID',
  Pool = 'POOL',
  UploadChannel = 'UPLOAD_CHANNEL',
  Hold = 'HOLD',
  Listing = 'LISTING',
}

export type Fed_GroupsConnection = {
  __typename?: 'FED_GroupsConnection';
  nodes: Array<Fed_Group>;
};

export type Fed_SearchServicePackages = {
  __typename?: 'FED_SearchServicePackages';
  nodes: Array<Fed_SearchServicePackage>;
  meta: Fed_SearchServicePackageMeta;
};

export type Fed_SearchServicePackage = {
  __typename?: 'FED_SearchServicePackage';
  name: Scalars['String'];
  unitsPerPackage: Scalars['Int'];
  groups: Fed_SearchServicePackageGroups;
  inturnPackageId: Scalars['String'];
  kind: Scalars['String'];
  type: Scalars['String'];
  prices: Fed_SearchServicePackagePrices;
  products: Fed_SearchServicePackageProducts;
  variants: Fed_SearchServicePackageVariants;
  uuid: Scalars['ID'];
};

export type Fed_SearchServicePackageGroups = {
  __typename?: 'FED_SearchServicePackageGroups';
  nodes: Array<Fed_SearchServicePackageGroup>;
};

export type Fed_SearchServicePackageGroup = {
  __typename?: 'FED_SearchServicePackageGroup';
  groupId: Scalars['ID'];
  totalQuantity: Scalars['Int'];
  totalAvailable: Scalars['Int'];
  unitsTotalQuantity: Scalars['Int'];
  unitsTotalAvailable: Scalars['Int'];
  type: Scalars['String'];
  sizeSummaries: Fed_SearchServicePackageGroupSizeSummaries;
};

export type Fed_SearchServicePackageGroupSizeSummaries = {
  __typename?: 'FED_SearchServicePackageGroupSizeSummaries';
  nodes: Array<Fed_SearchServicePackageGroupSizeSummary>;
};

export type Fed_SearchServicePackageGroupSizeSummary = {
  __typename?: 'FED_SearchServicePackageGroupSizeSummary';
  totalAvailable: Scalars['Int'];
  totalQuantity: Scalars['Int'];
  value: Scalars['String'];
};

export type Fed_SearchServicePackagePrices = {
  __typename?: 'FED_SearchServicePackagePrices';
  nodes: Array<Fed_SearchServicePackagePrice>;
};

export type Fed_SearchServicePackagePrice = {
  __typename?: 'FED_SearchServicePackagePrice';
  cost: Fed_Metric;
  currencyCode: Scalars['String'];
  marketUUID: Scalars['ID'];
  retail: Fed_Metric;
  wholesale: Fed_Metric;
  suggested: Fed_Metric;
};

export type Fed_Metric = {
  __typename?: 'FED_Metric';
  displayValue?: Maybe<Scalars['String']>;
  isoCurrencyCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  originalDisplayValue?: Maybe<Scalars['String']>;
  originalValue?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type Fed_SearchServicePackageProducts = {
  __typename?: 'FED_SearchServicePackageProducts';
  nodes: Array<Fed_SearchServiceProduct>;
};

export type Fed_SearchServiceProduct = {
  __typename?: 'FED_SearchServiceProduct';
  attributes: Fed_SearchServiceProductAttributes;
  kind: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  quantitySummaries: Fed_SearchServiceProductQuantitySummaries;
  options: Fed_SearchServiceProductOptions;
  sizeSummaries: Fed_SearchServiceProductSizeSummaries;
  sku: Scalars['String'];
  variants: Fed_SearchServiceProductVariants;
  uuid: Scalars['ID'];
};

export type Fed_SearchServiceProductAttributes = {
  __typename?: 'FED_SearchServiceProductAttributes';
  nodes: Array<Fed_SearchServiceProductAttribute>;
};

export type Fed_SearchServiceProductAttribute = {
  __typename?: 'FED_SearchServiceProductAttribute';
  inturnType: Scalars['String'];
  label: Scalars['String'];
  position: Scalars['Int'];
  type: Scalars['String'];
  uuid?: Maybe<Scalars['ID']>;
  value: Scalars['String'];
};

export type Fed_SearchServiceProductQuantitySummaries = {
  __typename?: 'FED_SearchServiceProductQuantitySummaries';
  nodes: Array<Fed_SearchServiceProductQuantitySummary>;
};

export type Fed_SearchServiceProductQuantitySummary = {
  __typename?: 'FED_SearchServiceProductQuantitySummary';
  availableQuantity: Scalars['Int'];
  groupId: Scalars['ID'];
  groupType: Scalars['String'];
  packageType: Scalars['String'];
  totalAvailable: Scalars['Int'];
  totalQuantity: Scalars['Int'];
};

export type Fed_SearchServiceProductOptions = {
  __typename?: 'FED_SearchServiceProductOptions';
  nodes: Array<Fed_SearchServiceProductOption>;
};

export type Fed_SearchServiceProductOption = {
  __typename?: 'FED_SearchServiceProductOption';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type Fed_SearchServiceProductSizeSummaries = {
  __typename?: 'FED_SearchServiceProductSizeSummaries';
  nodes: Array<Fed_SearchServiceProductSizeSummary>;
};

export type Fed_SearchServiceProductSizeSummary = {
  __typename?: 'FED_SearchServiceProductSizeSummary';
  groupId: Scalars['ID'];
  packageType: Scalars['String'];
  sizePerGroupSummaries: Fed_SearchServiceProductSizeSummarySizePerGroupSummaries;
};

export type Fed_SearchServiceProductSizeSummarySizePerGroupSummaries = {
  __typename?: 'FED_SearchServiceProductSizeSummarySizePerGroupSummaries';
  nodes: Array<Fed_SearchServiceProductSizeSummarySizePerGroupSummary>;
};

export type Fed_SearchServiceProductSizeSummarySizePerGroupSummary = {
  __typename?: 'FED_SearchServiceProductSizeSummarySizePerGroupSummary';
  totalAvailable: Scalars['Int'];
  totalQuantity: Scalars['Int'];
  value: Scalars['String'];
};

export type Fed_SearchServiceProductVariants = {
  __typename?: 'FED_SearchServiceProductVariants';
  nodes: Array<Fed_SearchServiceProductVariant>;
};

export type Fed_SearchServiceProductVariant = {
  __typename?: 'FED_SearchServiceProductVariant';
  images: Fed_SearchServiceProductVariantImages;
  markets: Fed_SearchServiceProductVariantMarkets;
  productID: Scalars['String'];
  uuid: Scalars['ID'];
};

export type Fed_SearchServiceProductVariantImages = {
  __typename?: 'FED_SearchServiceProductVariantImages';
  nodes?: Maybe<Array<Fed_SearchServiceProductVariantImage>>;
};

export type Fed_SearchServiceProductVariantImage = {
  __typename?: 'FED_SearchServiceProductVariantImage';
  colorMatch: Scalars['Boolean'];
  position: Scalars['Int'];
  productImageID: Scalars['ID'];
  url: Scalars['String'];
};

export type Fed_SearchServiceProductVariantMarkets = {
  __typename?: 'FED_SearchServiceProductVariantMarkets';
  nodes: Array<Fed_SearchServiceProductVariantMarket>;
};

export type Fed_SearchServiceProductVariantMarket = {
  __typename?: 'FED_SearchServiceProductVariantMarket';
  cost?: Maybe<Scalars['Float']>;
  currency: Scalars['String'];
  currencyCode: Scalars['String'];
  marketUUID: Scalars['ID'];
  name: Scalars['String'];
  prices: Fed_SearchServiceProductVariantMarketPrices;
  retail?: Maybe<Scalars['Float']>;
  suggested?: Maybe<Scalars['Float']>;
  wholesale?: Maybe<Scalars['Float']>;
};

export type Fed_SearchServiceProductVariantMarketPrices = {
  __typename?: 'FED_SearchServiceProductVariantMarketPrices';
  nodes: Array<Fed_Metric>;
};

export type Fed_SearchServicePackageVariants = {
  __typename?: 'FED_SearchServicePackageVariants';
  nodes: Array<Fed_SearchServicePackageVariant>;
};

export type Fed_SearchServicePackageVariant = {
  __typename?: 'FED_SearchServicePackageVariant';
  images: Fed_SearchServicePackageVariantImages;
  markets: Fed_SearchServicePackageVariantMarkets;
  options: Fed_SearchServicePackageVariantOptions;
  productID: Scalars['String'];
  ratio: Scalars['Float'];
  uuid: Scalars['ID'];
};

export type Fed_SearchServicePackageVariantImages = {
  __typename?: 'FED_SearchServicePackageVariantImages';
  nodes: Array<Fed_SearchServicePackageVariantImage>;
};

export type Fed_SearchServicePackageVariantImage = {
  __typename?: 'FED_SearchServicePackageVariantImage';
  colorMatch: Scalars['Boolean'];
  position: Scalars['Int'];
  productImageID: Scalars['ID'];
  url: Scalars['String'];
};

export type Fed_SearchServicePackageVariantMarkets = {
  __typename?: 'FED_SearchServicePackageVariantMarkets';
  nodes: Array<Fed_SearchServicePackageVariantMarket>;
};

export type Fed_SearchServicePackageVariantMarket = {
  __typename?: 'FED_SearchServicePackageVariantMarket';
  cost?: Maybe<Scalars['Float']>;
  currency: Scalars['String'];
  currencyCode: Scalars['String'];
  marketUUID: Scalars['ID'];
  name: Scalars['String'];
  prices: Fed_SearchServicePackageVariantMarketPrices;
  retail?: Maybe<Scalars['Float']>;
  suggested?: Maybe<Scalars['Float']>;
  wholesale?: Maybe<Scalars['Float']>;
};

export type Fed_SearchServicePackageVariantMarketPrices = {
  __typename?: 'FED_SearchServicePackageVariantMarketPrices';
  nodes: Array<Fed_Metric>;
};

export type Fed_SearchServicePackageVariantOptions = {
  __typename?: 'FED_SearchServicePackageVariantOptions';
  nodes: Array<Fed_SearchServicePackageVariantOption>;
};

export type Fed_SearchServicePackageVariantOption = {
  __typename?: 'FED_SearchServicePackageVariantOption';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type Fed_SearchServicePackageMeta = {
  __typename?: 'FED_SearchServicePackageMeta';
  filters: Fed_SearchServiceProductFilters;
  pagination: Fed_SearchServicePackagePagination;
  rollups: Fed_SearchServiceProductRollups;
  totalUnits: Scalars['Int'];
  totals: Fed_SearchServicePackageTotals;
  key: Scalars['String'];
};

export type Fed_SearchServiceProductFilters = {
  __typename?: 'FED_SearchServiceProductFilters';
  nodes: Array<Fed_SearchServiceProductFilter>;
};

export type Fed_SearchServiceProductFilter = {
  __typename?: 'FED_SearchServiceProductFilter';
  count: Scalars['Int'];
  label: Scalars['String'];
  options: Fed_SearchServiceProductFilterOptions;
  inturnType?: Maybe<Scalars['String']>;
};

export type Fed_SearchServiceProductFilterOptions = {
  __typename?: 'FED_SearchServiceProductFilterOptions';
  nodes: Array<Scalars['String']>;
};

export type Fed_SearchServicePackagePagination = {
  __typename?: 'FED_SearchServicePackagePagination';
  totalElements: Scalars['Int'];
};

export type Fed_SearchServiceProductRollups = {
  __typename?: 'FED_SearchServiceProductRollups';
  nodes: Array<Fed_SearchServiceProductRollup>;
};

export type Fed_SearchServiceProductRollup = {
  __typename?: 'FED_SearchServiceProductRollup';
  truckloadTotals?: Maybe<Fed_SearchServiceProductTruckloadRollups>;
  type: Scalars['String'];
  rollupMarkets: Fed_SearchServiceProductMarketRollups;
};

export type Fed_SearchServiceProductTruckloadRollups = {
  __typename?: 'FED_SearchServiceProductTruckloadRollups';
  totalGrossWeight?: Maybe<Scalars['Float']>;
  totalCube?: Maybe<Scalars['Float']>;
  totalTrucks?: Maybe<Scalars['Float']>;
  totalQuantity?: Maybe<Scalars['Int']>;
  totalUnits?: Maybe<Scalars['Int']>;
  totalCases?: Maybe<Scalars['Int']>;
  totalPackages?: Maybe<Scalars['Int']>;
};

export type Fed_SearchServiceProductMarketRollups = {
  __typename?: 'FED_SearchServiceProductMarketRollups';
  nodes: Array<Fed_SearchServiceProductMarketRollup>;
};

export type Fed_SearchServiceProductMarketRollup = {
  __typename?: 'FED_SearchServiceProductMarketRollup';
  marketId: Scalars['String'];
  marketName?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  options: Fed_SearchServiceProductMarketRollupOptions;
};

export type Fed_SearchServiceProductMarketRollupOptions = {
  __typename?: 'FED_SearchServiceProductMarketRollupOptions';
  nodes: Array<Fed_SearchServiceProductMarketRollupOption>;
};

export type Fed_SearchServiceProductMarketRollupOption = {
  __typename?: 'FED_SearchServiceProductMarketRollupOption';
  label: Scalars['String'];
  missing: Scalars['Boolean'];
  allocated: Fed_SearchServiceProductMarketRollupOptionRanges;
  ranges: Fed_SearchServiceProductMarketRollupOptionRanges;
  unallocated: Fed_SearchServiceProductMarketRollupOptionRanges;
};

export type Fed_SearchServiceProductMarketRollupOptionRanges = {
  __typename?: 'FED_SearchServiceProductMarketRollupOptionRanges';
  nodes: Array<Fed_SearchServiceProductMarketRollupOptionRange>;
};

export type Fed_SearchServiceProductMarketRollupOptionRange = {
  __typename?: 'FED_SearchServiceProductMarketRollupOptionRange';
  label: Scalars['String'];
  value: Scalars['Float'];
};

export type Fed_SearchServicePackageTotals = {
  __typename?: 'FED_SearchServicePackageTotals';
  availableQuantity: Scalars['Int'];
  totalQuantity: Scalars['Int'];
  unitsAvailableQuantity: Scalars['Int'];
  unitsTotalQuantity: Scalars['Int'];
  withoutImages: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  forgotPassword?: Maybe<ForgotPasswordResponse>;
  changePassword?: Maybe<ChangePasswordResponse>;
  resetPassword?: Maybe<ResetPasswordResponse>;
  updateProductAllocations?: Maybe<Allocations>;
  allocateProducts?: Maybe<Scalars['Boolean']>;
  unallocateProducts?: Maybe<Scalars['Boolean']>;
  updateBid?: Maybe<Bid>;
  updateBidSize?: Maybe<OfferBidSize>;
  updateBidTotalUnits?: Maybe<Bid>;
  addCompanyBrand: Brand;
  addCompanyGalleryImage: CompanyGalleryImage;
  addCompanyLookbook: Lookbook;
  deleteCompanyBrand: BooleanResult;
  deleteCompanyGalleryImage: BooleanResult;
  deleteCompanyLookbook: BooleanResult;
  updateCompanyBrand: Brand;
  updateCompanyGalleryImage: CompanyGalleryImage;
  updateCompanyInfo: Company;
  updateCompanyLogo: Company;
  updateCompanyLookbook: Lookbook;
  addDocumentImage: DocumentImage;
  addDocumentFile: DocumentFile;
  updateDocumentFileSignedSrc: DocumentFile;
  updateImageDocument: ImageSettings;
  syncInventoryImage: ImageSettings;
  syncInventoryData?: Maybe<Scalars['Boolean']>;
  deleteImageDocument?: Maybe<Scalars['Boolean']>;
  deleteInventoryCasepacks?: Maybe<Scalars['Boolean']>;
  uploadInventoryFile?: Maybe<CatalogStub>;
  uploadInventoryImages?: Maybe<CatalogStub>;
  deleteInventoryItems?: Maybe<Scalars['Boolean']>;
  uploadInventoryV2?: Maybe<InventoryUpload>;
  syncInventoryImagesV2?: Maybe<InventoryUpload>;
  uploadInventoryImagesV2?: Maybe<InventoryUpload>;
  addBuyerToListing?: Maybe<Listing>;
  addBuyerToListingV2?: Maybe<ListingV2>;
  removeBuyerFromListing?: Maybe<Listing>;
  removeBuyerFromListingV2?: Maybe<ListingV2>;
  updateListing: Listing;
  publishListingV2: Listing;
  updateListingV2: ListingV2;
  cloneListing?: Maybe<Listing>;
  cloneListingV2?: Maybe<ListingV2>;
  deleteListing?: Maybe<DeletedListing>;
  deleteListingV2?: Maybe<DeletedListing>;
  createListing?: Maybe<Listing>;
  createListingV2?: Maybe<ListingV2>;
  setAllocation?: Maybe<Listing>;
  listingOffersV2DownloadExcel: Scalars['Boolean'];
  downloadOfferV2: Scalars['Boolean'];
  listingOffersV2ExportPo: Scalars['Boolean'];
  listingOffersV2UploadCounterOffer: Scalars['Boolean'];
  syncListing?: Maybe<BooleanResult>;
  createMessageThread: CreateMessageThreadResponse;
  reportMessageThread: ReportMessageThreadResponse;
  createMessageThreadMessage: CreateMessageThreadMessagesResponse;
  updateMessageThreadMessages: UpdateMessageThreadMessagesResponse;
  updateNotification?: Maybe<Notification>;
  createOfferClone: Scalars['Boolean'];
  updateOfferV2: Listing;
  endOffer: BooleanResult;
  bulkAddOfferCasepacks?: Maybe<Scalars['Boolean']>;
  bulkRemoveOfferCasepacks?: Maybe<Scalars['Boolean']>;
  bulkAddOfferItems?: Maybe<Scalars['Boolean']>;
  bulkRemoveOfferItems?: Maybe<Scalars['Boolean']>;
  updateOfferRows?: Maybe<Scalars['Boolean']>;
  clearDraft?: Maybe<Scalars['Boolean']>;
  moveUnitsOutOfNegotiation?: Maybe<Scalars['Boolean']>;
  updateProcess?: Maybe<Process>;
  /** @deprecated Use searchServiceMoveUnits. */
  searchServiceMoveProducts?: Maybe<Scalars['Boolean']>;
  searchServiceMoveUnits?: Maybe<Scalars['Boolean']>;
  deletePackages?: Maybe<Scalars['Boolean']>;
  deletePackagesByKey?: Maybe<Scalars['Boolean']>;
  deleteProducts?: Maybe<Scalars['Boolean']>;
  deleteProductsByKey?: Maybe<Scalars['Boolean']>;
  createTransaction: Transaction;
  updateTransaction: Transaction;
  setPassword?: Maybe<BooleanResult>;
  fillUserData?: Maybe<Scalars['Boolean']>;
  verifyAccount?: Maybe<Scalars['Boolean']>;
  makeConnection?: Maybe<Scalars['Boolean']>;
  removeConnection?: Maybe<Scalars['Boolean']>;
  resendVerificationEmail?: Maybe<Scalars['Boolean']>;
  setProductCategoriesByUser?: Maybe<Scalars['Boolean']>;
  uploadUserAvatar?: Maybe<Me>;
  updateUserInfo?: Maybe<Scalars['Boolean']>;
  createUser?: Maybe<BooleanResult>;
  FED_updateListingTruckloadSettings?: Maybe<Scalars['Boolean']>;
  FED_updateOfferRow?: Maybe<Scalars['String']>;
  FED_bulkUpdateCSPKs: Scalars['Boolean'];
  FED_bulkUpdateLooseItems: Scalars['Boolean'];
  FED_submitOffer: Scalars['String'];
  FED_clearDraft: Scalars['String'];
  FED_withdrawOffer: Scalars['String'];
  FED_cloneOffer: Scalars['String'];
  FED_archiveOffer: Scalars['String'];
  FED_updateNotes: Scalars['Boolean'];
};

export type MutationForgotPasswordArgs = {
  email?: Maybe<Scalars['String']>;
  recaptcha?: Maybe<Scalars['String']>;
};

export type MutationChangePasswordArgs = {
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
  newPasswordConfirmation: Scalars['String'];
};

export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  token: Scalars['String'];
};

export type MutationUpdateProductAllocationsArgs = {
  allocations: Array<Maybe<AllocationDistribution>>;
  entity: Scalars['String'];
  id: Scalars['ID'];
};

export type MutationAllocateProductsArgs = {
  allocations: Array<Maybe<AllocationDistribution>>;
  entity: Scalars['String'];
  filters?: Maybe<Array<Maybe<CoreApiFilter>>>;
  key: Scalars['String'];
};

export type MutationUnallocateProductsArgs = {
  allocations: Array<Maybe<Scalars['String']>>;
  entity: Scalars['String'];
  filters?: Maybe<Array<Maybe<CoreApiFilter>>>;
  key: Scalars['String'];
};

export type MutationUpdateBidArgs = {
  id: Scalars['ID'];
  input?: Maybe<UpdateBidInput>;
  offerId: Scalars['ID'];
  productKind: Scalars['String'];
};

export type MutationUpdateBidSizeArgs = {
  bidId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  input?: Maybe<UpdateBidSizingInput>;
  offerId: Scalars['ID'];
  productKind?: Maybe<Scalars['String']>;
};

export type MutationUpdateBidTotalUnitsArgs = {
  bidId?: Maybe<Scalars['ID']>;
  input?: Maybe<UpdateBidTotalUnitsInput>;
  offerId: Scalars['ID'];
  productKind?: Maybe<Scalars['String']>;
};

export type MutationAddCompanyBrandArgs = {
  input: AddCompanyBrandInput;
};

export type MutationAddCompanyGalleryImageArgs = {
  input: AddCompanyGalleryImageInput;
};

export type MutationAddCompanyLookbookArgs = {
  input: AddCompanyLookbookInput;
};

export type MutationDeleteCompanyBrandArgs = {
  companyId: Scalars['ID'];
  brandId: Scalars['ID'];
};

export type MutationDeleteCompanyGalleryImageArgs = {
  input: DeleteCompanyGalleryImageInput;
};

export type MutationDeleteCompanyLookbookArgs = {
  companyId: Scalars['ID'];
  lookbookId: Scalars['ID'];
};

export type MutationUpdateCompanyBrandArgs = {
  input: UpdateCompanyBrandInput;
};

export type MutationUpdateCompanyGalleryImageArgs = {
  input: UpdateCompanyGalleryImageInput;
};

export type MutationUpdateCompanyInfoArgs = {
  id: Scalars['ID'];
  input?: Maybe<CompanyInfoInput>;
};

export type MutationUpdateCompanyLogoArgs = {
  id: Scalars['ID'];
  file: Scalars['Upload'];
};

export type MutationUpdateCompanyLookbookArgs = {
  input: UpdateCompanyLookbookInput;
};

export type MutationAddDocumentImageArgs = {
  input?: Maybe<DocumentInput>;
};

export type MutationAddDocumentFileArgs = {
  input?: Maybe<DocumentInput>;
};

export type MutationUpdateDocumentFileSignedSrcArgs = {
  id: Scalars['ID'];
};

export type MutationUpdateImageDocumentArgs = {
  colorMatch: Scalars['Boolean'];
  productImageId: Scalars['ID'];
  imagePosition: Scalars['Float'];
  productId: Scalars['ID'];
};

export type MutationSyncInventoryImageArgs = {
  documentId: Scalars['ID'];
  colorMatch: Scalars['Boolean'];
  imagePosition?: Maybe<Scalars['Float']>;
  productId: Scalars['ID'];
};

export type MutationSyncInventoryDataArgs = {
  actionType: InventorySyncActionType;
  channelId: Scalars['String'];
  type: InventorySyncType;
  groupIds?: Maybe<Array<Scalars['String']>>;
  packageIds?: Maybe<Array<Scalars['String']>>;
  productIds?: Maybe<Array<Scalars['String']>>;
};

export type MutationDeleteImageDocumentArgs = {
  productImageId: Scalars['ID'];
  productId: Scalars['ID'];
};

export type MutationDeleteInventoryCasepacksArgs = {
  key?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<CoreApiFilter>>>;
};

export type MutationUploadInventoryFileArgs = {
  file: Scalars['Upload'];
  catalogId?: Maybe<Scalars['ID']>;
};

export type MutationUploadInventoryImagesArgs = {
  files: Array<Maybe<Scalars['Upload']>>;
};

export type MutationDeleteInventoryItemsArgs = {
  key?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<CoreApiFilter>>>;
};

export type MutationUploadInventoryV2Args = {
  channelId: Scalars['String'];
  file: Scalars['Upload'];
  config: InventoryUploadConfig;
};

export type MutationSyncInventoryImagesV2Args = {
  channelId: Scalars['String'];
};

export type MutationUploadInventoryImagesV2Args = {
  files: Array<Maybe<Scalars['Upload']>>;
};

export type MutationAddBuyerToListingArgs = {
  listingId: Scalars['ID'];
  input?: Maybe<AddBuyerToListingInput>;
};

export type MutationAddBuyerToListingV2Args = {
  listingId: Scalars['ID'];
  input?: Maybe<AddBuyerToListingInput>;
};

export type MutationRemoveBuyerFromListingArgs = {
  listingId: Scalars['ID'];
  input?: Maybe<RemoveBuyerFromListingInput>;
};

export type MutationRemoveBuyerFromListingV2Args = {
  listingId: Scalars['ID'];
  input?: Maybe<RemoveBuyerFromListingInput>;
};

export type MutationUpdateListingArgs = {
  id: Scalars['ID'];
  input: ListingInput;
};

export type MutationPublishListingV2Args = {
  id: Scalars['ID'];
  context?: Maybe<Scalars['AnyObject']>;
};

export type MutationUpdateListingV2Args = {
  id: Scalars['ID'];
  input: ListingInputV2;
};

export type MutationCloneListingArgs = {
  id: Scalars['ID'];
};

export type MutationCloneListingV2Args = {
  id: Scalars['ID'];
};

export type MutationDeleteListingArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteListingV2Args = {
  id: Scalars['ID'];
};

export type MutationCreateListingArgs = {
  input?: Maybe<ListingInput>;
};

export type MutationCreateListingV2Args = {
  input: ListingInputV2;
};

export type MutationSetAllocationArgs = {
  listingId: Scalars['ID'];
  allocationId: Scalars['ID'];
};

export type MutationListingOffersV2DownloadExcelArgs = {
  offerId: Scalars['String'];
  listingId: Scalars['String'];
  params: DownloadOfferParams;
};

export type MutationListingOffersV2ExportPoArgs = {
  offerId: Scalars['String'];
};

export type MutationListingOffersV2UploadCounterOfferArgs = {
  offerId: Scalars['ID'];
  file: Scalars['Upload'];
};

export type MutationSyncListingArgs = {
  listingId?: Maybe<Scalars['String']>;
};

export type MutationCreateMessageThreadArgs = {
  content: Scalars['String'];
  userId: Scalars['ID'];
};

export type MutationReportMessageThreadArgs = {
  threadId: Scalars['ID'];
  content: Scalars['String'];
};

export type MutationCreateMessageThreadMessageArgs = {
  threadId: Scalars['ID'];
  content: Scalars['String'];
};

export type MutationUpdateMessageThreadMessagesArgs = {
  threadId: Scalars['ID'];
  payload?: Maybe<UpdateMessageThreadPayloadInput>;
};

export type MutationUpdateNotificationArgs = {
  id: Scalars['ID'];
  input?: Maybe<ActivityInput>;
};

export type MutationCreateOfferCloneArgs = {
  input: OfferCloneInput;
};

export type MutationUpdateOfferV2Args = {
  id: Scalars['ID'];
  input: ListingInputV2;
};

export type MutationEndOfferArgs = {
  input: EndOfferInput;
  sellerCompanyId: Scalars['String'];
  groupId: Scalars['String'];
  offerId: Scalars['String'];
  userUUID: Scalars['String'];
};

export type MutationBulkAddOfferCasepacksArgs = {
  offerId: Scalars['ID'];
  filters: Array<Maybe<CoreApiFilter>>;
  key: Scalars['String'];
  quantity?: Maybe<Scalars['Int']>;
};

export type MutationBulkRemoveOfferCasepacksArgs = {
  offerId: Scalars['ID'];
  filters: Array<Maybe<CoreApiFilter>>;
  key: Scalars['String'];
};

export type MutationBulkAddOfferItemsArgs = {
  offerId: Scalars['ID'];
  filters: Array<Maybe<CoreApiFilter>>;
  key: Scalars['String'];
  quantity?: Maybe<Scalars['Int']>;
};

export type MutationBulkRemoveOfferItemsArgs = {
  offerId: Scalars['ID'];
  filters: Array<Maybe<CoreApiFilter>>;
  key: Scalars['String'];
};

export type MutationUpdateOfferRowsArgs = {
  input?: Maybe<UpdateOfferRowsInput>;
  listingCreatorCompanyUUID?: Maybe<Scalars['String']>;
  offerId?: Maybe<Scalars['String']>;
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  isAsync?: Maybe<Scalars['Boolean']>;
};

export type MutationClearDraftArgs = {
  offerId?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['AnyObject']>;
};

export type MutationMoveUnitsOutOfNegotiationArgs = {
  context?: Maybe<Scalars['AnyObject']>;
  companyUUID?: Maybe<Scalars['String']>;
  filterGroups: Array<Maybe<SearchServiceFilterGroup>>;
  groupId: Scalars['String'];
  offerId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
};

export type MutationUpdateProcessArgs = {
  id: Scalars['ID'];
  input?: Maybe<ActivityInput>;
};

export type MutationSearchServiceMoveProductsArgs = {
  searchKey: Scalars['String'];
  uploadChannel: Scalars['ID'];
  moves: Array<Maybe<SearchServiceMoveData>>;
  userId: Scalars['ID'];
  groupId: Scalars['ID'];
  companyUUID: Scalars['ID'];
  productType: Scalars['String'];
};

export type MutationSearchServiceMoveUnitsArgs = {
  companyUUID?: Maybe<Scalars['String']>;
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  groupId: Scalars['String'];
  moves: Array<Maybe<SearchServiceMoveData>>;
  uploadChannelId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
  entityType?: Maybe<EntityType>;
  context?: Maybe<Scalars['AnyObject']>;
  singleRowUpdate?: Maybe<Scalars['Boolean']>;
};

export type MutationDeletePackagesArgs = {
  companyUUID?: Maybe<Scalars['String']>;
  groupUUID: Scalars['String'];
  packageIds: Array<Scalars['String']>;
  userUUID?: Maybe<Scalars['String']>;
};

export type MutationDeletePackagesByKeyArgs = {
  companyUUID?: Maybe<Scalars['String']>;
  groupUUID: Scalars['String'];
  key: Scalars['String'];
  userUUID?: Maybe<Scalars['String']>;
};

export type MutationDeleteProductsArgs = {
  companyUUID?: Maybe<Scalars['String']>;
  groupUUID: Scalars['String'];
  productIds: Array<Scalars['String']>;
  userUUID?: Maybe<Scalars['String']>;
};

export type MutationDeleteProductsByKeyArgs = {
  companyUUID?: Maybe<Scalars['String']>;
  groupUUID: Scalars['String'];
  key: Scalars['String'];
  userUUID?: Maybe<Scalars['String']>;
};

export type MutationCreateTransactionArgs = {
  offerId: Scalars['ID'];
  input: TransactionInput;
};

export type MutationUpdateTransactionArgs = {
  offerId: Scalars['ID'];
  transactionId: Scalars['ID'];
  input: TransactionInput;
};

export type MutationSetPasswordArgs = {
  input?: Maybe<SetPasswordInput>;
};

export type MutationFillUserDataArgs = {
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  companyName: Scalars['String'];
  password: Scalars['String'];
  listingId: Scalars['String'];
};

export type MutationVerifyAccountArgs = {
  id: Scalars['ID'];
  token: Scalars['String'];
};

export type MutationMakeConnectionArgs = {
  userId: Scalars['ID'];
};

export type MutationRemoveConnectionArgs = {
  userId: Scalars['ID'];
};

export type MutationResendVerificationEmailArgs = {
  id: Scalars['ID'];
  listingId: Scalars['String'];
};

export type MutationSetProductCategoriesByUserArgs = {
  input?: Maybe<ProductCategoriesUpdate>;
};

export type MutationUploadUserAvatarArgs = {
  input?: Maybe<ImageAvatarInput>;
};

export type MutationUpdateUserInfoArgs = {
  input: EditableUserInfo;
};

export type MutationCreateUserArgs = {
  input?: Maybe<CreateUserInput>;
};

export type MutationFed_UpdateListingTruckloadSettingsArgs = {
  listingId: Scalars['ID'];
  truckloadMinimumSize?: Maybe<Scalars['Int']>;
  truckloadMaximumSize?: Maybe<Scalars['Int']>;
};

export type MutationFed_UpdateOfferRowArgs = {
  input?: Maybe<Fed_UpdateOfferRowRequest>;
};

export type MutationFed_BulkUpdateMetricsArgs = {
  productType: Scalars['String'];
  userId: Scalars['ID'];
  companyId: Scalars['ID'];
  buyerCompanyId: Scalars['ID'] | undefined;
  uploadChannelId: Scalars['ID'];
  listingId: Scalars['ID'];
  offerId: Scalars['ID'];
  searchKey: Scalars['String'];
  metrics: Maybe<Scalars['AnyObject']>;
  update: Maybe<Scalars['AnyObject']>;
  context: Maybe<Scalars['AnyObject']>;
}

export type MutationFed_BulkUpdateCspKsArgs = {
  listingId: Scalars['ID'];
  offerId: Scalars['ID'];
  update?: Maybe<Fed_Update>;
  buyerRetailPrice?: Maybe<Scalars['Float']>;
  context?: Maybe<Scalars['AnyObject']>;
  searchKey: Scalars['String'];
};

export type MutationFed_BulkUpdateLooseItemsArgs = {
  listingId: Scalars['ID'];
  offerId: Scalars['ID'];
  update?: Maybe<Fed_Update>;
  buyerRetailPrice?: Maybe<Scalars['Float']>;
  context?: Maybe<Scalars['AnyObject']>;
  searchKey: Scalars['String'];
  packageID?: Maybe<Scalars['ID']>;
};

export type MutationFed_SubmitOfferArgs = {
  offerId: Scalars['ID'];
  listingId: Scalars['ID'];
  uploadChannelId: Scalars['ID'];
  correlationId?: Maybe<Scalars['String']>;
  context: Fed_SubmitOfferContext;
};

export type MutationFed_ClearDraftArgs = {
  input: ClearDraftInput;
};

export type MutationFed_WithdrawOfferArgs = {
  input?: Maybe<Fed_WithdrawOfferRequest>;
};

export type MutationFed_CloneOfferArgs = {
  offerId: Scalars['ID'];
  listingId: Scalars['ID'];
  newListingName: Scalars['String'];
  uploadChannelId: Scalars['String'];
  isDeepCloning?: Maybe<Scalars['Boolean']>;
  clientContext: Scalars['AnyObject'];
};

export type MutationFed_ArchiveOfferArgs = {
  input?: Maybe<Fed_ArchiveOfferRequest>;
};

export type MutationFed_UpdateNotesArgs = {
  input: UpdateNotesInput;
};

export type ForgotPasswordResponse = BooleanResult | GenericError;

export type ChangePasswordResponse = BooleanResult | GenericError;

export type ResetPasswordResponse = Token | GenericError;

export type UpdateBidInput = {
  notes?: Maybe<Scalars['String']>;
  pricing?: Maybe<Array<Maybe<BidPricingInput>>>;
  quantity?: Maybe<Scalars['Int']>;
  isRemoved?: Maybe<Scalars['Boolean']>;
  save?: Maybe<Scalars['Boolean']>;
};

export type BidPricingInput = {
  field: Scalars['String'];
  method: Scalars['String'];
  value: Scalars['Float'];
};

export type UpdateBidSizingInput = {
  quantity: Scalars['Int'];
};

export type UpdateBidTotalUnitsInput = {
  quantity?: Maybe<Scalars['Int']>;
  removed?: Maybe<Scalars['Boolean']>;
  save?: Maybe<Scalars['Boolean']>;
};

export type AddCompanyBrandInput = {
  companyId: Scalars['ID'];
  logoId: Scalars['ID'];
  name: Scalars['String'];
};

export type AddCompanyGalleryImageInput = {
  companyId: Scalars['ID'];
  file: Scalars['Upload'];
  name?: Maybe<Scalars['String']>;
};

export type AddCompanyLookbookInput = {
  companyId: Scalars['ID'];
  file: Scalars['Upload'];
  name?: Maybe<Scalars['String']>;
};

export type DeleteCompanyGalleryImageInput = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateCompanyBrandInput = {
  brandId: Scalars['ID'];
  companyId: Scalars['ID'];
  logoId: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateCompanyGalleryImageInput = {
  companyId: Scalars['ID'];
  file: Scalars['Upload'];
  imageId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type CompanyInfoInput = {
  address?: Maybe<AddressInput>;
  description?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  socialLinks?: Maybe<SocialLinksInput>;
};

export type AddressInput = {
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type SocialLinksInput = {
  facebook?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  pinterest?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type UpdateCompanyLookbookInput = {
  companyId: Scalars['ID'];
  file: Scalars['Upload'];
  lookbookId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type DocumentInput = {
  companyId: Scalars['ID'];
  documentId?: Maybe<Scalars['ID']>;
  file: Scalars['Upload'];
};

export type ImageSettings = {
  __typename?: 'ImageSettings';
  colorMatch: Scalars['Boolean'];
  documentId: Scalars['ID'];
  position: Scalars['Float'];
  productImageId: Scalars['ID'];
  productId: Scalars['ID'];
};

export enum InventorySyncActionType {
  CloneOffer = 'clone_offer',
  CloseOffer = 'close_offer',
  Import = 'import',
  ImageSync = 'image_sync',
  ManualImageSync = 'manual_image_sync',
  MoveQuantities = 'move_quantities',
  RemoveOfferQuantities = 'remove_offer_quantities',
  RemoveQuantities = 'remove_quantities',
  SyncChannel = 'sync_channel',
}

export enum InventorySyncType {
  Package = 'package',
  Product = 'product',
  Group = 'group',
}

export type CatalogStub = {
  __typename?: 'CatalogStub';
  id?: Maybe<Scalars['ID']>;
};

export type InventoryUploadConfig = {
  attributes?: Maybe<Scalars['String']>;
  attributeFilter?: Maybe<AttributeFilter>;
  ignoreLocked?: Maybe<Scalars['Boolean']>;
  prices?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  quantities?: Maybe<Scalars['String']>;
};

export type AttributeFilter = {
  label: Scalars['String'];
};

export type InventoryUpload = {
  __typename?: 'InventoryUpload';
  id?: Maybe<Scalars['String']>;
};

export type AddBuyerToListingInput = {
  userEmail?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type RemoveBuyerFromListingInput = {
  userId?: Maybe<Scalars['ID']>;
};

export type ListingInput = {
  allocationId?: Maybe<Scalars['ID']>;
  allowCounterOffers?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Int']>;
  marketId?: Maybe<Scalars['ID']>;
  otherRestrictions?: Maybe<Scalars['String']>;
  purchasingRule?: Maybe<PurchasingRule>;
  showMsrp?: Maybe<Scalars['Boolean']>;
  showSizes?: Maybe<Scalars['Boolean']>;
  showWholesale?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  visibleAttributes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ListingInputV2 = {
  allowCounterOffers?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  currencyId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Int']>;
  groupId?: Maybe<Scalars['String']>;
  marketId?: Maybe<Scalars['String']>;
  otherRestrictions?: Maybe<Scalars['String']>;
  parentGroupId?: Maybe<Scalars['String']>;
  purchasingRule?: Maybe<PurchasingRule>;
  reason?: Maybe<Scalars['String']>;
  showMsrp?: Maybe<Scalars['Boolean']>;
  showSizes?: Maybe<Scalars['Boolean']>;
  showWholesale?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  visibleAttributes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DeletedListing = {
  __typename?: 'DeletedListing';
  id?: Maybe<Scalars['ID']>;
};

export type DownloadOfferParams = {
  asBuyer: Scalars['Boolean'];
  showImages: Scalars['Boolean'];
  sizingOrientation: SizingOrientation;
};

export enum SizingOrientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

export type CreateMessageThreadResponse = MessageThread | GenericError;

export type ReportMessageThreadResponse = ReportConfirmation | GenericError;

export type ReportConfirmation = {
  __typename?: 'ReportConfirmation';
  content: Scalars['String'];
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  reporteeId: Scalars['ID'];
  reporterId: Scalars['ID'];
  updatedAt: Scalars['Date'];
};

export type CreateMessageThreadMessagesResponse =
  | MessageThreadMessage
  | GenericError;

export type UpdateMessageThreadPayloadInput = {
  status?: Maybe<MessageThreadMessageStatus>;
};

export type UpdateMessageThreadMessagesResponse =
  | UpdateMessageThreadMessagesSuccess
  | GenericError;

export type UpdateMessageThreadMessagesSuccess = {
  __typename?: 'UpdateMessageThreadMessagesSuccess';
  value?: Maybe<Scalars['Boolean']>;
};

export type ActivityInput = {
  isDismissed?: Maybe<Scalars['Boolean']>;
  isRead?: Maybe<Scalars['Boolean']>;
};

export type Notification = NotificationSuccess | NotificationsError;

export type OfferCloneInput = {
  buyers?: Maybe<Array<Maybe<Scalars['String']>>>;
  groupId?: Maybe<Scalars['String']>;
  offerId?: Maybe<Scalars['String']>;
  offerName?: Maybe<Scalars['String']>;
};

export type EndOfferInput = {
  reason?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  status: EndOfferStatus;
};

export enum EndOfferStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Countered = 'COUNTERED',
  Deleted = 'DELETED',
}

export type UpdateOfferRowsInput = {
  context?: Maybe<Scalars['AnyObject']>;
  price?: Maybe<UpdatePricing>;
  quantity?: Maybe<Scalars['Int']>;
  /**
   * Specify package id for quantity update if updating individual package.
   * NOTE: Can not be used for pricing
   */
  packageId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
};

export type UpdatePricing = {
  field?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
  buyerRetail?: Maybe<Scalars['Float']>;
};

export type Process = ProcessSuccess | ProcessesError;

export type SearchServiceMoveData = {
  destination: Scalars['String'];
  type: Scalars['String'];
  mode: Scalars['String'];
  value: Scalars['Int'];
};

export enum EntityType {
  Products = 'PRODUCTS',
  Packages = 'PACKAGES',
  Negotiations = 'NEGOTIATIONS',
}

export type TransactionInput = {
  totalItems: Scalars['Int'];
  totalUnits: Scalars['Int'];
  finalPrice: Scalars['Float'];
  totalMsrp: Scalars['Float'];
  totalWholesale: Scalars['Float'];
  description: Scalars['String'];
};

export type SetPasswordInput = {
  userId: Scalars['ID'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};

export type ProductCategoriesUpdate = {
  userId: Scalars['ID'];
  productCategories: Array<Maybe<ProductCategoryInput>>;
};

export type ProductCategoryInput = {
  id: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  checked: Scalars['Boolean'];
  grouping?: Maybe<Scalars['String']>;
};

export type ImageAvatarInput = {
  userId: Scalars['ID'];
  file: Scalars['Upload'];
};

export type EditableUserInfo = {
  userId: Scalars['ID'];
  fields: EditableUserInfoFields;
};

export type EditableUserInfoFields = {
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type CreateUserInput = {
  email: Scalars['String'];
  role: UserRole;
};

export type Fed_UpdateOfferRowRequest = {
  listingId: Scalars['ID'];
  offerId: Scalars['ID'];
  searchKey: Scalars['String'];
  update?: Maybe<Fed_RowUpdate>;
  packageId?: Maybe<Scalars['ID']>;
  isCasepack: Scalars['Boolean'];
};

export type Fed_RowUpdate = {
  type: Fed_UpdateRowType;
  value: Scalars['Float'];
};

export enum Fed_UpdateRowType {
  SingleRowUpdateTypeInvalid = 'SINGLE_ROW_UPDATE_TYPE_INVALID',
  SingleRowUpdateTypeMargin = 'SINGLE_ROW_UPDATE_TYPE_MARGIN',
  SingleRowUpdateTypeUnitPrice = 'SINGLE_ROW_UPDATE_TYPE_UNIT_PRICE',
  SingleRowUpdateTypeTotalPrice = 'SINGLE_ROW_UPDATE_TYPE_TOTAL_PRICE',
  SingleRowUpdateTypeBuyerRetailPrice = 'SINGLE_ROW_UPDATE_TYPE_BUYER_RETAIL_PRICE',
  SingleRowUpdateTypePercentageOffWhl = 'SINGLE_ROW_UPDATE_TYPE_PERCENTAGE_OFF_WHL',
  SingleRowUpdateTypePercentageOffMsrp = 'SINGLE_ROW_UPDATE_TYPE_PERCENTAGE_OFF_MSRP',
  SingleRowUpdateTypeQuantity = 'SINGLE_ROW_UPDATE_TYPE_QUANTITY',
  SingleRowUpdateTypeSizeQuantity = 'SINGLE_ROW_UPDATE_TYPE_SIZE_QUANTITY',
  SingleRowUpdateTypePrice = 'SINGLE_ROW_UPDATE_TYPE_PRICE',
}

export type Fed_Update = {
  type: Fed_UpdateType;
  value: Scalars['Float'];
};

export enum Fed_UpdateType {
  UpdateTypeInvalid = 'UPDATE_TYPE_INVALID',
  UpdateTypeLooseItemUnitPrice = 'UPDATE_TYPE_LOOSE_ITEM_UNIT_PRICE',
  UpdateTypeLooseItemTotalPrice = 'UPDATE_TYPE_LOOSE_ITEM_TOTAL_PRICE',
  UpdateTypeLooseItemPctOffWhl = 'UPDATE_TYPE_LOOSE_ITEM_PCT_OFF_WHL',
  UpdateTypeLooseItemPctOffMsrp = 'UPDATE_TYPE_LOOSE_ITEM_PCT_OFF_MSRP',
  UpdateTypeLooseItemMargin = 'UPDATE_TYPE_LOOSE_ITEM_MARGIN',
  UpdateTypeCspkUnitPrice = 'UPDATE_TYPE_CSPK_UNIT_PRICE',
  UpdateTypeCspkTotalPrice = 'UPDATE_TYPE_CSPK_TOTAL_PRICE',
  UpdateTypeCspkPrice = 'UPDATE_TYPE_CSPK_PRICE',
  UpdateTypeCspkPctOffWhl = 'UPDATE_TYPE_CSPK_PCT_OFF_WHL',
  UpdateTypeCspkPctOffMsrp = 'UPDATE_TYPE_CSPK_PCT_OFF_MSRP',
  UpdateTypeLooseItemQuantity = 'UPDATE_TYPE_LOOSE_ITEM_QUANTITY',
  UpdateTypeLooseItemSizeQuantity = 'UPDATE_TYPE_LOOSE_ITEM_SIZE_QUANTITY',
  UpdateTypeCspkQuantity = 'UPDATE_TYPE_CSPK_QUANTITY',
  UpdateTypeCspkMargin = 'UPDATE_TYPE_CSPK_MARGIN',
}

export type Fed_SubmitOfferContext = {
  type?: Maybe<Scalars['String']>;
  listingId?: Maybe<Scalars['ID']>;
  action?: Maybe<Scalars['String']>;
};

export type ClearDraftInput = {
  companyId?: Maybe<Scalars['ID']>;
  userId?: Maybe<Scalars['ID']>;
  offerId: Scalars['ID'];
  listingId: Scalars['ID'];
  uploadChannelId: Scalars['ID'];
  context?: Maybe<ClearDraftContextInput>;
};

export type ClearDraftContextInput = {
  action?: Maybe<Scalars['String']>;
  listingId?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
};

export type Fed_WithdrawOfferRequest = {
  creatorCompanyId: Scalars['ID'];
  listingId: Scalars['ID'];
  uploadChannelId: Scalars['ID'];
  correlationId?: Maybe<Scalars['String']>;
  offerId: Scalars['ID'];
  clientContext: Scalars['AnyObject'];
  // commented out for EN-7401 will revive
  // includeDeletedUsers?: Maybe<Scalars['Boolean']>;
};

export type Fed_ArchiveOfferRequest = {
  listingId: Scalars['ID'];
  offerId: Scalars['ID'];
  clientContext: Scalars['AnyObject'];
};

export type UpdateNotesInput = {
  listingId: Scalars['ID'];
  offerId: Scalars['ID'];
  offerItemType: OfferItemType;
  notes: Scalars['String'];
  packageIdsList: Array<Maybe<Scalars['String']>>;
  clientContext?: Maybe<Scalars['AnyObject']>;
  creatorCompanyId: Scalars['String'];
};

export enum OfferItemType {
  LooseItem = 'LOOSE_ITEM',
  CspkSingleItem = 'CSPK_SINGLE_ITEM',
  CspkMultiItem = 'CSPK_MULTI_ITEM',
}

export type CasepackItem = InventorySingleItem & {
  __typename?: 'CasepackItem';
  attributes: Scalars['AnyObject'];
  casepackId: Scalars['ID'];
  catalogId: Scalars['ID'];
  colorCode: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  images: InventoryItemImages;
  sku: Scalars['String'];
  status: Scalars['String'];
  style: Scalars['String'];
  title: Scalars['String'];
  totalUnits: Scalars['Int'];
  units: Scalars['Int'];
  sizes: InventorySizes;
};

export type Fed_CategorySize = {
  __typename?: 'FED_CategorySize';
  name: Scalars['String'];
  draftTotalUnits?: Maybe<Scalars['Float']>;
};

export type Fed_CategorySizes = {
  __typename?: 'FED_CategorySizes';
  nodes: Array<Fed_CategorySize>;
};

export enum Fed_ListingOfferStatus {
  Accepted = 'ACCEPTED',
  Closed = 'CLOSED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Countered = 'COUNTERED',
  Processing = 'PROCESSING',
  Expired = 'EXPIRED',
}

export enum Fed_ListingsField {
  CreatedAt = 'CREATED_AT',
  Version = 'VERSION',
  Name = 'NAME',
}

export enum Fed_OfferField {
  CreatedAt = 'CREATED_AT',
  Version = 'VERSION',
  Name = 'NAME',
}

export type Fed_OfferRowCategories = {
  __typename?: 'FED_OfferRowCategories';
  nodes: Array<Fed_OfferRowCategory>;
};

export type Fed_OfferRowCategory = {
  __typename?: 'FED_OfferRowCategory';
  name: Scalars['String'];
  totals: Fed_OfferRowCategoryTotals;
  sizes?: Maybe<Fed_CategorySizes>;
};

export type Fed_OfferRowCategoryTotals = {
  __typename?: 'FED_OfferRowCategoryTotals';
  draftTotalPrice?: Maybe<Scalars['Float']>;
  draftTotalUnits?: Maybe<Scalars['Float']>;
  totalMargin?: Maybe<Scalars['Float']>;
  totalMsrpOff?: Maybe<Scalars['Float']>;
  totalWhlOff?: Maybe<Scalars['Float']>;
  uniqueProducts: Scalars['Float'];
};

export type Fed_OfferRowsCategoryBreakdown = {
  __typename?: 'FED_OfferRowsCategoryBreakdown';
  name: Scalars['String'];
  sizes?: Maybe<Fed_OfferRowsCategoryBreakdownSizes>;
};

export type Fed_OfferRowsCategoryBreakdownSizes = {
  __typename?: 'FED_OfferRowsCategoryBreakdownSizes';
  nodes: Array<Maybe<Fed_OfferRowsCategoryBreakdownSize>>;
};

export type Fed_OfferRowsCategoryBreakdownSize = {
  __typename?: 'FED_OfferRowsCategoryBreakdownSize';
  name: Scalars['String'];
};

export type Fed_OfferRowsCategoryBreakdowns = {
  __typename?: 'FED_OfferRowsCategoryBreakdowns';
  nodes: Array<Fed_OfferRowsCategoryBreakdown>;
};

export type Fed_OfferRowsRollups = {
  __typename?: 'FED_OfferRowsRollups';
  nodes: Array<Fed_OfferRowsRollupsNode>;
};

export type Fed_OfferRowsRollupsNode = {
  __typename?: 'FED_OfferRowsRollupsNode';
  label: Scalars['String'];
  missing: Scalars['Boolean'];
  ranges: Fed_OfferRowsRollupsNodeRanges;
};

export type Fed_OfferRowsRollupsNodeRanges = {
  __typename?: 'FED_OfferRowsRollupsNodeRanges';
  nodes: Array<Fed_OfferRowsRollupsNodeRangesNode>;
};

export type Fed_OfferRowsRollupsNodeRangesNode = {
  __typename?: 'FED_OfferRowsRollupsNodeRangesNode';
  label: Scalars['String'];
  value: Scalars['Float'];
};

export type Fed_OfferRowsTotals = {
  __typename?: 'FED_OfferRowsTotals';
  avgCost?: Maybe<Scalars['Float']>;
  avgMargin?: Maybe<Scalars['Float']>;
  avgMarkup?: Maybe<Scalars['Float']>;
  avgMsrp?: Maybe<Scalars['Float']>;
  avgMsrpOff?: Maybe<Scalars['Float']>;
  avgRetail?: Maybe<Scalars['Float']>;
  avgUnitPrice?: Maybe<Scalars['Float']>;
  avgWhl?: Maybe<Scalars['Float']>;
  avgWhlOff?: Maybe<Scalars['Float']>;
  currentTotalPrice?: Maybe<Scalars['Float']>;
  currentTotalUnits: Scalars['Float'];
  draftTotalPrice?: Maybe<Scalars['Float']>;
  draftTotalUnits: Scalars['Float'];
  initialTotalUnits: Scalars['Float'];
  totalCost?: Maybe<Scalars['Float']>;
  totalMargin?: Maybe<Scalars['Float']>;
  totalMsrp?: Maybe<Scalars['Float']>;
  totalMsrpOff?: Maybe<Scalars['Float']>;
  totalProfit?: Maybe<Scalars['Float']>;
  totalRetail?: Maybe<Scalars['Float']>;
  totalUnpriced?: Maybe<Scalars['Int']>;
  totalWhl?: Maybe<Scalars['Float']>;
  totalWhlOff?: Maybe<Scalars['Float']>;
  uniqueProducts: Scalars['Int'];
  withoutImages: Scalars['Int'];
};

export type Fed_OfferRowTotals = {
  __typename?: 'FED_OfferRowTotals';
  avgMargin?: Maybe<Scalars['Float']>;
  avgMsrpOff?: Maybe<Scalars['Float']>;
  avgWhlOff?: Maybe<Scalars['Float']>;
  totalMsrp?: Maybe<Scalars['Float']>;
  totalPrice?: Maybe<Scalars['Float']>;
  totalProfit?: Maybe<Scalars['Float']>;
  totalUnits?: Maybe<Scalars['Int']>;
  totalWhl?: Maybe<Scalars['Float']>;
  uniqueProducts?: Maybe<Scalars['Int']>;
};

export type Images = {
  __typename?: 'Images';
  nodes?: Maybe<Array<Maybe<ImageSettings>>>;
};

export type OfferRowsCategoryBreakdown = {
  __typename?: 'OfferRowsCategoryBreakdown';
  name: Scalars['String'];
  sizes?: Maybe<OfferRowsCategoryBreakdownSizes>;
};

export type OfferRowsCategoryBreakdownSizes = {
  __typename?: 'OfferRowsCategoryBreakdownSizes';
  nodes: Array<Maybe<OfferRowsCategoryBreakdownSize>>;
};

export type OfferRowsCategoryBreakdownSize = {
  __typename?: 'OfferRowsCategoryBreakdownSize';
  name: Scalars['String'];
};

export type OfferRowsCategoryBreakdowns = {
  __typename?: 'OfferRowsCategoryBreakdowns';
  nodes: Array<OfferRowsCategoryBreakdown>;
};

export type OfferRowTotals = {
  __typename?: 'OfferRowTotals';
  avgMargin?: Maybe<Scalars['Float']>;
  avgMsrpOff?: Maybe<Scalars['Float']>;
  avgWhlOff?: Maybe<Scalars['Float']>;
  totalMsrp?: Maybe<Scalars['Float']>;
  totalPrice?: Maybe<Scalars['Float']>;
  totalProfit?: Maybe<Scalars['Float']>;
  totalUnits?: Maybe<Scalars['Int']>;
  totalWhl?: Maybe<Scalars['Float']>;
  uniqueProducts?: Maybe<Scalars['Int']>;
};

export type SearchServiceMoveProducts = {
  __typename?: 'SearchServiceMoveProducts';
  meta: SearchServiceMoveProductsMeta;
};

export type SearchServiceMoveProductsMeta = {
  __typename?: 'SearchServiceMoveProductsMeta';
  key: Scalars['String'];
};

export type ChannelsContextChannelsQueryVariables = {};

export type ChannelsContextChannelsQuery = { __typename?: 'Query' } & {
  FED_groups: { __typename?: 'FED_GroupsConnection' } & {
    nodes: Array<{ __typename?: 'FED_Group' } & Pick<Fed_Group, 'id' | 'name'>>;
  };
};

export type ChannelsContextMarketsQueryVariables = {
  groupId?: Maybe<Scalars['String']>;
};

export type ChannelsContextMarketsQuery = { __typename?: 'Query' } & {
  productServiceMarkets: { __typename?: 'ChannelMarkets' } & {
    nodes: Array<
      { __typename?: 'ChannelMarket' } & Pick<ChannelMarket, 'id' | 'name'> & {
          currency: { __typename?: 'ChannelMarketCurrency' } & Pick<
            ChannelMarketCurrency,
            'id' | 'code' | 'name' | 'symbol'
          >;
        }
    >;
  };
};

export type ChannelsContextAvailableMarketsQueryVariables = {
  companyUUID: Scalars['String'];
  groupUUID: Scalars['String'];
  userUUID: Scalars['String'];
};


export type ChannelsContextAvailableMarketsQuery = {
  getUploadChannelDetailsByGroupId: {
    markets: Market[];
    aaDefaultValues: Scalars['String'][]; 
  };
};

export type GlobalNavigationNotificationUpdateMutationVariables = {
  id: Scalars['ID'];
  input?: Maybe<ActivityInput>;
};

export type GlobalNavigationNotificationUpdateAllMutationVariables = {
  input: Maybe<ActivityInput>;
};

export type GlobalNavigationNotificationUpdateMutation = {
  __typename?: 'Mutation';
} & {
  updateNotification?: Maybe<
    | ({ __typename?: 'NotificationSuccess' } & Pick<
        NotificationSuccess,
        'id' | 'isRead' | 'isDismissed'
      >)
    | ({ __typename?: 'NotificationsError' } & Pick<
        NotificationsError,
        'message' | 'kind'| 'status'
      >)
  >;
};

export type GlobalNavigationUpdateProcessMutationVariables = {
  id: Scalars['ID'];
  input?: Maybe<ActivityInput>;
};

export type GlobalNavigationUpdateAllProcessMutationVariables = {
  input?: Maybe<ActivityInput>;
  state?: Maybe<Scalars['String']>;
};

export type GlobalNavigationUpdateProcessMutation = {
  __typename?: 'Mutation';
} & {
  updateProcess?: Maybe<
    | ({ __typename?: 'ProcessSuccess' } & Pick<
        ProcessSuccess,
        'id' | 'isDismissed' | 'isRead' | 'state'
      >)
    | ({ __typename?: 'ProcessesError' } & Pick<
        ProcessesError,
        'message' | 'kind'
      >)
  >;
};

export type SyncChannelListingsQueryVariables = {
  uploadChannelId: Scalars['AnyObject'];
};

export type SyncChannelListingsQuery = { __typename?: 'Query' } & {
  listingsV2: { __typename?: 'ListingsV2' } & {
    nodes: Array<
      { __typename?: 'ListingsV2Listing' } & Pick<
        ListingsV2Listing,
        'listingId'
      >
    >;
  };
};

export type GlobalNavigationSyncChannelDataMutationVariables = {
  actionType: InventorySyncActionType;
  channelId: Scalars['String'];
  groupIds: Array<Scalars['String']>;
  type: InventorySyncType;
};

export type GlobalNavigationSyncChannelDataMutation = {
  __typename?: 'Mutation';
} & { isSuccessful: Mutation['syncInventoryData'] };

export type GlobalNavigation_NotificationsSuccessFragment = {
  __typename?: 'NotificationsSuccess';
} & {
  nodes: Array<
    { __typename?: 'NotificationSuccess' } & Pick<
      NotificationSuccess,
      | 'action'
      | 'avatar'
      | 'createdAt'
      | 'flagColor'
      | 'id'
      | 'isDismissed'
      | 'isRead'
      | 'message'
      | 'type'
      | 'updatedAt'
      | 'userId'
    > & {
        actionData: { __typename?: 'NotificationActionData' } & Pick<
          NotificationActionData,
          'listingId' | 'buyerCompanyId'
        >;
        i18n: { __typename?: 'NotificationI18nParams' } & Pick<
          NotificationI18nParams,
          'lastName' | 'firstName' | 'offerName' | 'companyName'
        >;
      }
  >;
};

export type GlobalNavigation_NotificationsErrorFragment = {
  __typename?: 'NotificationsError';
} & Pick<NotificationsError, 'message' | 'kind' | 'status'>;

export type GlobalNavigation_NotificationsQueryVariables = {};

export type GlobalNavigation_NotificationsQuery = { __typename?: 'Query' } & {
  notifications?: Maybe<
    | ({
        __typename?: 'NotificationsSuccess';
      } & GlobalNavigation_NotificationsSuccessFragment)
    | ({
        __typename?: 'NotificationsError';
      } & GlobalNavigation_NotificationsErrorFragment)
  >;
};

export type GlobalNavigation_ProcessesSuccessFragment = {
  __typename?: 'ProcessesSuccess';
} & {
  nodes: Array<
    { __typename?: 'ProcessSuccess' } & Pick<
      ProcessSuccess,
      | 'actionData'
      | 'context'
      | 'createdAt'
      | 'description'
      | 'event'
      | 'icon'
      | 'id'
      | 'isDismissed'
      | 'isRead'
      | 'title'
      | 'state'
      | 'type'
      | 'updatedAt'
      | 'userId'
    > & {
        stages: Array<
          { __typename?: 'ProcessStage' } & Pick<
            ProcessStage,
            'description' | 'order' | 'status'
          > & {
              details: { __typename?: 'ProcessStageDetails' } & Pick<
                ProcessStageDetails,
                'count' | 'error'
              >;
            }
        >;
      }
  >;
};

export type GlobalNavigation_ProcessesErrorFragment = {
  __typename?: 'ProcessesError';
} & Pick<ProcessesError, 'message' | 'kind'>;

export type GlobalNavigation_ProcessesQueryVariables = {};

export type GlobalNavigation_ProcessesQuery = { __typename?: 'Query' } & {
  processes?: Maybe<
    | ({
        __typename?: 'ProcessesSuccess';
      } & GlobalNavigation_ProcessesSuccessFragment)
    | ({
        __typename?: 'ProcessesError';
      } & GlobalNavigation_ProcessesErrorFragment)
  >;
};

export type MeQueryVariables = {};

export type MeQuery = { __typename?: 'Query' } & {
  me?: Maybe<
    { __typename?: 'Me' } & Pick<
      Me,
      | 'address'
      | 'address2'
      | 'avatarUrl'
      | 'city'
      | 'companyAvatarUrl'
      | 'companyId'
      | 'companyUuid'
      | 'companyName'
      | 'companyRole'
      | 'countryCode'
      | 'department'
      | 'email'
      | 'firstName'
      | 'id'
      | 'isSimpleBuyer'
      | 'hideClarity'
      | 'isSupport'
      | 'jobTitle'
      | 'lastName'
      | 'onboardingCompletedAt'
      | 'phoneNumber'
      | 'status'
      | 'userRole'
      | 'uuid'
      | 'zip'
    > & {
        categories?: Maybe<
          { __typename?: 'ProductCategories' } & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'ProductCategory' } & Pick<
                    ProductCategory,
                    'id' | 'name' | 'checked' | 'grouping'
                  >
                >
              >
            >;
          }
        >;
        permissions?: Maybe<
          { __typename?: 'Permissions' } & Pick<
            Permissions,
            'editCompanyProfile' | 'hasInventory' | 'hasCasepacks'
          >
        >;
      }
  >;
  metaData: { __typename?: 'MetaData' } & Pick<MetaData, 'actionNames'> & {
      actions: { __typename?: 'MetaDataActions' } & Pick<
        MetaDataActions,
        | 'allocation'
        | 'availableToSell'
        | 'createOffer'
        | 'dashboard'
        | 'discovery'
        | 'editCompanyProfile'
        | 'filterRedundantGroups'
        | 'hasAccountResync'
        | 'horizontalSizing'
        | 'inventoryDynamicFilters'
        | 'inventoryLinesheet'
        | 'manageInventory'
        | 'manageListings'
        | 'manageUsers'
        | 'negotiationPoExport'
        | 'noMarketFilterInDashboard'
        | 'reportingLink'
        | 'servicesV2'
        | 'showCases'
        | 'variantPriceAveraging'
        | 'zendesk'
        | 'hideClone'
        | 'temporalWorkflowSubmitOffer'
        | 'withdrawOffer'
        | 'partialReplaceAttribute'
        | 'enableAdvancedAnalytics'
        | 'counterOfferUploadRevamp'
        | 'downloadOfferRevamp'
      >;
      countryCodes?: Maybe<
        { __typename?: 'CountryCodes' } & {
          nodes?: Maybe<
            Array<
              Maybe<{ __typename?: 'CountryCode' } & Pick<CountryCode, 'value'>>
            >
          >;
        }
      >;
    };
};

export type DownloadOptionsModalDownloadExcelMutationVariables = {
  offerId: Scalars['String'];
  params: DownloadOfferParams;
};

export type DownloadOptionsModalDownloadExcelMutation = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'listingOffersV2DownloadExcel'>;

export type DownloadOptionsModalDownloadExcelMutationV2 = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'downloadOfferV2'>;

export type DownloadOptionsModalExportPoMutationVariables = {
  offerId: Scalars['String'];
};

export type DownloadOptionsModalExportPoMutation = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'listingOffersV2ExportPo'>;

export type CustomPurchaseOrderDetailsSuccessFragment = {
  __typename?: 'CustomPurchaseOrderDetails';
} & Pick<CustomPurchaseOrderDetails, 'title' | 'additionalProperties'> & {
    properties: { __typename?: 'CustomPurchaseOrderProperties' } & {
      nodes: Array<
        { __typename?: 'CustomPurchaseOrderProperty' } & Pick<
          CustomPurchaseOrderProperty,
          'key' | 'type' | 'title' | 'placeholder' | 'options'
        >
      >;
    };
  };

export type CustomPurchaseOrderDetailsErrorFragment = {
  __typename?: 'GenericError';
} & Pick<GenericError, 'message' | 'kind'>;

export type CustomPurchaseOrderDetailsQueryVariables = {
  listingUuid: Scalars['String'];
};

type CustomPurchaseOrderResult =
  | ({
      __typename?: 'CustomPurchaseOrderDetails';
    } & CustomPurchaseOrderDetailsSuccessFragment)
  | ({
      __typename?: 'GenericError';
    } & CustomPurchaseOrderDetailsErrorFragment);

export type CustomPurchaseOrderDetailsQuery = { __typename?: 'Query' } & {
  customPurchaseOrderDetails: CustomPurchaseOrderResult;
  exportPoInfoV2: CustomPurchaseOrderResult;
};

export type DownloadCustomPurchaseOrderSuccessFragment = {
  __typename?: 'BooleanResult';
} & Pick<BooleanResult, 'ok'>;

export type DownloadCustomPurchaseOrderErrorFragment = {
  __typename?: 'GenericError';
} & Pick<GenericError, 'message' | 'kind'>;

export type DownloadCustomPurchaseOrderQueryVariables = {
  listingUuid: Scalars['String'];
  payload?: Maybe<Scalars['AnyObject']>;
};

export type DownloadCustomPurchaseOrderQuery = { __typename?: 'Query' } & {
  downloadCustomPurchaseOrder:
    | ({
        __typename?: 'BooleanResult';
      } & DownloadCustomPurchaseOrderSuccessFragment)
    | ({
        __typename?: 'GenericError';
      } & DownloadCustomPurchaseOrderErrorFragment);
};

export type LinesheetSidebarListingsQueryVariables = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  states?: Maybe<Array<Maybe<Fed_ListingState>>>;
  parentGroupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  includeDeletedUsers?: Maybe<Scalars['Boolean']>;
};

export type LinesheetSidebarListingsQuery = { __typename?: 'Query' } & {
  FED_listings: { __typename?: 'FED_ListingsConnection' } & {
    nodes: Array<
      { __typename?: 'FED_Listing' } & Pick<
        Fed_Listing,
        'id' | 'title' | 'state'
      > & {
          market?: Maybe<
            { __typename?: 'FED_Market' } & Pick<Fed_Market, 'id'>
          >;
          buyerCompanies?: Maybe<
            Array<
              Maybe<
                { __typename?: 'FED_Company' } & Pick<
                  Fed_Company,
                  'id' | 'name' | 'avatarUrl'
                >
              >
            >
          >;
          creator?: Maybe<
            { __typename?: 'FED_User' } & Pick<Fed_User, 'id'> & {
                company?: Maybe<
                  { __typename?: 'FED_Company' } & Pick<
                    Fed_Company,
                    'id' | 'name' | 'avatarUrl'
                  >
                >;
              }
          >;
        }
    >;
    pagination: { __typename?: 'FED_ListingsPagination' } & Pick<
      Fed_ListingsPagination,
      'count' | 'total' | 'limit'
    >;
  };
};

export type Fed_NegotiationSearchServiceFiltersContextFiltersQueryVariables = {
  buyerCompanyUUID?: Maybe<Scalars['String']>;
  filterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
  listingCreatorCompanyUUID: Scalars['String'];
  listingUUID: Scalars['String'];
};

export type Fed_NegotiationSearchServiceFiltersContextFiltersQuery = {
  __typename?: 'Query';
} & {
  entities: { __typename?: 'FED_OfferRollups' } & {
    sizesByCategory: Array<
      { __typename?: 'FED_OfferRollupsSizeByCategory' } & Pick<
        Fed_OfferRollupsSizeByCategory,
        'name'
      > & {
          sizes: Array<
            { __typename?: 'FED_OfferRollupsSize' } & Pick<
              Fed_OfferRollupsSize,
              'name'
            >
          >;
        }
    >;
    totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
      Fed_OfferRollupsTotalRollup,
      'totalElements'
    >;
    filters: { __typename?: 'FED_OfferRowsFilters' } & {
      nodes: Array<
        { __typename?: 'FED_OfferRowsFiltersNode' } & Pick<
          Fed_OfferRowsFiltersNode,
          'count' | 'label' | 'inturnType'
        > & {
            options: { __typename?: 'FED_OfferRowsFiltersNodeOptions' } & Pick<
              Fed_OfferRowsFiltersNodeOptions,
              'nodes'
            >;
          }
      >;
    };
    labelRollups: Array<
      { __typename?: 'FED_LabelRollups' } & Pick<
        Fed_LabelRollups,
        'label' | 'missing'
      > & {
          ranges: Array<
            { __typename?: 'FED_LabelRollupsNodeRanges' } & Pick<
              Fed_LabelRollupsNodeRanges,
              'label' | 'value'
            >
          >;
        }
    >;
  };
};

export type OnboardingSetPasswordMutationVariables = {
  input?: Maybe<SetPasswordInput>;
};

export type OnboardingSetPasswordMutation = { __typename?: 'Mutation' } & {
  setPassword?: Maybe<
    { __typename?: 'BooleanResult' } & Pick<BooleanResult, 'ok'>
  >;
};

export type OnboardingUserTokenQueryVariables = {
  username: Scalars['ID'];
  password: Scalars['String'];
};

export type OnboardingUserTokenQuery = { __typename?: 'Query' } & {
  userToken?: Maybe<
    | ({ __typename?: 'Token' } & Pick<
        Token,
        'accessToken' | 'expiresIn' | 'tokenType'
      >)
    | ({ __typename?: 'GenericError' } & Pick<GenericError, 'message' | 'kind'>)
  >;
};

export type UploadInventorySyncImagesMutationMutationVariables = {
  channelId: Scalars['String'];
};

export type UploadInventorySyncImagesMutationMutation = {
  __typename?: 'Mutation';
} & {
  syncInventoryImagesV2?: Maybe<
    { __typename?: 'InventoryUpload' } & Pick<InventoryUpload, 'id'>
  >;
};

export type UploadInventoryModalUploadFileMutationVariables = {
  channelId: Scalars['String'];
  file: Scalars['Upload'];
  config: InventoryUploadConfig;
};

export type UploadInventoryModalUploadFileMutation = {
  __typename?: 'Mutation';
} & {
  uploadInventoryV2?: Maybe<
    { __typename?: 'InventoryUpload' } & Pick<InventoryUpload, 'id'>
  >;
};

export type AuthForgotPasswordSuccessFragment = {
  __typename?: 'BooleanResult';
} & Pick<BooleanResult, 'ok'>;

export type AuthForgotPasswordErrorFragment = {
  __typename?: 'GenericError';
} & Pick<GenericError, 'message' | 'kind'>;

export type AuthForgotPasswordMutationVariables = {
  email?: Maybe<Scalars['String']>;
  recaptcha?: Maybe<Scalars['String']>;
};

export type AuthForgotPasswordMutation = { __typename?: 'Mutation' } & {
  forgotPassword?: Maybe<
    | ({ __typename?: 'BooleanResult' } & AuthForgotPasswordSuccessFragment)
    | ({ __typename?: 'GenericError' } & AuthForgotPasswordErrorFragment)
  >;
};

export type ZendeskTokenSuccessFragment = { __typename?: 'Token' } & Pick<
  Token,
  'accessToken'
>;

export type ZendeskTokenErrorFragment = { __typename?: 'GenericError' } & Pick<
  GenericError,
  'message' | 'kind'
>;

export type ZendeskTokenQueryVariables = {};

export type ZendeskTokenQuery = { __typename?: 'Query' } & {
  zendeskToken?: Maybe<
    | ({ __typename?: 'Token' } & ZendeskTokenSuccessFragment)
    | ({ __typename?: 'GenericError' } & ZendeskTokenErrorFragment)
  >;
};

export type LoginSignupUserTokenQueryVariables = {
  username: Scalars['ID'];
  password: Scalars['String'];
};

export type LoginSignupUserTokenQuery = { __typename?: 'Query' } & {
  userToken?: Maybe<
    | ({ __typename?: 'Token' } & Pick<
        Token,
        'accessToken' | 'expiresIn' | 'tokenType'
      >)
    | ({ __typename?: 'GenericError' } & Pick<GenericError, 'message' | 'kind'>)
  >;
};

export type AuthResetPasswordSuccessFragment = { __typename?: 'Token' } & Pick<
  Token,
  'accessToken' | 'expiresIn' | 'tokenType'
>;

export type AuthResetPasswordErrorFragment = {
  __typename?: 'GenericError';
} & Pick<GenericError, 'message' | 'kind'>;

export type AuthResetPasswordMutationVariables = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  token: Scalars['String'];
};

export type AuthResetPasswordMutation = { __typename?: 'Mutation' } & {
  resetPassword?: Maybe<
    | ({ __typename?: 'Token' } & AuthResetPasswordSuccessFragment)
    | ({ __typename?: 'GenericError' } & AuthResetPasswordErrorFragment)
  >;
};

export type CompanyProfileEditQueryQueryVariables = {
  companyId: Scalars['ID'];
};

export type CompanyProfileEditQueryQuery = { __typename?: 'Query' } & {
  company?: Maybe<
    { __typename?: 'Company' } & Pick<
      Company,
      'id' | 'uuid' | 'role' | 'name'
    > &
      CompanyLogoEditContainer_LogoFragment &
      CompanyInfoEditContainer_CompanyFragment &
      CompanyImagesEditContainer_ImagesFragment &
      CompanyLookbooksEditContainer_LookbooksFragment &
      CompanyBrandEditContainer_BrandsFragment
  >;
  metaData: { __typename?: 'MetaData' } & AddressCodesFragment;
};

export type CompanyBrandEditContainer_BrandsFragment = {
  __typename?: 'Company';
} & {
  brands?: Maybe<
    { __typename?: 'Brands' } & {
      nodes?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Brand' } & Pick<Brand, 'id' | 'name'> & {
                logo?: Maybe<
                  { __typename?: 'DocumentImage' } & Pick<
                    DocumentImage,
                    'id' | 'src'
                  >
                >;
              }
          >
        >
      >;
    }
  >;
};

export type CompanyAddBrandMutationMutationVariables = {
  input: AddCompanyBrandInput;
};

export type CompanyAddBrandMutationMutation = { __typename?: 'Mutation' } & {
  addCompanyBrand: { __typename?: 'Brand' } & Pick<Brand, 'id' | 'name'> & {
      logo?: Maybe<
        { __typename?: 'DocumentImage' } & Pick<DocumentImage, 'id' | 'src'>
      >;
    };
};

export type CompanyDeleteBrandMutationMutationVariables = {
  brandId: Scalars['ID'];
  companyId: Scalars['ID'];
};

export type CompanyDeleteBrandMutationMutation = { __typename?: 'Mutation' } & {
  deleteCompanyBrand: { __typename?: 'BooleanResult' } & Pick<
    BooleanResult,
    'ok'
  >;
};

export type CompanyUpdateBrandMutationMutationVariables = {
  input: UpdateCompanyBrandInput;
};

export type CompanyUpdateBrandMutationMutation = { __typename?: 'Mutation' } & {
  updateCompanyBrand: { __typename?: 'Brand' } & Pick<Brand, 'id' | 'name'> & {
      logo?: Maybe<
        { __typename?: 'DocumentImage' } & Pick<DocumentImage, 'id' | 'src'>
      >;
    };
};

export type AddDocumentMutationMutationVariables = {
  input: DocumentInput;
};

export type AddDocumentMutationMutation = { __typename?: 'Mutation' } & {
  addDocumentImage: { __typename?: 'DocumentImage' } & Pick<
    DocumentImage,
    'id' | 'name' | 'src'
  >;
};

export type CompanyImagesEditContainer_ImagesFragment = {
  __typename?: 'Company';
} & {
  images?: Maybe<
    { __typename?: 'CompanyGalleryImages' } & {
      nodes?: Maybe<
        Array<
          Maybe<
            { __typename?: 'CompanyGalleryImage' } & Pick<
              CompanyGalleryImage,
              'id' | 'src'
            >
          >
        >
      >;
    }
  >;
};

export type CompanyUpdateImageMutationMutationVariables = {
  input: UpdateCompanyGalleryImageInput;
};

export type CompanyUpdateImageMutationMutation = { __typename?: 'Mutation' } & {
  updateCompanyGalleryImage: { __typename?: 'CompanyGalleryImage' } & Pick<
    CompanyGalleryImage,
    'id' | 'src'
  >;
};

export type CompanyCreateImageMutationMutationVariables = {
  input: AddCompanyGalleryImageInput;
};

export type CompanyCreateImageMutationMutation = { __typename?: 'Mutation' } & {
  addCompanyGalleryImage: { __typename?: 'CompanyGalleryImage' } & Pick<
    CompanyGalleryImage,
    'id' | 'src'
  >;
};

export type CompanyDeleteImageMutationMutationVariables = {
  input: DeleteCompanyGalleryImageInput;
};

export type CompanyDeleteImageMutationMutation = { __typename?: 'Mutation' } & {
  deleteCompanyGalleryImage: { __typename?: 'BooleanResult' } & Pick<
    BooleanResult,
    'ok'
  >;
};

export type CompanyInfoEditContainer_CompanyFragment = {
  __typename?: 'Company';
} & Pick<Company, 'phoneNumber' | 'description'> & {
    address?: Maybe<
      { __typename?: 'Address' } & Pick<
        Address,
        'address' | 'address2' | 'city' | 'state' | 'countryCode' | 'zip'
      >
    >;
    socialLinks?: Maybe<
      { __typename?: 'SocialLinks' } & Pick<
        SocialLinks,
        | 'websiteUrl'
        | 'instagram'
        | 'facebook'
        | 'twitter'
        | 'pinterest'
        | 'linkedin'
      >
    >;
  };

export type AddressCodesFragment = { __typename?: 'MetaData' } & {
  countryCodes?: Maybe<
    { __typename?: 'CountryCodes' } & {
      nodes?: Maybe<
        Array<
          Maybe<{ __typename?: 'CountryCode' } & Pick<CountryCode, 'value'>>
        >
      >;
    }
  >;
  stateCodes?: Maybe<
    { __typename?: 'StateCodes' } & {
      nodes?: Maybe<
        Array<Maybe<{ __typename?: 'StateCode' } & Pick<StateCode, 'value'>>>
      >;
    }
  >;
};

export type CompanyInfoMutationMutationVariables = {
  id: Scalars['ID'];
  input: CompanyInfoInput;
};

export type CompanyInfoMutationMutation = { __typename?: 'Mutation' } & {
  updateCompanyInfo: { __typename?: 'Company' } & Pick<
    Company,
    'id' | 'phoneNumber' | 'description'
  > & {
      address?: Maybe<
        { __typename?: 'Address' } & Pick<
          Address,
          'address' | 'address2' | 'city' | 'state' | 'countryCode' | 'zip'
        >
      >;
      socialLinks?: Maybe<
        { __typename?: 'SocialLinks' } & Pick<
          SocialLinks,
          | 'websiteUrl'
          | 'instagram'
          | 'facebook'
          | 'twitter'
          | 'pinterest'
          | 'linkedin'
        >
      >;
    };
};

export type CompanyLogoEditContainer_LogoFragment = {
  __typename?: 'Company';
} & { logo?: Maybe<{ __typename?: 'File' } & Pick<File, 'src'>> };

export type CompanyLogoMutationMutationVariables = {
  id: Scalars['ID'];
  file: Scalars['Upload'];
};

export type CompanyLogoMutationMutation = { __typename?: 'Mutation' } & {
  updateCompanyLogo: { __typename: 'Company' } & Pick<Company, 'id'> & {
      logo?: Maybe<{ __typename?: 'File' } & Pick<File, 'src'>>;
    };
};

export type CompanyLookbooksEditContainer_LookbooksFragment = {
  __typename?: 'Company';
} & {
  lookbooks?: Maybe<
    { __typename?: 'Lookbooks' } & {
      nodes?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Lookbook' } & Pick<Lookbook, 'id' | 'name'> & {
                file: { __typename?: 'DocumentFile' } & Pick<
                  DocumentFile,
                  'id' | 'src'
                >;
              }
          >
        >
      >;
    }
  >;
};

export type CompanyAddLookbookMutationMutationVariables = {
  input: AddCompanyLookbookInput;
};

export type CompanyAddLookbookMutationMutation = { __typename?: 'Mutation' } & {
  addCompanyLookbook: { __typename?: 'Lookbook' } & Pick<
    Lookbook,
    'id' | 'name'
  > & {
      file: { __typename?: 'DocumentFile' } & Pick<DocumentFile, 'id' | 'src'>;
    };
};

export type CompanyUpdateLookbookMutationMutationVariables = {
  input: UpdateCompanyLookbookInput;
};

export type CompanyUpdateLookbookMutationMutation = {
  __typename?: 'Mutation';
} & {
  updateCompanyLookbook: { __typename?: 'Lookbook' } & Pick<
    Lookbook,
    'id' | 'name'
  > & {
      file: { __typename?: 'DocumentFile' } & Pick<DocumentFile, 'id' | 'src'>;
    };
};

export type CompanyDeleteLookbookMutationMutationVariables = {
  companyId: Scalars['ID'];
  lookbookId: Scalars['ID'];
};

export type CompanyDeleteLookbookMutationMutation = {
  __typename?: 'Mutation';
} & {
  deleteCompanyLookbook: { __typename?: 'BooleanResult' } & Pick<
    BooleanResult,
    'ok'
  >;
};

export type CompanyProfileQueryVariables = {
  companyId: Scalars['ID'];
};

export type CompanyProfileQuery = { __typename?: 'Query' } & {
  company?: Maybe<
    { __typename?: 'Company' } & Pick<
      Company,
      'id' | 'name' | 'role' | 'description' | 'phoneNumber'
    > & {
        images?: Maybe<
          { __typename?: 'CompanyGalleryImages' } & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'CompanyGalleryImage' } & Pick<
                    CompanyGalleryImage,
                    'src' | 'id'
                  >
                >
              >
            >;
          }
        >;
        socialLinks?: Maybe<
          { __typename?: 'SocialLinks' } & Pick<
            SocialLinks,
            | 'websiteUrl'
            | 'instagram'
            | 'facebook'
            | 'twitter'
            | 'pinterest'
            | 'linkedin'
          >
        >;
        address?: Maybe<
          { __typename?: 'Address' } & Pick<
            Address,
            'address' | 'address2' | 'city' | 'state' | 'countryCode' | 'zip'
          >
        >;
        logo?: Maybe<{ __typename?: 'File' } & Pick<File, 'src'>>;
        brands?: Maybe<
          { __typename?: 'Brands' } & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Brand' } & Pick<Brand, 'id' | 'name'> & {
                      logo?: Maybe<
                        { __typename?: 'DocumentImage' } & Pick<
                          DocumentImage,
                          'id' | 'src'
                        >
                      >;
                    }
                >
              >
            >;
          }
        >;
        categories?: Maybe<
          { __typename?: 'Categories' } & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Category' } & Pick<
                    Category,
                    'name' | 'grouping' | 'id'
                  >
                >
              >
            >;
          }
        >;
        lookbooks?: Maybe<
          { __typename?: 'Lookbooks' } & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Lookbook' } & Pick<
                    Lookbook,
                    'id' | 'name'
                  > & {
                      file: { __typename?: 'DocumentFile' } & Pick<
                        DocumentFile,
                        'id' | 'src'
                      >;
                    }
                >
              >
            >;
          }
        >;
      }
  >;
};

export type UpdateDocumentFileSignedSrcMutationVariables = {
  id: Scalars['ID'];
};

export type UpdateDocumentFileSignedSrcMutation = {
  __typename?: 'Mutation';
} & {
  updateDocumentFileSignedSrc: { __typename: 'DocumentFile' } & Pick<
    DocumentFile,
    'src' | 'name'
  >;
};

export type DashboardSearchServiceProductMarketRollupFragment = {
  __typename?: 'SearchServiceProductMarketRollup';
} & Pick<SearchServiceProductMarketRollup, 'marketId' | 'marketName'> & {
    options: { __typename?: 'SearchServiceProductMarketRollupOptions' } & {
      nodes: Array<
        { __typename?: 'SearchServiceProductMarketRollupOption' } & Pick<
          SearchServiceProductMarketRollupOption,
          'label' | 'missing'
        > & {
            allocated: {
              __typename?: 'SearchServiceProductMarketRollupOptionRanges';
            } & {
              nodes: Array<
                {
                  __typename?: 'SearchServiceProductMarketRollupOptionRange';
                } & Pick<
                  SearchServiceProductMarketRollupOptionRange,
                  'label' | 'value'
                >
              >;
            };
            ranges: {
              __typename?: 'SearchServiceProductMarketRollupOptionRanges';
            } & {
              nodes: Array<
                {
                  __typename?: 'SearchServiceProductMarketRollupOptionRange';
                } & Pick<
                  SearchServiceProductMarketRollupOptionRange,
                  'label' | 'value'
                >
              >;
            };
            unallocated: {
              __typename?: 'SearchServiceProductMarketRollupOptionRanges';
            } & {
              nodes: Array<
                {
                  __typename?: 'SearchServiceProductMarketRollupOptionRange';
                } & Pick<
                  SearchServiceProductMarketRollupOptionRange,
                  'label' | 'value'
                >
              >;
            };
          }
      >;
    };
  };

export type DashboardInventoryOfferComparisonOfferRollupsQueryVariables = {
  groupUUID: Scalars['ID'];
  productFilterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  packageFilterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
};

export type DashboardInventoryOfferComparisonOfferRollupsQuery = {
  __typename?: 'Query';
} & {
  searchServiceProducts: { __typename?: 'SearchServiceProducts' } & {
    meta: { __typename?: 'SearchServiceProductMeta' } & Pick<
      SearchServiceProductMeta,
      'totalUnits'
    > & {
        totals: { __typename?: 'SearchServiceProductTotals' } & Pick<
          SearchServiceProductTotals,
          'totalQuantity' | 'availableQuantity'
        >;
        pagination: { __typename?: 'SearchServiceProductPagination' } & Pick<
          SearchServiceProductPagination,
          'totalElements'
        >;
        rollups: { __typename?: 'SearchServiceProductRollups' } & {
          nodes: Array<
            { __typename?: 'SearchServiceProductRollup' } & Pick<
              SearchServiceProductRollup,
              'type'
            > & {
                rollupMarkets: {
                  __typename?: 'SearchServiceProductMarketRollups';
                } & {
                  nodes: Array<
                    {
                      __typename?: 'SearchServiceProductMarketRollup';
                    } & DashboardSearchServiceProductMarketRollupFragment
                  >;
                };
              }
          >;
        };
      };
  };
  searchServicePackages: { __typename?: 'SearchServicePackages' } & {
    meta: { __typename?: 'SearchServicePackageMeta' } & Pick<
      SearchServicePackageMeta,
      'totalUnits'
    > & {
        totals: { __typename?: 'SearchServicePackageTotals' } & Pick<
          SearchServicePackageTotals,
          | 'totalQuantity'
          | 'availableQuantity'
          | 'unitsAvailableQuantity'
          | 'unitsTotalQuantity'
        >;
        pagination: { __typename?: 'SearchServicePackagePagination' } & Pick<
          SearchServicePackagePagination,
          'totalElements'
        >;
        rollups: { __typename?: 'SearchServiceProductRollups' } & {
          nodes: Array<
            { __typename?: 'SearchServiceProductRollup' } & Pick<
              SearchServiceProductRollup,
              'type'
            > & {
                rollupMarkets: {
                  __typename?: 'SearchServiceProductMarketRollups';
                } & {
                  nodes: Array<
                    { __typename?: 'SearchServiceProductMarketRollup' } & Pick<
                      SearchServiceProductMarketRollup,
                      'marketId' | 'marketName'
                    > & {
                        options: {
                          __typename?: 'SearchServiceProductMarketRollupOptions';
                        } & {
                          nodes: Array<
                            {
                              __typename?: 'SearchServiceProductMarketRollupOption';
                            } & Pick<
                              SearchServiceProductMarketRollupOption,
                              'label' | 'missing'
                            > & {
                                allocated: {
                                  __typename?: 'SearchServiceProductMarketRollupOptionRanges';
                                } & {
                                  nodes: Array<
                                    {
                                      __typename?: 'SearchServiceProductMarketRollupOptionRange';
                                    } & Pick<
                                      SearchServiceProductMarketRollupOptionRange,
                                      'label' | 'value'
                                    >
                                  >;
                                };
                                ranges: {
                                  __typename?: 'SearchServiceProductMarketRollupOptionRanges';
                                } & {
                                  nodes: Array<
                                    {
                                      __typename?: 'SearchServiceProductMarketRollupOptionRange';
                                    } & Pick<
                                      SearchServiceProductMarketRollupOptionRange,
                                      'label' | 'value'
                                    >
                                  >;
                                };
                                unallocated: {
                                  __typename?: 'SearchServiceProductMarketRollupOptionRanges';
                                } & {
                                  nodes: Array<
                                    {
                                      __typename?: 'SearchServiceProductMarketRollupOptionRange';
                                    } & Pick<
                                      SearchServiceProductMarketRollupOptionRange,
                                      'label' | 'value'
                                    >
                                  >;
                                };
                              }
                          >;
                        };
                      }
                  >;
                };
              }
          >;
        };
      };
  };
};

export type DashboardInventoryRollupQueryVariables = {
  groupUUID: Scalars['ID'];
};

export type DashboardInventoryRollupQuery = { __typename?: 'Query' } & {
  searchServiceProducts: { __typename?: 'SearchServiceProducts' } & {
    meta: { __typename?: 'SearchServiceProductMeta' } & Pick<
      SearchServiceProductMeta,
      'totalUnits'
    > & {
        totals: { __typename?: 'SearchServiceProductTotals' } & Pick<
          SearchServiceProductTotals,
          'totalQuantity' | 'availableQuantity'
        >;
        pagination: { __typename?: 'SearchServiceProductPagination' } & Pick<
          SearchServiceProductPagination,
          'totalElements'
        >;
        rollups: { __typename?: 'SearchServiceProductRollups' } & {
          nodes: Array<
            { __typename?: 'SearchServiceProductRollup' } & Pick<
              SearchServiceProductRollup,
              'type'
            > & {
                rollupMarkets: {
                  __typename?: 'SearchServiceProductMarketRollups';
                } & {
                  nodes: Array<
                    { __typename?: 'SearchServiceProductMarketRollup' } & Pick<
                      SearchServiceProductMarketRollup,
                      'marketId' | 'marketName'
                    > & {
                        options: {
                          __typename?: 'SearchServiceProductMarketRollupOptions';
                        } & {
                          nodes: Array<
                            {
                              __typename?: 'SearchServiceProductMarketRollupOption';
                            } & Pick<
                              SearchServiceProductMarketRollupOption,
                              'label' | 'missing'
                            > & {
                                allocated: {
                                  __typename?: 'SearchServiceProductMarketRollupOptionRanges';
                                } & {
                                  nodes: Array<
                                    {
                                      __typename?: 'SearchServiceProductMarketRollupOptionRange';
                                    } & Pick<
                                      SearchServiceProductMarketRollupOptionRange,
                                      'label' | 'value'
                                    >
                                  >;
                                };
                                ranges: {
                                  __typename?: 'SearchServiceProductMarketRollupOptionRanges';
                                } & {
                                  nodes: Array<
                                    {
                                      __typename?: 'SearchServiceProductMarketRollupOptionRange';
                                    } & Pick<
                                      SearchServiceProductMarketRollupOptionRange,
                                      'label' | 'value'
                                    >
                                  >;
                                };
                                unallocated: {
                                  __typename?: 'SearchServiceProductMarketRollupOptionRanges';
                                } & {
                                  nodes: Array<
                                    {
                                      __typename?: 'SearchServiceProductMarketRollupOptionRange';
                                    } & Pick<
                                      SearchServiceProductMarketRollupOptionRange,
                                      'label' | 'value'
                                    >
                                  >;
                                };
                              }
                          >;
                        };
                      }
                  >;
                };
              }
          >;
        };
      };
  };
  searchServicePackages: { __typename?: 'SearchServicePackages' } & {
    meta: { __typename?: 'SearchServicePackageMeta' } & Pick<
      SearchServicePackageMeta,
      'totalUnits'
    > & {
        totals: { __typename?: 'SearchServicePackageTotals' } & Pick<
          SearchServicePackageTotals,
          | 'totalQuantity'
          | 'availableQuantity'
          | 'unitsAvailableQuantity'
          | 'unitsTotalQuantity'
        >;
        pagination: { __typename?: 'SearchServicePackagePagination' } & Pick<
          SearchServicePackagePagination,
          'totalElements'
        >;
        rollups: { __typename?: 'SearchServiceProductRollups' } & {
          nodes: Array<
            { __typename?: 'SearchServiceProductRollup' } & Pick<
              SearchServiceProductRollup,
              'type'
            > & {
                rollupMarkets: {
                  __typename?: 'SearchServiceProductMarketRollups';
                } & {
                  nodes: Array<
                    { __typename?: 'SearchServiceProductMarketRollup' } & Pick<
                      SearchServiceProductMarketRollup,
                      'marketId' | 'marketName'
                    > & {
                        options: {
                          __typename?: 'SearchServiceProductMarketRollupOptions';
                        } & {
                          nodes: Array<
                            {
                              __typename?: 'SearchServiceProductMarketRollupOption';
                            } & Pick<
                              SearchServiceProductMarketRollupOption,
                              'label' | 'missing'
                            > & {
                                allocated: {
                                  __typename?: 'SearchServiceProductMarketRollupOptionRanges';
                                } & {
                                  nodes: Array<
                                    {
                                      __typename?: 'SearchServiceProductMarketRollupOptionRange';
                                    } & Pick<
                                      SearchServiceProductMarketRollupOptionRange,
                                      'label' | 'value'
                                    >
                                  >;
                                };
                                ranges: {
                                  __typename?: 'SearchServiceProductMarketRollupOptionRanges';
                                } & {
                                  nodes: Array<
                                    {
                                      __typename?: 'SearchServiceProductMarketRollupOptionRange';
                                    } & Pick<
                                      SearchServiceProductMarketRollupOptionRange,
                                      'label' | 'value'
                                    >
                                  >;
                                };
                                unallocated: {
                                  __typename?: 'SearchServiceProductMarketRollupOptionRanges';
                                } & {
                                  nodes: Array<
                                    {
                                      __typename?: 'SearchServiceProductMarketRollupOptionRange';
                                    } & Pick<
                                      SearchServiceProductMarketRollupOptionRange,
                                      'label' | 'value'
                                    >
                                  >;
                                };
                              }
                          >;
                        };
                      }
                  >;
                };
              }
          >;
        };
      };
  };
};

export type MoveUnitsActiveFiltersQueryVariables = {
  companyUUID: Scalars['ID'];
  dataType: Scalars['String'];
  key: Scalars['String'];
};

export type MoveUnitsActiveFiltersQuery = { __typename?: 'Query' } & {
  filters?: Maybe<
    { __typename?: 'SearchServiceActiveFilters' } & Pick<
      SearchServiceActiveFilters,
      'filterGroupsCondition'
    > & {
        filterGroups: Array<
          { __typename?: 'SearchServiceActiveFilterGroup' } & Pick<
            SearchServiceActiveFilterGroup,
            'filtersCondition'
          > & {
              filters: Array<
                { __typename?: 'SearchServiceActiveFilterData' } & Pick<
                  SearchServiceActiveFilterData,
                  'values' | 'condition' | 'field'
                >
              >;
            }
        >;
      }
  >;
};

export type MoveUnitsPackagesQueryQueryVariables = {
  companyUUID: Scalars['ID'];
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  groupUUID: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  userUUID: Scalars['ID'];
  sortKey?: Maybe<Scalars['String']>;
  sortScope?: Maybe<Scalars['String']>;
  sortScopeValue?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

export type MoveUnitsPackagesQueryQuery = { __typename?: 'Query' } & {
  products: { __typename?: 'SearchServicePackages' } & {
    nodes: Array<
      { __typename?: 'SearchServicePackage' } & Pick<
        SearchServicePackage,
        | 'kind'
        | 'type'
        | 'unitsPerPackage'
        | 'name'
        | 'inturnPackageId'
        | 'uuid'
      > & {
          groups: { __typename?: 'SearchServicePackageGroups' } & {
            nodes: Array<
              { __typename?: 'SearchServicePackageGroup' } & Pick<
                SearchServicePackageGroup,
                'groupId' | 'totalAvailable' | 'totalQuantity'
              >
            >;
          };
          variants: { __typename?: 'SearchServicePackageVariants' } & {
            nodes: Array<
              { __typename?: 'SearchServicePackageVariant' } & Pick<
                SearchServicePackageVariant,
                'productID'
              > & {
                  markets: {
                    __typename?: 'SearchServicePackageVariantMarkets';
                  } & {
                    nodes: Array<
                      {
                        __typename?: 'SearchServicePackageVariantMarket';
                      } & Pick<
                        SearchServicePackageVariantMarket,
                        | 'wholesale'
                        | 'cost'
                        | 'marketUUID'
                        | 'currencyCode'
                        | 'suggested'
                      >
                    >;
                  };
                  images: {
                    __typename?: 'SearchServicePackageVariantImages';
                  } & {
                    nodes: Array<
                      {
                        __typename?: 'SearchServicePackageVariantImage';
                      } & Pick<SearchServicePackageVariantImage, 'url'>
                    >;
                  };
                }
            >;
          };
          prices: { __typename?: 'SearchServicePackagePrices' } & {
            nodes: Array<
              { __typename?: 'SearchServicePackagePrice' } & Pick<
                SearchServicePackagePrice,
                'marketUUID'
              > & {
                  cost: { __typename?: 'Metric' } & Pick<
                    Metric,
                    'value' | 'displayValue'
                  >;
                  wholesale: { __typename?: 'Metric' } & Pick<
                    Metric,
                    'value' | 'displayValue'
                  >;
                  suggested: { __typename?: 'Metric' } & Pick<
                    Metric,
                    'value' | 'displayValue'
                  >;
                }
            >;
          };
          products: { __typename?: 'SearchServicePackageProducts' } & {
            nodes: Array<
              { __typename?: 'SearchServiceProduct' } & Pick<
                SearchServiceProduct,
                'uuid'
              > & {
                  attributes: {
                    __typename?: 'SearchServiceProductAttributes';
                  } & {
                    nodes: Array<
                      { __typename?: 'SearchServiceProductAttribute' } & Pick<
                        SearchServiceProductAttribute,
                        'inturnType' | 'label' | 'value'
                      >
                    >;
                  };
                }
            >;
          };
        }
    >;
    meta: { __typename?: 'SearchServicePackageMeta' } & Pick<
      SearchServicePackageMeta,
      'key' | 'totalUnits'
    > & {
        rollups: { __typename?: 'SearchServiceProductRollups' } & {
          nodes: Array<
            { __typename?: 'SearchServiceProductRollup' } & Pick<
              SearchServiceProductRollup,
              'type'
            > & {
                rollupMarkets: {
                  __typename?: 'SearchServiceProductMarketRollups';
                } & {
                  nodes: Array<
                    { __typename?: 'SearchServiceProductMarketRollup' } & Pick<
                      SearchServiceProductMarketRollup,
                      'marketId'
                    > & {
                        options: {
                          __typename?: 'SearchServiceProductMarketRollupOptions';
                        } & {
                          nodes: Array<
                            {
                              __typename?: 'SearchServiceProductMarketRollupOption';
                            } & Pick<
                              SearchServiceProductMarketRollupOption,
                              'label'
                            > & {
                                ranges: {
                                  __typename?: 'SearchServiceProductMarketRollupOptionRanges';
                                } & {
                                  nodes: Array<
                                    {
                                      __typename?: 'SearchServiceProductMarketRollupOptionRange';
                                    } & Pick<
                                      SearchServiceProductMarketRollupOptionRange,
                                      'value' | 'label'
                                    >
                                  >;
                                };
                              }
                          >;
                        };
                      }
                  >;
                };
              }
          >;
        };
        pagination: { __typename?: 'SearchServicePackagePagination' } & Pick<
          SearchServicePackagePagination,
          'totalElements'
        >;
        totals: { __typename?: 'SearchServicePackageTotals' } & Pick<
          SearchServicePackageTotals,
          'availableQuantity' | 'totalQuantity'
        >;
      };
  };
};

export type MoveUnitsProductsQueryQueryVariables = {
  companyUUID: Scalars['ID'];
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  groupUUID: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  userUUID: Scalars['ID'];
  sortKey?: Maybe<Scalars['String']>;
  sortScope?: Maybe<Scalars['String']>;
  sortScopeValue?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

export type MoveUnitsProductsQueryQuery = { __typename?: 'Query' } & {
  products: { __typename?: 'SearchServiceProducts' } & {
    nodes: Array<
      { __typename?: 'SearchServiceProduct' } & Pick<
        SearchServiceProduct,
        'uuid' | 'name' | 'sku'
      > & {
          attributes: { __typename?: 'SearchServiceProductAttributes' } & {
            nodes: Array<
              { __typename?: 'SearchServiceProductAttribute' } & Pick<
                SearchServiceProductAttribute,
                'inturnType' | 'label' | 'value'
              >
            >;
          };
          variants: { __typename?: 'SearchServiceProductVariants' } & {
            nodes: Array<
              { __typename?: 'SearchServiceProductVariant' } & {
                markets: {
                  __typename?: 'SearchServiceProductVariantMarkets';
                } & {
                  nodes: Array<
                    { __typename?: 'SearchServiceProductVariantMarket' } & Pick<
                      SearchServiceProductVariantMarket,
                      | 'marketUUID'
                      | 'retail'
                      | 'cost'
                      | 'wholesale'
                      | 'currencyCode'
                      | 'suggested'
                    >
                  >;
                };
                images: { __typename?: 'SearchServiceProductVariantImages' } & {
                  nodes?: Maybe<
                    Array<
                      {
                        __typename?: 'SearchServiceProductVariantImage';
                      } & Pick<SearchServiceProductVariantImage, 'url'>
                    >
                  >;
                };
              }
            >;
          };
          sizeSummaries: {
            __typename?: 'SearchServiceProductSizeSummaries';
          } & {
            nodes: Array<
              { __typename?: 'SearchServiceProductSizeSummary' } & Pick<
                SearchServiceProductSizeSummary,
                'groupId'
              > & {
                  sizePerGroupSummaries: {
                    __typename?: 'SearchServiceProductSizeSummarySizePerGroupSummaries';
                  } & {
                    nodes: Array<
                      {
                        __typename?: 'SearchServiceProductSizeSummarySizePerGroupSummary';
                      } & Pick<
                        SearchServiceProductSizeSummarySizePerGroupSummary,
                        'totalAvailable' | 'totalQuantity' | 'value'
                      >
                    >;
                  };
                }
            >;
          };
          quantitySummaries: {
            __typename?: 'SearchServiceProductQuantitySummaries';
          } & {
            nodes: Array<
              { __typename?: 'SearchServiceProductQuantitySummary' } & Pick<
                SearchServiceProductQuantitySummary,
                | 'availableQuantity'
                | 'groupId'
                | 'totalQuantity'
                | 'totalAvailable'
              >
            >;
          };
        }
    >;
    meta: { __typename?: 'SearchServiceProductMeta' } & Pick<
      SearchServiceProductMeta,
      'key' | 'totalUnits'
    > & {
        totals: { __typename?: 'SearchServiceProductTotals' } & Pick<
          SearchServiceProductTotals,
          'availableQuantity' | 'totalQuantity'
        >;
        rollups: { __typename?: 'SearchServiceProductRollups' } & {
          nodes: Array<
            { __typename?: 'SearchServiceProductRollup' } & Pick<
              SearchServiceProductRollup,
              'type'
            > & {
                rollupMarkets: {
                  __typename?: 'SearchServiceProductMarketRollups';
                } & {
                  nodes: Array<
                    { __typename?: 'SearchServiceProductMarketRollup' } & Pick<
                      SearchServiceProductMarketRollup,
                      'marketId'
                    > & {
                        options: {
                          __typename?: 'SearchServiceProductMarketRollupOptions';
                        } & {
                          nodes: Array<
                            {
                              __typename?: 'SearchServiceProductMarketRollupOption';
                            } & Pick<
                              SearchServiceProductMarketRollupOption,
                              'label'
                            > & {
                                ranges: {
                                  __typename?: 'SearchServiceProductMarketRollupOptionRanges';
                                } & {
                                  nodes: Array<
                                    {
                                      __typename?: 'SearchServiceProductMarketRollupOptionRange';
                                    } & Pick<
                                      SearchServiceProductMarketRollupOptionRange,
                                      'value' | 'label'
                                    >
                                  >;
                                };
                              }
                          >;
                        };
                      }
                  >;
                };
              }
          >;
        };
        pagination: { __typename?: 'SearchServiceProductPagination' } & Pick<
          SearchServiceProductPagination,
          'totalElements'
        >;
      };
  };
};

export type MoveUnitsMoveProductsMutationVariables = {
  searchKey: Scalars['String'];
  uploadChannel: Scalars['ID'];
  moves: Array<Maybe<SearchServiceMoveData>>;
  userId: Scalars['ID'];
  groupId: Scalars['ID'];
  companyUUID: Scalars['ID'];
  productType: Scalars['String'];
};

export type MoveUnitsMoveProductsMutation = { __typename?: 'Mutation' } & {
  isSuccessful: Mutation['searchServiceMoveProducts'];
};

export type MoveUnitsOfferMissingPricesQueryVariables = {
  buyerCompanyUUID?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  listingCreatorCompanyUUID: Scalars['String'];
  listingUUID: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
};

export type MoveUnitsOfferMissingPricesQuery = { __typename?: 'Query' } & {
  totalUnitsInfo: { __typename?: 'OfferRows' } & {
    totals?: Maybe<
      { __typename?: 'OfferRowsTotals' } & Pick<
        OfferRowsTotals,
        'draftTotalUnits'
      >
    >;
  };
};

export type MoveUnitsOfferSummaryQueryVariables = {
  buyerCompanyUUID?: Maybe<Scalars['String']>;
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  limit?: Maybe<Scalars['Int']>;
  listingCreatorCompanyUUID: Scalars['String'];
  listingUUID: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
};

export type MoveUnitsOfferSummaryQuery = { __typename?: 'Query' } & {
  rows: { __typename?: 'OfferRows' } & {
    nodes: Array<
      { __typename?: 'OfferRow' } & Pick<
        OfferRow,
        'draftUnitPrice' | 'draftPackagePrice' | 'unitCost'
      >
    >;
    categoryBreakdown?: Maybe<
      { __typename?: 'OfferRowCategories' } & {
        nodes: Array<
          { __typename?: 'OfferRowCategory' } & Pick<
            OfferRowCategory,
            'name'
          > & {
              totals: { __typename?: 'OfferRowCategoryTotals' } & Pick<
                OfferRowCategoryTotals,
                'draftTotalUnits' | 'uniqueProducts'
              >;
            }
        >;
      }
    >;
    totals?: Maybe<
      { __typename?: 'OfferRowsTotals' } & Pick<
        OfferRowsTotals,
        'avgMargin' | 'draftTotalUnits' | 'draftTotalPrice' | 'totalCost'
      >
    >;
  };
};

export type MoveUnitsOffersQueryVariables = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sortKey?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<Fed_SortDirection>;
  parentGroupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  states?: Maybe<Array<Maybe<Fed_ListingState>>>;
  companyRole?: Maybe<Fed_CompanyRole>;
  companyId?: Maybe<Scalars['ID']>;
};

export type MoveUnitsOffersQuery = { __typename?: 'Query' } & {
  offers: { __typename?: 'FED_ListingsConnection' } & {
    nodes: Array<
      { __typename?: 'FED_Listing' } & Pick<
        Fed_Listing,
        'id' | 'status' | 'state' | 'title'
      > & {
          market?: Maybe<
            { __typename?: 'FED_Market' } & Pick<Fed_Market, 'id'>
          >;
          buyerCompanies?: Maybe<
            Array<
              Maybe<
                { __typename?: 'FED_Company' } & Pick<
                  Fed_Company,
                  'avatarUrl' | 'name'
                >
              >
            >
          >;
        }
    >;
    pagination: { __typename?: 'FED_ListingsPagination' } & Pick<
      Fed_ListingsPagination,
      'limit' | 'offset' | 'total'
    >;
  };
};

export type InventoryManageDeletePackagesMutationVariables = {
  companyUUID: Scalars['String'];
  groupUUID: Scalars['String'];
  key: Scalars['String'];
  userUUID: Scalars['String'];
};

export type InventoryManageDeletePackagesMutation = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'deletePackagesByKey'>;

export type InventoryManageDeleteProductsMutationVariables = {
  companyUUID: Scalars['String'];
  groupUUID: Scalars['String'];
  key: Scalars['String'];
  userUUID: Scalars['String'];
};

export type InventoryManageDeleteProductsMutation = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'deleteProductsByKey'>;

export type Fed_InventorySelectionPackagesQueryVariables = {
  filterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
  groupUUID: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  isRedundantGroupsFilteringActive?: Maybe<Scalars['Boolean']>;
};

export type Fed_InventorySelectionPackagesQuery = { __typename?: 'Query' } & {
  products: { __typename?: 'FED_SearchServicePackages' } & {
    meta: { __typename?: 'FED_SearchServicePackageMeta' } & {
      rollups: { __typename?: 'FED_SearchServiceProductRollups' } & {
        nodes: Array<
          { __typename?: 'FED_SearchServiceProductRollup' } & Pick<
            Fed_SearchServiceProductRollup,
            'type'
          > & {
              rollupMarkets: {
                __typename?: 'FED_SearchServiceProductMarketRollups';
              } & {
                nodes: Array<
                  {
                    __typename?: 'FED_SearchServiceProductMarketRollup';
                  } & Pick<Fed_SearchServiceProductMarketRollup, 'marketId'> & {
                      options: {
                        __typename?: 'FED_SearchServiceProductMarketRollupOptions';
                      } & {
                        nodes: Array<
                          {
                            __typename?: 'FED_SearchServiceProductMarketRollupOption';
                          } & Pick<
                            Fed_SearchServiceProductMarketRollupOption,
                            'label' | 'missing'
                          > & {
                              ranges: {
                                __typename?: 'FED_SearchServiceProductMarketRollupOptionRanges';
                              } & {
                                nodes: Array<
                                  {
                                    __typename?: 'FED_SearchServiceProductMarketRollupOptionRange';
                                  } & Pick<
                                    Fed_SearchServiceProductMarketRollupOptionRange,
                                    'label' | 'value'
                                  >
                                >;
                              };
                            }
                        >;
                      };
                    }
                >;
              };
              truckloadTotals?: Maybe<
                {
                  __typename?: 'FED_SearchServiceProductTruckloadRollups';
                } & Pick<
                  Fed_SearchServiceProductTruckloadRollups,
                  | 'totalGrossWeight'
                  | 'totalCube'
                  | 'totalTrucks'
                  | 'totalQuantity'
                  | 'totalUnits'
                  | 'totalCases'
                  | 'totalPackages'
                >
              >;
            }
        >;
      };
    };
  };
};

export type DeleteDocumentMutationVariables = {
  productImageId: Scalars['ID'];
  productId: Scalars['ID'];
};

export type DeleteDocumentMutation = { __typename?: 'Mutation' } & {
  isSuccessful: Mutation['deleteImageDocument'];
};

export type InventoryPdpDeletePackagesMutationVariables = {
  groupUUID: Scalars['String'];
  packageIds: Array<Scalars['String']>;
};

export type InventoryPdpDeletePackagesMutation = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'deletePackages'>;

export type InventoryPdpDeleteProductsMutationVariables = {
  groupUUID: Scalars['String'];
  productIds: Array<Scalars['String']>;
};

export type InventoryPdpDeleteProductsMutation = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'deleteProducts'>;

export type SyncInventoryDataMutationVariables = {
  actionType: InventorySyncActionType;
  channelId: Scalars['String'];
  productIds: Array<Scalars['String']>;
  type: InventorySyncType;
};

export type SyncInventoryDataMutation = { __typename?: 'Mutation' } & {
  isSuccessful: Mutation['syncInventoryData'];
};

export type ImageSettingsFragmentFragment = {
  __typename?: 'ImageSettings';
} & Pick<
  ImageSettings,
  'colorMatch' | 'documentId' | 'position' | 'productImageId' | 'productId'
>;

export type UpdateDocumentMutationVariables = {
  colorMatch: Scalars['Boolean'];
  productImageId: Scalars['ID'];
  imagePosition: Scalars['Float'];
  productId: Scalars['ID'];
};

export type UpdateDocumentMutation = { __typename?: 'Mutation' } & {
  updatedImage: {
    __typename?: 'ImageSettings';
  } & ImageSettingsFragmentFragment;
};

export type AddDocumentMutationVariables = {
  input: DocumentInput;
};

export type AddDocumentMutation = { __typename?: 'Mutation' } & {
  addDocumentImage: { __typename?: 'DocumentImage' } & Pick<
    DocumentImage,
    'id' | 'name' | 'src'
  >;
};

export type UploadInventorySyncImageMutationVariables = {
  colorMatch: Scalars['Boolean'];
  documentId: Scalars['ID'];
  imagePosition: Scalars['Float'];
  productId: Scalars['ID'];
};

export type UploadInventorySyncImageMutation = { __typename?: 'Mutation' } & {
  uploadedImage: {
    __typename?: 'ImageSettings';
  } & ImageSettingsFragmentFragment;
};

export type PdpInventoryPackagesQueryVariables = {
  companyUUID: Scalars['ID'];
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  groupUUID: Scalars['ID'];
  userUUID: Scalars['ID'];
  isRedundantGroupsFilteringActive?: Maybe<Scalars['Boolean']>;
};

export type PdpInventoryPackagesQuery = { __typename?: 'Query' } & {
  products: { __typename?: 'SearchServicePackages' } & {
    nodes: Array<
      { __typename?: 'SearchServicePackage' } & Pick<
        SearchServicePackage,
        | 'name'
        | 'kind'
        | 'uuid'
        | 'unitsPerPackage'
        | 'inturnPackageId'
        | 'type'
      > & {
          variants: { __typename?: 'SearchServicePackageVariants' } & {
            nodes: Array<
              { __typename?: 'SearchServicePackageVariant' } & Pick<
                SearchServicePackageVariant,
                'ratio' | 'productID'
              > & {
                  images: {
                    __typename?: 'SearchServicePackageVariantImages';
                  } & {
                    nodes: Array<
                      {
                        __typename?: 'SearchServicePackageVariantImage';
                      } & Pick<
                        SearchServicePackageVariantImage,
                        'colorMatch' | 'position' | 'productImageID' | 'url'
                      >
                    >;
                  };
                  options: {
                    __typename?: 'SearchServicePackageVariantOptions';
                  } & {
                    nodes: Array<
                      {
                        __typename?: 'SearchServicePackageVariantOption';
                      } & Pick<
                        SearchServicePackageVariantOption,
                        'name' | 'value'
                      >
                    >;
                  };
                  markets: {
                    __typename?: 'SearchServicePackageVariantMarkets';
                  } & {
                    nodes: Array<
                      {
                        __typename?: 'SearchServicePackageVariantMarket';
                      } & Pick<
                        SearchServicePackageVariantMarket,
                        'marketUUID' | 'name' | 'currency' | 'currencyCode'
                      > & {
                          prices: {
                            __typename?: 'SearchServicePackageVariantMarketPrices';
                          } & {
                            nodes: Array<
                              { __typename?: 'Metric' } & Pick<
                                Metric,
                                'type' | 'value' | 'isoCurrencyCode'
                              >
                            >;
                          };
                        }
                    >;
                  };
                }
            >;
          };
          prices: { __typename?: 'SearchServicePackagePrices' } & {
            nodes: Array<
              { __typename?: 'SearchServicePackagePrice' } & Pick<
                SearchServicePackagePrice,
                'marketUUID'
              > & {
                  cost: { __typename?: 'Metric' } & Pick<Metric, 'value'>;
                  retail: { __typename?: 'Metric' } & Pick<Metric, 'value'>;
                  wholesale: { __typename?: 'Metric' } & Pick<Metric, 'value'>;
                }
            >;
          };
          products: { __typename?: 'SearchServicePackageProducts' } & {
            nodes: Array<
              { __typename?: 'SearchServiceProduct' } & Pick<
                SearchServiceProduct,
                'uuid' | 'name' | 'sku' | 'description'
              > & {
                  attributes: {
                    __typename?: 'SearchServiceProductAttributes';
                  } & {
                    nodes: Array<
                      { __typename?: 'SearchServiceProductAttribute' } & Pick<
                        SearchServiceProductAttribute,
                        'inturnType' | 'label' | 'value'
                      >
                    >;
                  };
                  options: { __typename?: 'SearchServiceProductOptions' } & {
                    nodes: Array<
                      { __typename?: 'SearchServiceProductOption' } & Pick<
                        SearchServiceProductOption,
                        'name' | 'value'
                      >
                    >;
                  };
                }
            >;
          };
          groups: { __typename?: 'SearchServicePackageGroups' } & {
            nodes: Array<
              { __typename?: 'SearchServicePackageGroup' } & Pick<
                SearchServicePackageGroup,
                | 'groupId'
                | 'totalAvailable'
                | 'totalQuantity'
                | 'unitsTotalQuantity'
                | 'type'
              > & {
                  sizeSummaries: {
                    __typename?: 'SearchServicePackageGroupSizeSummaries';
                  } & {
                    nodes: Array<
                      {
                        __typename?: 'SearchServicePackageGroupSizeSummary';
                      } & Pick<
                        SearchServicePackageGroupSizeSummary,
                        'value' | 'totalAvailable' | 'totalQuantity'
                      >
                    >;
                  };
                }
            >;
          };
        }
    >;
    meta: { __typename?: 'SearchServicePackageMeta' } & {
      pagination: { __typename?: 'SearchServicePackagePagination' } & {
        total: SearchServicePackagePagination['totalElements'];
      };
    };
  };
};

export type PdpInventoryProductVariantFragment = {
  __typename?: 'SearchServiceProductVariants';
} & {
  nodes: Array<
    { __typename?: 'SearchServiceProductVariant' } & {
      images: { __typename?: 'SearchServiceProductVariantImages' } & {
        nodes?: Maybe<
          Array<
            { __typename?: 'SearchServiceProductVariantImage' } & Pick<
              SearchServiceProductVariantImage,
              'colorMatch' | 'position' | 'productImageID' | 'url'
            >
          >
        >;
      };
      markets: { __typename?: 'SearchServiceProductVariantMarkets' } & {
        nodes: Array<
          { __typename?: 'SearchServiceProductVariantMarket' } & Pick<
            SearchServiceProductVariantMarket,
            | 'name'
            | 'marketUUID'
            | 'currencyCode'
            | 'cost'
            | 'retail'
            | 'wholesale'
            | 'suggested'
          >
        >;
      };
    }
  >;
};

export type PdpInventoryProductSizeSummariesFragment = {
  __typename?: 'SearchServiceProductSizeSummaries';
} & {
  nodes: Array<
    { __typename?: 'SearchServiceProductSizeSummary' } & Pick<
      SearchServiceProductSizeSummary,
      'groupId' | 'packageType'
    > & {
        sizePerGroupSummaries: {
          __typename?: 'SearchServiceProductSizeSummarySizePerGroupSummaries';
        } & {
          nodes: Array<
            {
              __typename?: 'SearchServiceProductSizeSummarySizePerGroupSummary';
            } & Pick<
              SearchServiceProductSizeSummarySizePerGroupSummary,
              'totalAvailable' | 'totalQuantity' | 'value'
            >
          >;
        };
      }
  >;
};

export type PdpInventoryProductQuantitySummariesFragment = {
  __typename?: 'SearchServiceProductQuantitySummaries';
} & {
  nodes: Array<
    { __typename?: 'SearchServiceProductQuantitySummary' } & Pick<
      SearchServiceProductQuantitySummary,
      | 'groupId'
      | 'groupType'
      | 'packageType'
      | 'totalAvailable'
      | 'totalQuantity'
    >
  >;
};

export type PdpInventoryProductsQueryVariables = {
  companyUUID: Scalars['ID'];
  userUUID: Scalars['ID'];
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  groupUUID: Scalars['ID'];
  isRedundantGroupsFilteringActive?: Maybe<Scalars['Boolean']>;
};

export type PdpInventoryProductsQuery = { __typename?: 'Query' } & {
  products: { __typename?: 'SearchServiceProducts' } & {
    nodes: Array<
      { __typename?: 'SearchServiceProduct' } & Pick<
        SearchServiceProduct,
        'kind' | 'description' | 'name' | 'sku' | 'uuid'
      > & {
          attributes: { __typename?: 'SearchServiceProductAttributes' } & {
            nodes: Array<
              { __typename?: 'SearchServiceProductAttribute' } & Pick<
                SearchServiceProductAttribute,
                'inturnType' | 'label' | 'uuid' | 'value'
              >
            >;
          };
          quantitySummaries: {
            __typename?: 'SearchServiceProductQuantitySummaries';
          } & PdpInventoryProductQuantitySummariesFragment;
          sizeSummaries: {
            __typename?: 'SearchServiceProductSizeSummaries';
          } & PdpInventoryProductSizeSummariesFragment;
          variants: {
            __typename?: 'SearchServiceProductVariants';
          } & PdpInventoryProductVariantFragment;
        }
    >;
    meta: { __typename?: 'SearchServiceProductMeta' } & Pick<
      SearchServiceProductMeta,
      'key'
    > & {
        pagination: { __typename?: 'SearchServiceProductPagination' } & {
          total: SearchServiceProductPagination['totalElements'];
        };
      };
  };
};

export type SearchServiceFiltersContextActiveOffersQueryVariables = {
  groupUUID: Scalars['AnyObject'];
};

export type SearchServiceFiltersContextActiveOffersQuery = {
  __typename?: 'Query';
} & {
  listingsV2: { __typename?: 'ListingsV2' } & {
    nodes: Array<
      { __typename?: 'ListingsV2Listing' } & Pick<
        ListingsV2Listing,
        'id' | 'status' | 'title'
      >
    >;
  };
};

export type InventoryPackagesFiltersQueryVariables = {
  companyUUID: Scalars['ID'];
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  groupUUID: Scalars['ID'];
  userUUID: Scalars['ID'];
};

export type InventoryPackagesFiltersQuery = { __typename?: 'Query' } & {
  entities: { __typename?: 'SearchServicePackages' } & {
    meta: { __typename?: 'SearchServicePackageMeta' } & {
      filters: { __typename?: 'SearchServiceProductFilters' } & {
        nodes: Array<
          { __typename?: 'SearchServiceProductFilter' } & Pick<
            SearchServiceProductFilter,
            'count' | 'label'
          > & {
              options: {
                __typename?: 'SearchServiceProductFilterOptions';
              } & Pick<SearchServiceProductFilterOptions, 'nodes'>;
            }
        >;
      };
      pagination: { __typename?: 'SearchServicePackagePagination' } & Pick<
        SearchServicePackagePagination,
        'totalElements'
      >;
      rollups: { __typename?: 'SearchServiceProductRollups' } & {
        nodes: Array<
          { __typename?: 'SearchServiceProductRollup' } & Pick<
            SearchServiceProductRollup,
            'type'
          > & {
              rollupMarkets: {
                __typename?: 'SearchServiceProductMarketRollups';
              } & {
                nodes: Array<
                  { __typename?: 'SearchServiceProductMarketRollup' } & Pick<
                    SearchServiceProductMarketRollup,
                    'marketId'
                  > & {
                      options: {
                        __typename?: 'SearchServiceProductMarketRollupOptions';
                      } & {
                        nodes: Array<
                          {
                            __typename?: 'SearchServiceProductMarketRollupOption';
                          } & Pick<
                            SearchServiceProductMarketRollupOption,
                            'label' | 'missing'
                          > & {
                              ranges: {
                                __typename?: 'SearchServiceProductMarketRollupOptionRanges';
                              } & {
                                nodes: Array<
                                  {
                                    __typename?: 'SearchServiceProductMarketRollupOptionRange';
                                  } & Pick<
                                    SearchServiceProductMarketRollupOptionRange,
                                    'label' | 'value'
                                  >
                                >;
                              };
                            }
                        >;
                      };
                    }
                >;
              };
            }
        >;
      };
    };
  };
};

export type InventoryProductsFiltersQueryVariables = {
  companyUUID: Scalars['ID'];
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  groupUUID: Scalars['ID'];
  userUUID: Scalars['ID'];
};

export type InventoryProductsFiltersQuery = { __typename?: 'Query' } & {
  entities: { __typename?: 'SearchServiceProducts' } & {
    meta: { __typename?: 'SearchServiceProductMeta' } & {
      filters: { __typename?: 'SearchServiceProductFilters' } & {
        nodes: Array<
          { __typename?: 'SearchServiceProductFilter' } & Pick<
            SearchServiceProductFilter,
            'count' | 'label'
          > & {
              options: {
                __typename?: 'SearchServiceProductFilterOptions';
              } & Pick<SearchServiceProductFilterOptions, 'nodes'>;
            }
        >;
      };
      pagination: { __typename?: 'SearchServiceProductPagination' } & Pick<
        SearchServiceProductPagination,
        'totalElements'
      >;
      rollups: { __typename?: 'SearchServiceProductRollups' } & {
        nodes: Array<
          { __typename?: 'SearchServiceProductRollup' } & Pick<
            SearchServiceProductRollup,
            'type'
          > & {
              rollupMarkets: {
                __typename?: 'SearchServiceProductMarketRollups';
              } & {
                nodes: Array<
                  { __typename?: 'SearchServiceProductMarketRollup' } & Pick<
                    SearchServiceProductMarketRollup,
                    'marketId'
                  > & {
                      options: {
                        __typename?: 'SearchServiceProductMarketRollupOptions';
                      } & {
                        nodes: Array<
                          {
                            __typename?: 'SearchServiceProductMarketRollupOption';
                          } & Pick<
                            SearchServiceProductMarketRollupOption,
                            'label' | 'missing'
                          > & {
                              ranges: {
                                __typename?: 'SearchServiceProductMarketRollupOptionRanges';
                              } & {
                                nodes: Array<
                                  {
                                    __typename?: 'SearchServiceProductMarketRollupOptionRange';
                                  } & Pick<
                                    SearchServiceProductMarketRollupOptionRange,
                                    'label' | 'value'
                                  >
                                >;
                              };
                            }
                        >;
                      };
                    }
                >;
              };
            }
        >;
      };
    };
  };
};

export type InventoryAllEntitiesCountsQueryVariables = {
  groupUUID: Scalars['ID'];
};

export type InventoryAllEntitiesCountsQuery = { __typename?: 'Query' } & {
  casepacks: { __typename?: 'SearchServicePackages' } & {
    meta: { __typename?: 'SearchServicePackageMeta' } & {
      pagination: { __typename?: 'SearchServicePackagePagination' } & Pick<
        SearchServicePackagePagination,
        'totalElements'
      >;
      totals: { __typename?: 'SearchServicePackageTotals' } & Pick<
        SearchServicePackageTotals,
        'withoutImages'
      >;
    };
  };
  items: { __typename?: 'SearchServiceProducts' } & {
    meta: { __typename?: 'SearchServiceProductMeta' } & {
      pagination: { __typename?: 'SearchServiceProductPagination' } & Pick<
        SearchServiceProductPagination,
        'totalElements'
      >;
      totals: { __typename?: 'SearchServiceProductTotals' } & Pick<
        SearchServiceProductTotals,
        'withoutImages'
      >;
    };
  };
};

export type Fed_InventoryPackagesNodeFragment = {
  __typename: 'FED_SearchServicePackage';
} & Pick<
  Fed_SearchServicePackage,
  'name' | 'kind' | 'uuid' | 'inturnPackageId' | 'type'
> & {
    variants: { __typename?: 'FED_SearchServicePackageVariants' } & {
      nodes: Array<
        { __typename?: 'FED_SearchServicePackageVariant' } & Pick<
          Fed_SearchServicePackageVariant,
          'uuid' | 'productID' | 'ratio'
        > & {
            images: { __typename?: 'FED_SearchServicePackageVariantImages' } & {
              nodes: Array<
                { __typename?: 'FED_SearchServicePackageVariantImage' } & Pick<
                  Fed_SearchServicePackageVariantImage,
                  'colorMatch' | 'url'
                >
              >;
            };
          }
      >;
    };
    prices: { __typename?: 'FED_SearchServicePackagePrices' } & {
      nodes: Array<
        { __typename?: 'FED_SearchServicePackagePrice' } & Pick<
          Fed_SearchServicePackagePrice,
          'marketUUID' | 'currencyCode'
        > & {
            cost: { __typename?: 'FED_Metric' } & Pick<Fed_Metric, 'value'>;
            wholesale: { __typename?: 'FED_Metric' } & Pick<
              Fed_Metric,
              'value'
            >;
            retail: { __typename?: 'FED_Metric' } & Pick<Fed_Metric, 'value'>;
          }
      >;
    };
    products: { __typename?: 'FED_SearchServicePackageProducts' } & {
      nodes: Array<
        { __typename?: 'FED_SearchServiceProduct' } & Pick<
          Fed_SearchServiceProduct,
          'description' | 'sku'
        > & {
            attributes: {
              __typename?: 'FED_SearchServiceProductAttributes';
            } & {
              nodes: Array<
                { __typename?: 'FED_SearchServiceProductAttribute' } & Pick<
                  Fed_SearchServiceProductAttribute,
                  'label' | 'value' | 'inturnType'
                >
              >;
            };
          }
      >;
    };
    groups: { __typename?: 'FED_SearchServicePackageGroups' } & {
      nodes: Array<
        { __typename?: 'FED_SearchServicePackageGroup' } & Pick<
          Fed_SearchServicePackageGroup,
          'groupId' | 'totalAvailable' | 'totalQuantity' | 'unitsTotalQuantity'
        > & {
            sizeSummaries: {
              __typename?: 'FED_SearchServicePackageGroupSizeSummaries';
            } & {
              nodes: Array<
                {
                  __typename?: 'FED_SearchServicePackageGroupSizeSummary';
                } & Pick<
                  Fed_SearchServicePackageGroupSizeSummary,
                  'value' | 'totalAvailable' | 'totalQuantity'
                >
              >;
            };
          }
      >;
    };
  };

export type Fed_InventoryPackagesQueryVariables = {
  companyUUID?: Maybe<Scalars['ID']>;
  filterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
  groupUUID: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  sortDirection?: Maybe<Scalars['String']>;
  sortKey?: Maybe<Scalars['String']>;
  sortScope?: Maybe<Scalars['String']>;
  sortScopeValue?: Maybe<Scalars['String']>;
  userUUID?: Maybe<Scalars['ID']>;
  isRedundantGroupsFilteringActive?: Maybe<Scalars['Boolean']>;
};

export type Fed_InventoryPackagesQuery = { __typename?: 'Query' } & {
  products: { __typename?: 'FED_SearchServicePackages' } & {
    nodes: Array<
      {
        __typename?: 'FED_SearchServicePackage';
      } & Fed_InventoryPackagesNodeFragment
    >;
    meta: { __typename?: 'FED_SearchServicePackageMeta' } & Pick<
      Fed_SearchServicePackageMeta,
      'key'
    > & {
        filters: { __typename?: 'FED_SearchServiceProductFilters' } & {
          nodes: Array<
            { __typename?: 'FED_SearchServiceProductFilter' } & Pick<
              Fed_SearchServiceProductFilter,
              'label' | 'inturnType'
            >
          >;
        };
        pagination: { __typename?: 'FED_SearchServicePackagePagination' } & {
          total: Fed_SearchServicePackagePagination['totalElements'];
        };
        rollups: { __typename?: 'FED_SearchServiceProductRollups' } & {
          nodes: Array<
            { __typename?: 'FED_SearchServiceProductRollup' } & Pick<
              Fed_SearchServiceProductRollup,
              'type'
            > & {
                rollupMarkets: {
                  __typename?: 'FED_SearchServiceProductMarketRollups';
                } & {
                  nodes: Array<
                    {
                      __typename?: 'FED_SearchServiceProductMarketRollup';
                    } & Pick<
                      Fed_SearchServiceProductMarketRollup,
                      'marketId'
                    > & {
                        options: {
                          __typename?: 'FED_SearchServiceProductMarketRollupOptions';
                        } & {
                          nodes: Array<
                            {
                              __typename?: 'FED_SearchServiceProductMarketRollupOption';
                            } & Pick<
                              Fed_SearchServiceProductMarketRollupOption,
                              'label' | 'missing'
                            > & {
                                ranges: {
                                  __typename?: 'FED_SearchServiceProductMarketRollupOptionRanges';
                                } & {
                                  nodes: Array<
                                    {
                                      __typename?: 'FED_SearchServiceProductMarketRollupOptionRange';
                                    } & Pick<
                                      Fed_SearchServiceProductMarketRollupOptionRange,
                                      'label' | 'value'
                                    >
                                  >;
                                };
                              }
                          >;
                        };
                      }
                  >;
                };
                truckloadTotals?: Maybe<
                  {
                    __typename?: 'FED_SearchServiceProductTruckloadRollups';
                  } & Pick<
                    Fed_SearchServiceProductTruckloadRollups,
                    | 'totalGrossWeight'
                    | 'totalCube'
                    | 'totalTrucks'
                    | 'totalQuantity'
                    | 'totalUnits'
                    | 'totalCases'
                    | 'totalPackages'
                  >
                >;
              }
          >;
        };
        totals: { __typename?: 'FED_SearchServicePackageTotals' } & Pick<
          Fed_SearchServicePackageTotals,
          'totalQuantity' | 'unitsTotalQuantity'
        >;
      };
  };
};

export type Fed_SearchServiceInventoryPackagesFetchMoreQueryVariables = {
  companyUUID?: Maybe<Scalars['ID']>;
  filterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
  groupUUID: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  sortDirection?: Maybe<Scalars['String']>;
  sortKey?: Maybe<Scalars['String']>;
  sortScope?: Maybe<Scalars['String']>;
  sortScopeValue?: Maybe<Scalars['String']>;
  userUUID?: Maybe<Scalars['ID']>;
  isRedundantGroupsFilteringActive?: Maybe<Scalars['Boolean']>;
};

export type Fed_SearchServiceInventoryPackagesFetchMoreQuery = {
  __typename?: 'Query';
} & {
  products: { __typename?: 'FED_SearchServicePackages' } & {
    nodes: Array<
      {
        __typename?: 'FED_SearchServicePackage';
      } & Fed_InventoryPackagesNodeFragment
    >;
  };
};

export type InventoryProductsNodeFragment = {
  __typename: 'SearchServiceProduct';
} & Pick<
  SearchServiceProduct,
  'kind' | 'description' | 'name' | 'sku' | 'uuid'
> & {
    attributes: { __typename?: 'SearchServiceProductAttributes' } & {
      nodes: Array<
        { __typename?: 'SearchServiceProductAttribute' } & Pick<
          SearchServiceProductAttribute,
          'label' | 'value' | 'inturnType'
        >
      >;
    };
    quantitySummaries: {
      __typename?: 'SearchServiceProductQuantitySummaries';
    } & {
      nodes: Array<
        { __typename?: 'SearchServiceProductQuantitySummary' } & Pick<
          SearchServiceProductQuantitySummary,
          | 'groupId'
          | 'groupType'
          | 'packageType'
          | 'totalAvailable'
          | 'totalQuantity'
        >
      >;
    };
    sizeSummaries: { __typename?: 'SearchServiceProductSizeSummaries' } & {
      nodes: Array<
        { __typename?: 'SearchServiceProductSizeSummary' } & Pick<
          SearchServiceProductSizeSummary,
          'groupId' | 'packageType'
        > & {
            sizePerGroupSummaries: {
              __typename?: 'SearchServiceProductSizeSummarySizePerGroupSummaries';
            } & {
              nodes: Array<
                {
                  __typename?: 'SearchServiceProductSizeSummarySizePerGroupSummary';
                } & Pick<
                  SearchServiceProductSizeSummarySizePerGroupSummary,
                  'totalAvailable' | 'totalQuantity' | 'value'
                >
              >;
            };
          }
      >;
    };
    variants: { __typename?: 'SearchServiceProductVariants' } & {
      nodes: Array<
        { __typename?: 'SearchServiceProductVariant' } & Pick<
          SearchServiceProductVariant,
          'uuid' | 'productID'
        > & {
            images: { __typename?: 'SearchServiceProductVariantImages' } & {
              nodes?: Maybe<
                Array<
                  { __typename?: 'SearchServiceProductVariantImage' } & Pick<
                    SearchServiceProductVariantImage,
                    'colorMatch' | 'url'
                  >
                >
              >;
            };
            markets: { __typename?: 'SearchServiceProductVariantMarkets' } & {
              nodes: Array<
                { __typename?: 'SearchServiceProductVariantMarket' } & Pick<
                  SearchServiceProductVariantMarket,
                  | 'name'
                  | 'marketUUID'
                  | 'currencyCode'
                  | 'cost'
                  | 'retail'
                  | 'wholesale'
                >
              >;
            };
          }
      >;
    };
  };

export type InventoryProductsQueryVariables = {
  companyUUID?: Maybe<Scalars['ID']>;
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  groupUUID: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  sortDirection?: Maybe<Scalars['String']>;
  sortKey?: Maybe<Scalars['String']>;
  sortScope?: Maybe<Scalars['String']>;
  sortScopeValue?: Maybe<Scalars['String']>;
  userUUID?: Maybe<Scalars['ID']>;
  isRedundantGroupsFilteringActive?: Maybe<Scalars['Boolean']>;
};

export type InventoryProductsQuery = { __typename?: 'Query' } & {
  products: { __typename?: 'SearchServiceProducts' } & {
    nodes: Array<
      { __typename?: 'SearchServiceProduct' } & InventoryProductsNodeFragment
    >;
    meta: { __typename?: 'SearchServiceProductMeta' } & Pick<
      SearchServiceProductMeta,
      'key'
    > & {
        filters: { __typename?: 'SearchServiceProductFilters' } & {
          nodes: Array<
            { __typename?: 'SearchServiceProductFilter' } & Pick<
              SearchServiceProductFilter,
              'label' | 'inturnType'
            >
          >;
        };
        pagination: { __typename?: 'SearchServiceProductPagination' } & {
          total: SearchServiceProductPagination['totalElements'];
        };
        rollups: { __typename?: 'SearchServiceProductRollups' } & {
          nodes: Array<
            { __typename?: 'SearchServiceProductRollup' } & Pick<
              SearchServiceProductRollup,
              'type'
            > & {
                rollupMarkets: {
                  __typename?: 'SearchServiceProductMarketRollups';
                } & {
                  nodes: Array<
                    { __typename?: 'SearchServiceProductMarketRollup' } & Pick<
                      SearchServiceProductMarketRollup,
                      'marketId'
                    > & {
                        options: {
                          __typename?: 'SearchServiceProductMarketRollupOptions';
                        } & {
                          nodes: Array<
                            {
                              __typename?: 'SearchServiceProductMarketRollupOption';
                            } & Pick<
                              SearchServiceProductMarketRollupOption,
                              'label' | 'missing'
                            > & {
                                ranges: {
                                  __typename?: 'SearchServiceProductMarketRollupOptionRanges';
                                } & {
                                  nodes: Array<
                                    {
                                      __typename?: 'SearchServiceProductMarketRollupOptionRange';
                                    } & Pick<
                                      SearchServiceProductMarketRollupOptionRange,
                                      'label' | 'value'
                                    >
                                  >;
                                };
                              }
                          >;
                        };
                      }
                  >;
                };
              }
          >;
        };
        totals: { __typename?: 'SearchServiceProductTotals' } & {
          unitsTotalQuantity: SearchServiceProductTotals['totalQuantity'];
          availableQuantity: SearchServiceProductTotals['availableQuantity'];
        };
      };
  };
};

export type SearchServiceInventoryProductsFetchMoreQueryVariables = {
  companyUUID?: Maybe<Scalars['ID']>;
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  groupUUID: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  sortDirection?: Maybe<Scalars['String']>;
  sortKey?: Maybe<Scalars['String']>;
  sortScope?: Maybe<Scalars['String']>;
  sortScopeValue?: Maybe<Scalars['String']>;
  userUUID?: Maybe<Scalars['ID']>;
  isRedundantGroupsFilteringActive?: Maybe<Scalars['Boolean']>;
};

export type SearchServiceInventoryProductsFetchMoreQuery = {
  __typename?: 'Query';
} & {
  products: { __typename?: 'SearchServiceProducts' } & {
    nodes: Array<
      { __typename?: 'SearchServiceProduct' } & InventoryProductsNodeFragment
    >;
  };
};

export type InventoryUserAllocationsQueryVariables = {
  userId: Scalars['ID'];
};

export type InventoryUserAllocationsQuery = { __typename?: 'Query' } & {
  userAllocations?: Maybe<
    { __typename?: 'Allocations' } & {
      nodes?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Allocation' } & Pick<Allocation, 'id' | 'label'>
          >
        >
      >;
    }
  >;
};

export type MessagesCreateThreadParticipantFragment = {
  __typename?: 'User';
} & Pick<User, 'firstName' | 'email' | 'id' | 'lastName' | 'userRole'> & {
    company: { __typename?: 'Company' } & Pick<Company, 'id' | 'name'>;
    image?: Maybe<{ __typename?: 'File' } & Pick<File, 'src'>>;
  };

export type MessagesCreateThreadSuccessFragment = {
  __typename?: 'MessageThread';
} & Pick<MessageThread, 'createdAt' | 'id' | 'isRead' | 'updatedAt'> & {
    participants: { __typename?: 'Participants' } & {
      nodes: Array<
        { __typename?: 'User' } & MessagesCreateThreadParticipantFragment
      >;
    };
    messages: { __typename?: 'MessageThreadMessages' } & {
      nodes: Array<
        { __typename?: 'MessageThreadMessage' } & Pick<
          MessageThreadMessage,
          'content' | 'id' | 'updatedAt'
        >
      >;
    };
  };

export type MessageCreateThreadErrorFragment = {
  __typename?: 'GenericError';
} & Pick<GenericError, 'kind' | 'message'>;

export type MessagesCreateThreadAndSendMessageMutationVariables = {
  userId: Scalars['ID'];
  content: Scalars['String'];
};

export type MessagesCreateThreadAndSendMessageMutation = {
  __typename?: 'Mutation';
} & {
  createMessageThread:
    | ({ __typename?: 'MessageThread' } & MessagesCreateThreadSuccessFragment)
    | ({ __typename?: 'GenericError' } & MessageCreateThreadErrorFragment);
};

export type MessagesReadThreadMessagesSuccessFragment = {
  __typename?: 'UpdateMessageThreadMessagesSuccess';
} & Pick<UpdateMessageThreadMessagesSuccess, 'value'>;

export type MessagesReadThreadMessagesErrorFragment = {
  __typename?: 'GenericError';
} & Pick<GenericError, 'kind' | 'message'>;

export type MessagesReadThreadMessagesMutationVariables = {
  threadId: Scalars['ID'];
};

export type MessagesReadThreadMessagesMutation = { __typename?: 'Mutation' } & {
  isUpdated:
    | ({
        __typename?: 'UpdateMessageThreadMessagesSuccess';
      } & MessagesReadThreadMessagesSuccessFragment)
    | ({
        __typename?: 'GenericError';
      } & MessagesReadThreadMessagesErrorFragment);
};

export type MessagesReportThreadSuccessFragment = {
  __typename?: 'ReportConfirmation';
} & Pick<ReportConfirmation, 'id'>;

export type MessagesReportThreadErrorFragment = {
  __typename?: 'GenericError';
} & Pick<GenericError, 'kind' | 'message'>;

export type MessagesReportThreadMutationVariables = {
  threadId: Scalars['ID'];
  content: Scalars['String'];
};

export type MessagesReportThreadMutation = { __typename?: 'Mutation' } & {
  reportMessageThread:
    | ({
        __typename?: 'ReportConfirmation';
      } & MessagesReportThreadSuccessFragment)
    | ({ __typename?: 'GenericError' } & MessagesReportThreadErrorFragment);
};

export type MessagesSendMessageSuccessFragment = {
  __typename?: 'MessageThreadMessage';
} & Pick<MessageThreadMessage, 'content' | 'id' | 'updatedAt' | 'creatorId'>;

export type MessagesSendMessageErrorFragment = {
  __typename?: 'GenericError';
} & Pick<GenericError, 'kind' | 'message'>;

export type MessagesSendMessageMutationVariables = {
  threadId: Scalars['ID'];
  content: Scalars['String'];
};

export type MessagesSendMessageMutation = { __typename?: 'Mutation' } & {
  createMessageThreadMessage:
    | ({
        __typename?: 'MessageThreadMessage';
      } & MessagesSendMessageSuccessFragment)
    | ({ __typename?: 'GenericError' } & MessagesSendMessageErrorFragment);
};

export type MessagesMessageThreadMessageFragment = {
  __typename?: 'MessageThreadMessage';
} & Pick<
  MessageThreadMessage,
  'content' | 'id' | 'updatedAt' | 'creatorId' | 'status'
>;

export type MessagesMessageThreadMessagesSuccessFragment = {
  __typename?: 'MessageThreadMessages';
} & {
  nodes: Array<
    {
      __typename?: 'MessageThreadMessage';
    } & MessagesMessageThreadMessageFragment
  >;
};

export type MessagesMessageThreadMessagesErrorFragment = {
  __typename?: 'GenericError';
} & Pick<GenericError, 'kind' | 'message'>;

export type MessagesMessageThreadMessagesQueryVariables = {
  threadId: Scalars['ID'];
};

export type MessagesMessageThreadMessagesQuery = { __typename?: 'Query' } & {
  messageThreadMessages:
    | ({
        __typename?: 'MessageThreadMessages';
      } & MessagesMessageThreadMessagesSuccessFragment)
    | ({
        __typename?: 'GenericError';
      } & MessagesMessageThreadMessagesErrorFragment);
};

export type MessagesMessageThreadParticipantFragment = {
  __typename?: 'User';
} & Pick<User, 'firstName' | 'email' | 'id' | 'lastName' | 'userRole'> & {
    company: { __typename?: 'Company' } & Pick<Company, 'id' | 'name'>;
    image?: Maybe<{ __typename?: 'File' } & Pick<File, 'src'>>;
  };

export type MessagesMessageThreadFragment = {
  __typename?: 'MessageThread';
} & Pick<MessageThread, 'createdAt' | 'id' | 'isRead' | 'updatedAt'> & {
    participants: { __typename?: 'Participants' } & {
      nodes: Array<
        { __typename?: 'User' } & MessagesMessageThreadParticipantFragment
      >;
    };
    messages: { __typename?: 'MessageThreadMessages' } & {
      nodes: Array<
        { __typename?: 'MessageThreadMessage' } & Pick<
          MessageThreadMessage,
          'content' | 'id' | 'updatedAt'
        >
      >;
    };
  };

export type MessageThreadsSuccessFragment = {
  __typename?: 'MessageThreads';
} & {
  pagination: { __typename?: 'MessageThreadsPagination' } & Pick<
    MessageThreadsPagination,
    'currentPage' | 'perPage' | 'total' | 'totalPages'
  >;
  nodes: Array<
    { __typename?: 'MessageThread' } & MessagesMessageThreadFragment
  >;
};

export type MessageThreadsErrorFragment = {
  __typename?: 'GenericError';
} & Pick<GenericError, 'kind' | 'message'>;

export type MessagesMessageThreadsQueryVariables = {
  participantIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MessagesMessageThreadsQuery = { __typename?: 'Query' } & {
  messageThreads:
    | ({ __typename?: 'MessageThreads' } & MessageThreadsSuccessFragment)
    | ({ __typename?: 'GenericError' } & MessageThreadsErrorFragment);
};

export type MessagesUserFragment = { __typename?: 'User' } & Pick<
  User,
  'firstName' | 'email' | 'id' | 'lastName' | 'userRole'
> & {
    company: { __typename?: 'Company' } & Pick<Company, 'id' | 'name'>;
    image?: Maybe<{ __typename?: 'File' } & Pick<File, 'src'>>;
  };

export type MessagesUserQueryVariables = {
  id: Scalars['ID'];
};

export type MessagesUserQuery = { __typename?: 'Query' } & {
  user?: Maybe<{ __typename?: 'User' } & MessagesUserFragment>;
};

export type MessagesSearchUserFragment = { __typename?: 'User' } & Pick<
  User,
  'firstName' | 'email' | 'id' | 'lastName' | 'userRole'
> & {
    company: { __typename?: 'Company' } & Pick<Company, 'id' | 'name'>;
    image?: Maybe<{ __typename?: 'File' } & Pick<File, 'src'>>;
  };

export type MessagesSearchUsersQueryVariables = {
  value: Scalars['AnyObject'];
};

export type MessagesSearchUsersQuery = { __typename?: 'Query' } & {
  users?: Maybe<
    { __typename?: 'Users' } & {
      nodes?: Maybe<
        Array<{ __typename?: 'User' } & MessagesSearchUserFragment>
      >;
    }
  >;
};

export type Fed_CreateOfferCloneMutationVariables = {
  offerId: Scalars['ID'];
  listingId: Scalars['ID'];
  newListingName: Scalars['String'];
  uploadChannelId: Scalars['String'];
  clientContext: Scalars['AnyObject'];
};

export type Fed_CreateOfferCloneMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'FED_cloneOffer'
>;

export type Fed_CloneOfferListingQueryVariables = {
  id: Scalars['ID'];
  offerRowsFilterGroups: Array<Fed_SearchServiceFilterGroup>;
};

export type Fed_CloneOfferListingQuery = { __typename?: 'Query' } & {
  FED_listing: { __typename?: 'FED_Listing' } & {
    parentGroup?: Maybe<{ __typename?: 'FED_Group' } & Pick<Fed_Group, 'id'>>;
    offers: Array<
      { __typename?: 'FED_Offer' } & Pick<Fed_Offer, 'id' | 'version'> & {
          offerRows?: Maybe<
            { __typename?: 'FED_OfferRows' } & {
              pagination: { __typename?: 'FED_OfferRowsPagination' } & Pick<
                Fed_OfferRowsPagination,
                'totalElements'
              >;
            }
          >;
        }
    >;
  };
};

export type Fed_CreateOfferListingQueryVariables = {
  listingId: Scalars['ID'];
  groupId: Scalars['String'];
  offerRowsFilterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
  includeDeletedUsers?: Maybe<Scalars['Boolean']>;
};

export type Fed_CreateOfferListingQuery = { __typename?: 'Query' } & {
  listing: { __typename?: 'FED_Listing' } & Pick<
    Fed_Listing,
    'id' | 'customPo' | 'state'
  > & {
      offers: Array<
        { __typename?: 'FED_Offer' } & Pick<
          Fed_Offer,
          'id' | 'version' | 'status' | 'isDraftEdited' | 'isCurrent'
        > & {
            seller: { __typename?: 'FED_User' } & Pick<
              Fed_User,
              'id' | 'userId' | 'firstName' | 'lastName'
            > & {
                company?: Maybe<
                  { __typename?: 'FED_Company' } & Pick<
                    Fed_Company,
                    'id' | 'name'
                  >
                >;
              };
            creator?: Maybe<
              { __typename?: 'FED_User' } & Pick<Fed_User, 'id' | 'userId'> & {
                  company?: Maybe<
                    { __typename?: 'FED_Company' } & Pick<
                      Fed_Company,
                      'id' | 'name' | 'role'
                    >
                  >;
                }
            >;
            declineInfo?: Maybe<
              { __typename?: 'FED_DeclineInfo' } & Pick<
                Fed_DeclineInfo,
                'reasons' | 'comment'
              > & {
                  user?: Maybe<
                    { __typename?: 'FED_User' } & Pick<
                      Fed_User,
                      'id' | 'userId' | 'firstName'
                    > & {
                        company?: Maybe<
                          { __typename?: 'FED_Company' } & Pick<
                            Fed_Company,
                            'id' | 'name' | 'role'
                          >
                        >;
                      }
                  >;
                }
            >;
            rollups?: Maybe<
              { __typename?: 'FED_OfferRollups' } & {
                totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
                  Fed_OfferRollupsTotalRollup,
                  'totalElements'
                >;
                truckloadTotals?: Maybe<
                  {
                    __typename?: 'FED_OfferRollupsTruckloadTotalRollup';
                  } & Pick<
                    Fed_OfferRollupsTruckloadTotalRollup,
                    'totalTrucks' | 'totalGrossWeight' | 'totalCube'
                  >
                >;
                sizesByCategory: Array<
                  { __typename?: 'FED_OfferRollupsSizeByCategory' } & Pick<
                    Fed_OfferRollupsSizeByCategory,
                    'name'
                  > & {
                      totals?: Maybe<
                        {
                          __typename?: 'FED_OfferRollupsCategoryTotals';
                        } & Pick<
                          Fed_OfferRollupsCategoryTotals,
                          'draftTotalUnits'
                        >
                      >;
                      sizes: Array<
                        { __typename?: 'FED_OfferRollupsSize' } & Pick<
                          Fed_OfferRollupsSize,
                          'name' | 'draftTotalUnits'
                        >
                      >;
                    }
                >;
              }
            >;
            casepacks?: Maybe<
              { __typename?: 'FED_OfferRows' } & {
                pagination: { __typename?: 'FED_OfferRowsPagination' } & Pick<
                  Fed_OfferRowsPagination,
                  'totalElements'
                >;
              }
            >;
            items?: Maybe<
              { __typename?: 'FED_OfferRows' } & {
                pagination: { __typename?: 'FED_OfferRowsPagination' } & Pick<
                  Fed_OfferRowsPagination,
                  'totalElements'
                >;
              }
            >;
            unpriced?: Maybe<
              { __typename?: 'FED_OfferRows' } & {
                pagination: { __typename?: 'FED_OfferRowsPagination' } & Pick<
                  Fed_OfferRowsPagination,
                  'totalElements'
                >;
              }
            >;
          }
      >;
      creator?: Maybe<
        { __typename?: 'FED_User' } & Pick<
          Fed_User,
          'id' | 'userId' | 'firstName'
        > & {
            company?: Maybe<
              { __typename?: 'FED_Company' } & Pick<
                Fed_Company,
                'id' | 'name' | 'role' | 'avatarUrl'
              > & {
                  configuration?: Maybe<
                    { __typename?: 'FED_CompanyConfiguration' } & {
                      buyerAttributes: Array<
                        { __typename?: 'FED_BuyerAttribute' } & Pick<
                          Fed_BuyerAttribute,
                          'id' | 'label' | 'value' | 'attributeType'
                        >
                      >;
                    }
                  >;
                }
            >;
          }
      >;
      buyers: Array<
        { __typename?: 'FED_User' } & Pick<
          Fed_User,
          'id' | 'firstName' | 'lastName'
        > & {
            company?: Maybe<
              { __typename?: 'FED_Company' } & Pick<
                Fed_Company,
                'id' | 'name' | 'role' | 'avatarUrl'
              >
            >;
          }
      >;
      endNegotiationReasons: Array<
        Maybe<
          { __typename?: 'FED_EndNegotiationReason' } & Pick<
            Fed_EndNegotiationReason,
            'id' | 'type' | 'description'
          >
        >
      >;
      market?: Maybe<
        { __typename?: 'FED_Market' } & {
          currency?: Maybe<
            { __typename?: 'FED_Currency' } & Pick<
              Fed_Currency,
              'id' | 'code' | 'name' | 'symbol'
            >
          >;
        }
      >;
    } & Fed_NegotiationActionBar_ListingFragment &
    Fed_AdditionalSettings_ListingFragment &
    Fed_OfferBasicsContainer_ListingFragment &
    Fed_NegotiationSettings_ListingFragment &
    Fed_ProductsContainer_ListingFragment &
    Fed_TruckloadSettings_ListingFragment;
};

export type CreateOfferFormConnections_UserFragment = {
  __typename?: 'FED_User';
} & Pick<
  Fed_User,
  | 'avatarUrl'
  | 'email'
  | 'firstName'
  | 'id'
  | 'isPersonalEmail'
  | 'jobTitle'
  | 'lastName'
  | 'onboardingCompletedAt'
  | 'userId'
> & {
    company?: Maybe<
      { __typename?: 'FED_Company' } & Pick<
        Fed_Company,
        'id' | 'companyId' | 'name' | 'avatarUrl'
      >
    >;
  };

export type CreateOfferConnectionsQueryVariables = {};

export type CreateOfferConnectionsQuery = { __typename?: 'Query' } & {
  users?: Maybe<
    { __typename?: 'FED_Users' } & {
      nodes: Array<
        { __typename?: 'FED_User' } & CreateOfferFormConnections_UserFragment
      >;
    }
  >;
};

export type AdditionalBuyerSelectBuyerFragment = { __typename?: 'User' } & Pick<
  User,
  | 'avatarUrl'
  | 'companyId'
  | 'companyName'
  | 'companyUuid'
  | 'email'
  | 'firstName'
  | 'id'
  | 'isPersonalEmail'
  | 'jobTitle'
  | 'lastName'
  | 'onboardingCompletedAt'
  | 'uuid'
> & {
    company: { __typename?: 'Company' } & Pick<
      Company,
      'id' | 'uuid' | 'name'
    > & { logo?: Maybe<{ __typename?: 'File' } & Pick<File, 'src'>> };
  };

export type AdditionalBuyerSelect_Listing_V2Fragment = {
  __typename?: 'ListingV2';
} & Pick<ListingV2, 'id'> & {
    buyers: { __typename?: 'Users' } & {
      nodes?: Maybe<
        Array<{ __typename?: 'User' } & AdditionalBuyerSelectBuyerFragment>
      >;
    };
  };

export type AddictionalBuyerSearchUsersQueryQueryVariables = {
  filters: Array<Maybe<CoreApiFilter>>;
};

export type AddictionalBuyerSearchUsersQueryQuery = { __typename?: 'Query' } & {
  users?: Maybe<
    { __typename?: 'Users' } & {
      nodes?: Maybe<
        Array<{ __typename?: 'User' } & AdditionalBuyerSelectBuyerFragment>
      >;
    }
  >;
};

export type CreateOfferAddAdditionalBuyerMutationVariables = {
  listingId: Scalars['ID'];
  input?: Maybe<AddBuyerToListingInput>;
};

export type CreateOfferAddAdditionalBuyerMutation = {
  __typename?: 'Mutation';
} & {
  addBuyerToListingV2?: Maybe<
    { __typename?: 'ListingV2' } & Pick<ListingV2, 'id'> & {
        buyers: { __typename?: 'Users' } & {
          nodes?: Maybe<
            Array<{ __typename?: 'User' } & AdditionalBuyerSelectBuyerFragment>
          >;
        };
      }
  >;
};

export type Deprecated_AdditionalSettings_Listing_V2Fragment = {
  __typename?: 'ListingV2';
} & Pick<
  ListingV2,
  | 'showMsrp'
  | 'showWholesale'
  | 'showSizes'
  | 'purchasingRule'
  | 'otherRestrictions'
> & {
    visibleAttributes?: Maybe<
      { __typename?: 'VisibleAttributes' } & {
        nodes: Array<
          { __typename?: 'Attribute' } & Pick<
            Attribute,
            'id' | 'label' | 'attributeType'
          >
        >;
      }
    >;
  };

export type Fed_AdditionalSettings_ListingFragment = {
  __typename?: 'FED_Listing';
} & Pick<
  Fed_Listing,
  | 'showMsrp'
  | 'showWholesale'
  | 'showSizes'
  | 'otherRestrictions'
  | 'visibleAttributes'
>;

export type Deprecated_NegotiationSettings_Listing_V2Fragment = {
  __typename?: 'ListingV2';
} & Pick<ListingV2, 'allowCounterOffers' | 'purchasingRule' | 'endDate'>;

export type Fed_NegotiationSettings_ListingFragment = {
  __typename?: 'FED_Listing';
} & Pick<Fed_Listing, 'allowCounterOffers' | 'expirationDateTime'>;

export type Deprecated_BuyerSelectBuyerFragment = {
  __typename?: 'User';
} & Pick<
  User,
  | 'avatarUrl'
  | 'companyId'
  | 'companyName'
  | 'companyUuid'
  | 'email'
  | 'firstName'
  | 'id'
  | 'isPersonalEmail'
  | 'jobTitle'
  | 'lastName'
  | 'onboardingCompletedAt'
  | 'uuid'
> & {
    company: { __typename?: 'Company' } & Pick<
      Company,
      'id' | 'name' | 'uuid'
    > & { logo?: Maybe<{ __typename?: 'File' } & Pick<File, 'src'>> };
  };

export type Fed_BuyerSelectBuyerFragment = { __typename?: 'FED_User' } & Pick<
  Fed_User,
  | 'avatarUrl'
  | 'email'
  | 'firstName'
  | 'id'
  | 'isPersonalEmail'
  | 'jobTitle'
  | 'lastName'
  | 'onboardingCompletedAt'
  | 'userId'
> & {
    company?: Maybe<
      { __typename?: 'FED_Company' } & Pick<
        Fed_Company,
        'id' | 'companyId' | 'name' | 'avatarUrl'
      >
    >;
  };

export type Deprecated_BuyerSelect_Listing_V2Fragment = {
  __typename?: 'ListingV2';
} & Pick<ListingV2, 'id'> & {
    buyers: { __typename?: 'Users' } & {
      nodes?: Maybe<
        Array<{ __typename?: 'User' } & Deprecated_BuyerSelectBuyerFragment>
      >;
    };
  };

export type Fed_BuyerSelect_ListingFragment = {
  __typename?: 'FED_Listing';
} & Pick<Fed_Listing, 'id'> & {
    buyers: Array<{ __typename?: 'FED_User' } & Fed_BuyerSelectBuyerFragment>;
  };

export type SearchUsersQueryQueryVariables = {
  value: Scalars['AnyObject'];
};

export type SearchUsersQueryQueryVariablesUpdated = {
  value: Scalars['String'];
  companyId: Scalars['String'];
};

export type SearchUsersQueryQuery = { __typename?: 'Query' } & {
  users?: Maybe<
    { __typename?: 'FED_Users' } & {
      nodes: Array<{ __typename?: 'FED_User' } & Fed_BuyerSelectBuyerFragment>;
    }
  >;
};

export type CreateOfferAddBuyerMutationVariables = {
  listingId: Scalars['ID'];
  input?: Maybe<AddBuyerToListingInput>;
};

export type CreateOfferAddBuyerMutation = { __typename?: 'Mutation' } & {
  addBuyerToListingV2?: Maybe<
    { __typename?: 'ListingV2' } & Pick<ListingV2, 'id'> & {
        buyers: { __typename?: 'Users' } & {
          nodes?: Maybe<
            Array<{ __typename?: 'User' } & Deprecated_BuyerSelectBuyerFragment>
          >;
        };
      }
  >;
};

export type CreateOfferRemoveBuyerMutationVariables = {
  listingId: Scalars['ID'];
  input?: Maybe<RemoveBuyerFromListingInput>;
};

export type CreateOfferRemoveBuyerMutation = { __typename?: 'Mutation' } & {
  removeBuyerFromListingV2?: Maybe<
    { __typename?: 'ListingV2' } & Pick<ListingV2, 'id'> & {
        buyers: { __typename?: 'Users' } & {
          nodes?: Maybe<
            Array<{ __typename?: 'User' } & Deprecated_BuyerSelectBuyerFragment>
          >;
        };
      }
  >;
};

export type Deprecated_OfferBasicsContainer_Listing_V2Fragment = {
  __typename?: 'ListingV2';
} & Pick<ListingV2, 'title' | 'description' | 'marketId'> &
  Deprecated_BuyerSelect_Listing_V2Fragment;

export type Fed_OfferBasicsContainer_ListingFragment = {
  __typename?: 'FED_Listing';
} & Pick<Fed_Listing, 'title' | 'description'> & {
    market?: Maybe<{ __typename?: 'FED_Market' } & Pick<Fed_Market, 'id'>>;
  } & Fed_BuyerSelect_ListingFragment;

export type Deprecated_ProductsContainer_Listing_V2Fragment = {
  __typename?: 'ListingV2';
} & Pick<ListingV2, 'marketId' | 'parentGroupId'>;

export type Fed_ProductsContainer_ListingFragment = {
  __typename?: 'FED_Listing';
} & {
  market?: Maybe<{ __typename?: 'FED_Market' } & Pick<Fed_Market, 'id'>>;
  parentGroup?: Maybe<
    { __typename?: 'FED_Group' } & Pick<Fed_Group, 'id' | 'name'>
  >;
};

export type Fed_TruckloadSettings_ListingFragment = {
  __typename?: 'FED_Listing';
} & {
  truckload?: Maybe<
    { __typename?: 'FED_ListingTruckload' } & Pick<
      Fed_ListingTruckload,
      | 'truckloadMaxWeightPerTruck'
      | 'truckloadNumberOfTrucksForSize'
      | 'truckloadMinimumSize'
      | 'truckloadMaximumSize'
    >
  >;
};

export type Fed_UpdateListingTruckloadSettingsMutationVariables = {
  listingId: Scalars['ID'];
  truckloadMinimumSize?: Maybe<Scalars['Int']>;
  truckloadMaximumSize?: Maybe<Scalars['Int']>;
};

export type Fed_UpdateListingTruckloadSettingsMutation = {
  __typename?: 'Mutation';
} & {
  listingTruckloadSettingsUpdated: Mutation['FED_updateListingTruckloadSettings'];
};

export type CreateOfferCreateListingMutationVariables = {
  input: ListingInputV2;
};

export type CreateOfferCreateListingMutation = { __typename?: 'Mutation' } & {
  createListingV2?: Maybe<{ __typename?: 'ListingV2' } & Pick<ListingV2, 'id'>>;
};

export type Deprecated_CreateOfferUpdateListingMutationVariables = {
  listingId: Scalars['ID'];
  input: ListingInputV2;
  offerRowsFilterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
};

export type Deprecated_CreateOfferUpdateListingMutation = {
  __typename?: 'Mutation';
} & {
  updateListingV2: { __typename?: 'ListingV2' } & Pick<
    ListingV2,
    'id' | 'status'
  > & {
      buyers: { __typename?: 'Users' } & {
        nodes?: Maybe<Array<{ __typename?: 'User' } & Pick<User, 'id'>>>;
      };
    } & Deprecated_AdditionalSettings_Listing_V2Fragment &
    Deprecated_OfferBasicsContainer_Listing_V2Fragment &
    Deprecated_NegotiationActionBar_Listing_V2Fragment &
    Deprecated_NegotiationSettings_Listing_V2Fragment &
    Deprecated_ProductsContainer_Listing_V2Fragment;
};

export type OfferListListingsStateCountQueryVariables = {
  states?: Maybe<Array<Maybe<Fed_ListingState>>>;
  parentGroupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type OfferListListingsStateCountQuery = { __typename?: 'Query' } & {
  FED_listings: { __typename?: 'FED_ListingsConnection' } & {
    counts: { __typename?: 'FED_ListingsCounts' } & {
      states: Array<
        { __typename?: 'StatesFieldCount' } & Pick<
          StatesFieldCount,
          'key' | 'count'
        >
      >;
      companies: Array<
        { __typename?: 'CompaniesFieldCount' } & Pick<
          CompaniesFieldCount,
          'key' | 'count'
        > & {
            entity?: Maybe<
              { __typename?: 'FED_Company' } & Pick<Fed_Company, 'id' | 'name'>
            >;
          }
      >;
      markets: Array<
        { __typename?: 'MarketsFieldCount' } & Pick<
          MarketsFieldCount,
          'key' | 'count'
        > & {
            entity?: Maybe<
              { __typename?: 'FED_Market' } & Pick<
                Fed_Market,
                'id' | 'name'
              > & {
                  currency?: Maybe<
                    { __typename?: 'FED_Currency' } & Pick<
                      Fed_Currency,
                      'id' | 'symbol'
                    >
                  >;
                }
            >;
          }
      >;
      parentGroups: Array<
        { __typename?: 'ParentGroupsFieldCount' } & Pick<
          ParentGroupsFieldCount,
          'key' | 'count'
        > & {
            entity?: Maybe<
              { __typename?: 'FED_Group' } & Pick<Fed_Group, 'id' | 'name'>
            >;
          }
      >;
    };
  };
};

export type OfferStateCountQuery = { __typename?: 'Query' } & {
  FED_listings: { __typename?: 'FED_ListingsConnection' } & {
    counts: { __typename?: 'FED_ListingsCounts' } & {
      states: Array<
        { __typename?: 'StatesFieldCount' } & Pick<
          StatesFieldCount,
          'key' | 'count'
        >
      >;
    };
  };
};

export type OfferListListingsQueryVariables = {
  buyerCompanyId?: Maybe<Scalars['String']>;
  companyId: Scalars['ID'];
  filterCompanyIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  limit?: Maybe<Scalars['Int']>;
  marketIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  offset?: Maybe<Scalars['Int']>;
  parentGroupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  search?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<Fed_SortDirection>;
  sortKey?: Maybe<Scalars['String']>;
  states?: Maybe<Array<Maybe<Fed_ListingState>>>;
  filterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type OfferListListingsQuery = { __typename?: 'Query' } & {
  FED_listings: { __typename?: 'FED_ListingsConnection' } & {
    counts: { __typename?: 'FED_ListingsCounts' } & {
      states: Array<
        { __typename?: 'StatesFieldCount' } & Pick<
          StatesFieldCount,
          'key' | 'count'
        >
      >;
    };
    nodes: Array<
      { __typename?: 'FED_Listing' } & Pick<
        Fed_Listing,
        | 'id'
        | 'allowCounterOffers'
        | 'allowPickingItems'
        | 'allowPickingQuantities'
        | 'allowPickingSizes'
        | 'archivedAt'
        | 'canAccept'
        | 'lastModifiedDateTime'
        | 'publishedDateTime'
        | 'showSizes'
        | 'showWholesale'
        | 'showMsrp'
        | 'state'
        | 'status'
        | 'title'
      > & {
          parentGroup?: Maybe<
            { __typename?: 'FED_Group' } & Pick<Fed_Group, 'id'>
          >;
          creator?: Maybe<
            { __typename?: 'FED_User' } & Pick<
              Fed_User,
              'id' | 'firstName' | 'lastName'
            > & {
                company?: Maybe<
                  { __typename?: 'FED_Company' } & Pick<
                    Fed_Company,
                    'id' | 'name' | 'avatarUrl'
                  >
                >;
              }
          >;
          buyers: Array<
            { __typename?: 'FED_User' } & Pick<
              Fed_User,
              'id' | 'firstName' | 'lastName'
            >
          >;
          market?: Maybe<
            { __typename?: 'FED_Market' } & Pick<Fed_Market, 'id'> & {
                currency?: Maybe<
                  { __typename?: 'FED_Currency' } & Pick<
                    Fed_Currency,
                    'id' | 'code'
                  >
                >;
              }
          >;
          buyerCompanies?: Maybe<
            Array<
              Maybe<
                { __typename?: 'FED_Company' } & Pick<
                  Fed_Company,
                  'id' | 'name' | 'avatarUrl'
                >
              >
            >
          >;
          offers: Array<
            { __typename?: 'FED_Offer' } & Pick<
              Fed_Offer,
              'id' | 'isDraftEdited' | 'status' | 'version' | 'submittedAt'
            > & {
                seller: { __typename?: 'FED_User' } & Pick<
                  Fed_User,
                  'id' | 'firstName' | 'lastName'
                >;
                creator?: Maybe<
                  { __typename?: 'FED_User' } & Pick<
                    Fed_User,
                    'id' | 'firstName' | 'lastName'
                  >
                >;
                declineInfo?: Maybe<
                  { __typename?: 'FED_DeclineInfo' } & Pick<
                    Fed_DeclineInfo,
                    'reasons' | 'comment'
                  > & {
                      user?: Maybe<
                        { __typename?: 'FED_User' } & Pick<
                          Fed_User,
                          'id' | 'firstName' | 'lastName'
                        > & {
                            company?: Maybe<
                              { __typename?: 'FED_Company' } & Pick<
                                Fed_Company,
                                'id'
                              >
                            >;
                          }
                      >;
                    }
                >;
                rollups?: Maybe<
                  { __typename?: 'FED_OfferRollups' } & {
                    totals: {
                      __typename?: 'FED_OfferRollupsTotalRollup';
                    } & Pick<
                      Fed_OfferRollupsTotalRollup,
                      | 'draftTotalPrice'
                      | 'draftTotalUnits'
                      | 'totalMsrp'
                      | 'totalMsrpOff'
                      | 'totalWhl'
                      | 'totalWhlOff'
                      | 'totalElements'
                      | 'totalUnpriced'
                      | 'avgMargin'
                      | 'totalMargin'
                      | 'totalMarginUnpriced'
                      | 'totalProfit'
                      | 'totalProfitUnpriced'
                      | 'totalCost'
                      | 'totalCostUnpriced'
                      | 'avgRetail'
                      | 'totalRetail'
                      | 'totalRetailUnpriced'
                    >;
                  }
                >;
              }
          >;
        }
    >;
    pagination: { __typename?: 'FED_ListingsPagination' } & Pick<
      Fed_ListingsPagination,
      'limit' | 'count' | 'offset' | 'total'
    >;
  };
  FED_company: { __typename?: 'FED_Company' } & Pick<Fed_Company, 'id'> & {
      configuration?: Maybe<
        { __typename?: 'FED_CompanyConfiguration' } & Pick<
          Fed_CompanyConfiguration,
          'vertoFormat'
        >
      >;
    };
};

export type NegotiationBulkActionUpdateOfferRowsMutationVariables = {
  input?: Maybe<UpdateOfferRowsInput>;
  listingCreatorCompanyUUID?: Maybe<Scalars['String']>;
  offerId?: Maybe<Scalars['String']>;
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
};

export type NegotiationBulkActionUpdateOfferRowsMutation = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'updateOfferRows'>;

export type Fed_NegotiationSelectedOfferRowsQueryVariables = {
  buyerCompanyUUID?: Maybe<Scalars['String']>;
  filterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
  listingCreatorCompanyUUID: Scalars['String'];
  listingUUID: Scalars['String'];
};

export type Fed_NegotiationSelectedOfferRowsQuery = { __typename?: 'Query' } & {
  rollups: { __typename?: 'FED_OfferRollups' } & {
    totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
      Fed_OfferRollupsTotalRollup,
      | 'avgCost'
      | 'avgMargin'
      | 'avgMarkup'
      | 'avgMsrp'
      | 'totalMsrpOff'
      | 'avgRetail'
      | 'avgUnitPrice'
      | 'avgWhl'
      | 'totalWhlOff'
      | 'draftTotalPrice'
      | 'draftTotalUnits'
      | 'totalCost'
      | 'totalMsrp'
      | 'totalProfit'
      | 'totalRetail'
      | 'totalUnpriced'
      | 'totalWhl'
      | 'uniqueProducts'
      | 'totalElements'
    >;
  };
};

export type Fed_NegotiationBulkActionsBarTotalAvailableUnitsQueryVariables = {
  buyerCompanyUUID?: Maybe<Scalars['String']>;
  filterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
  listingCreatorCompanyUUID: Scalars['String'];
  listingUUID: Scalars['String'];
};

export type Fed_NegotiationBulkActionsBarTotalAvailableUnitsQuery = {
  __typename?: 'Query';
} & {
  rollups: { __typename?: 'FED_OfferRollups' } & {
    totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
      Fed_OfferRollupsTotalRollup,
      'draftTotalUnits'
    >;
  };
};

export type BulkAddOfferCasepacksMutationVariables = {
  filters: Array<Maybe<CoreApiFilter>>;
  key: Scalars['String'];
  offerId: Scalars['ID'];
  quantity?: Maybe<Scalars['Int']>;
};

export type BulkAddOfferCasepacksMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'bulkAddOfferCasepacks'
>;

export type BulkAddOfferItemsMutationVariables = {
  filters: Array<Maybe<CoreApiFilter>>;
  key: Scalars['String'];
  offerId: Scalars['ID'];
  quantity?: Maybe<Scalars['Int']>;
};

export type BulkAddOfferItemsMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'bulkAddOfferItems'
>;

export type NegotiationMoveUnitsOutOfNegotiationMutationVariables = {
  companyUUID?: Maybe<Scalars['String']>;
  filterGroups: Array<Maybe<SearchServiceFilterGroup>>;
  groupId: Scalars['String'];
  offerId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['AnyObject']>;
};

export type NegotiationMoveUnitsOutOfNegotiationMutation = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'moveUnitsOutOfNegotiation'>;

export type CategoryRollupUpdateCategoryPercentOffMsrpMutationVariables = {
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  listingCreatorCompanyUUID: Scalars['String'];
  offerUUID: Scalars['String'];
  value: Scalars['Float'];
  context?: Maybe<Scalars['AnyObject']>;
};

export type CategoryRollupUpdateCategoryPercentOffMsrpMutation = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'updateOfferRows'>;

export type CategoryRollupUpdateCategoryPercentOffWhlMutationVariables = {
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  listingCreatorCompanyUUID: Scalars['String'];
  offerUUID: Scalars['String'];
  value: Scalars['Float'];
  context?: Maybe<Scalars['AnyObject']>;
};

export type CategoryRollupUpdateCategoryPercentOffWhlMutation = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'updateOfferRows'>;

export type CategoryRollupUpdateCategoryTotalPriceMutationVariables = {
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  listingCreatorCompanyUUID: Scalars['String'];
  offerUUID: Scalars['String'];
  value: Scalars['Float'];
  context?: Maybe<Scalars['AnyObject']>;
};

export type CategoryRollupUpdateCategoryTotalPriceMutation = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'updateOfferRows'>;

export type CategoryRollupUpdateItemsPercentOffMsrpMutationVariables = {
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  listingCreatorCompanyUUID: Scalars['String'];
  offerUUID: Scalars['String'];
  value: Scalars['Float'];
  context?: Maybe<Scalars['AnyObject']>;
};

export type CategoryRollupUpdateItemsPercentOffMsrpMutation = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'updateOfferRows'>;

export type CategoryRollupUpdateItemsPercentOffWhlMutationVariables = {
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  listingCreatorCompanyUUID: Scalars['String'];
  offerUUID: Scalars['String'];
  value: Scalars['Float'];
  context?: Maybe<Scalars['AnyObject']>;
};

export type CategoryRollupUpdateItemsPercentOffWhlMutation = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'updateOfferRows'>;

export type CategoryRollupUpdateItemsTotalPriceMutationVariables = {
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  listingCreatorCompanyUUID: Scalars['String'];
  offerUUID: Scalars['String'];
  value: Scalars['Float'];
  context?: Maybe<Scalars['AnyObject']>;
};

export type CategoryRollupUpdateItemsTotalPriceMutation = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'updateOfferRows'>;

export type CategoryRollupAllProductsCountQueryVariables = {
  buyerCompanyUUID?: Maybe<Scalars['String']>;
  listingCreatorCompanyUUID: Scalars['String'];
  listingUUID: Scalars['String'];
  offerUUID: Scalars['AnyObject'];
};

export type CategoryRollupAllProductsCountQuery = { __typename?: 'Query' } & {
  casepacks: { __typename?: 'FED_OfferRollups' } & {
    totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
      Fed_OfferRollupsTotalRollup,
      | 'draftTotalPrice'
      | 'draftTotalUnits'
      | 'totalMsrpOff'
      | 'totalWhlOff'
      | 'totalElements'
    > & { totalMargin: Fed_OfferRollupsTotalRollup['avgMargin'] };
  };
  items: { __typename?: 'FED_OfferRollups' } & {
    sizesByCategory: Array<
      { __typename?: 'FED_OfferRollupsSizeByCategory' } & Pick<
        Fed_OfferRollupsSizeByCategory,
        'name'
      > & {
          totals?: Maybe<
            { __typename?: 'FED_OfferRollupsCategoryTotals' } & Pick<
              Fed_OfferRollupsCategoryTotals,
              | 'draftTotalPrice'
              | 'draftTotalUnits'
              | 'totalMargin'
              | 'totalMsrpOff'
              | 'totalWhlOff'
              | 'uniqueProducts'
            >
          >;
        }
    >;
    totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
      Fed_OfferRollupsTotalRollup,
      | 'draftTotalPrice'
      | 'draftTotalUnits'
      | 'totalMsrpOff'
      | 'totalWhlOff'
      | 'totalElements'
    > & { totalMargin: Fed_OfferRollupsTotalRollup['avgMargin'] };
  };
};

export type Fed_CategorySummaryQueryQueryVariables = {
  buyerCompanyUUID?: Maybe<Scalars['String']>;
  listingCreatorCompanyUUID: Scalars['String'];
  listingUUID: Scalars['String'];
  offerUUID: Scalars['AnyObject'];
};

export type Fed_CategorySummaryQueryQuery = { __typename?: 'Query' } & {
  items: { __typename?: 'FED_OfferRollups' } & {
    categoryRollups?: Maybe<
      Array<
        { __typename?: 'FED_CategoryRollups' } & {
          categoryName: Fed_CategoryRollups['name'];
        } & {
          totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & {
            totalPrice: Fed_OfferRollupsTotalRollup['draftTotalPrice'];
            totalUnits: Fed_OfferRollupsTotalRollup['draftTotalUnits'];
            totalProducts: Fed_OfferRollupsTotalRollup['totalProductsInOffer'];
            margin: Fed_OfferRollupsTotalRollup['avgMargin'];
            msrpOff: Fed_OfferRollupsTotalRollup['totalMsrpOff'];
            whlOff: Fed_OfferRollupsTotalRollup['totalWhlOff'];
          };
        }
      >
    >;
    totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & {
      totalPrice: Fed_OfferRollupsTotalRollup['draftTotalPrice'];
      totalUnits: Fed_OfferRollupsTotalRollup['draftTotalUnits'];
      totalProducts: Fed_OfferRollupsTotalRollup['totalProductsInOffer'];
      margin: Fed_OfferRollupsTotalRollup['avgMargin'];
      msrpOff: Fed_OfferRollupsTotalRollup['totalMsrpOff'];
      whlOff: Fed_OfferRollupsTotalRollup['totalWhlOff'];
    };
  };
};

export type NegotiationLinesheetHeaderCompanyQueryVariables = {
  id: Scalars['ID'];
};

export type NegotiationLinesheetHeaderCompanyQuery = {
  __typename?: 'Query';
} & {
  company: { __typename?: 'FED_Company' } & Pick<
    Fed_Company,
    'id' | 'avatarUrl' | 'name'
  >;
};

export type Fed_NegotiationListingContextQueryVariables = {
  listingId: Scalars['ID'];
  offerRowsFilterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
  includeDeletedUsers?: Maybe<Scalars['Boolean']>;
};

export type Fed_NegotiationListingContextQuery = { __typename?: 'Query' } & {
  listing: { __typename?: 'FED_Listing' } & Pick<
    Fed_Listing,
    | 'id'
    | 'allowCounterOffers'
    | 'allowPickingItems'
    | 'allowPickingQuantities'
    | 'allowPickingSizes'
    | 'canAccept'
    | 'title'
    | 'status'
    | 'state'
    | 'showMsrp'
    | 'showSizes'
    | 'showWholesale'
    | 'visibleAttributes'
    | 'description'
    | 'customPo'
    | 'otherRestrictions'
    | 'endDateTime'
    | 'expirationDateTime'
  > & {
      parentGroup?: Maybe<{ __typename?: 'FED_Group' } & Pick<Fed_Group, 'id'>>;
      truckload?: Maybe<
        { __typename?: 'FED_ListingTruckload' } & Pick<
          Fed_ListingTruckload,
          'truckloadMinimumSize' | 'truckloadMaximumSize'
        >
      >;
      buyers: Array<
        { __typename?: 'FED_User' } & Pick<
          Fed_User,
          'id' | 'firstName' | 'lastName'
        > & {
            company?: Maybe<
              { __typename?: 'FED_Company' } & Pick<
                Fed_Company,
                'id' | 'name' | 'avatarUrl'
              >
            >;
          }
      >;
      buyerCompanies?: Maybe<
        Array<
          Maybe<
            { __typename?: 'FED_Company' } & Pick<
              Fed_Company,
              'name' | 'avatarUrl'
            >
          >
        >
      >;
      creator?: Maybe<
        { __typename?: 'FED_User' } & Pick<Fed_User, 'id'> & {
            company?: Maybe<
              { __typename?: 'FED_Company' } & Pick<Fed_Company, 'id' | 'name'>
            >;
          }
      >;
      market?: Maybe<
        { __typename?: 'FED_Market' } & Pick<Fed_Market, 'id'> & {
            currency?: Maybe<
              { __typename?: 'FED_Currency' } & Pick<
                Fed_Currency,
                'id' | 'code'
              >
            >;
          }
      >;
      endNegotiationReasons: Array<
        Maybe<
          { __typename?: 'FED_EndNegotiationReason' } & Pick<
            Fed_EndNegotiationReason,
            'id' | 'type'
          >
        >
      >;
      offers: Array<
        { __typename?: 'FED_Offer' } & Pick<
          Fed_Offer,
          | 'id'
          | 'isCurrent'
          | 'status'
          | 'version'
          | 'isDraftEdited'
          | 'submittedAt'
          | 'updatedAt'
        > & {
            declineInfo?: Maybe<
              { __typename?: 'FED_DeclineInfo' } & {
                user?: Maybe<
                  { __typename?: 'FED_User' } & Pick<
                    Fed_User,
                    'id' | 'firstName' | 'lastName'
                  > & {
                      company?: Maybe<
                        { __typename?: 'FED_Company' } & Pick<Fed_Company, 'id'>
                      >;
                    }
                >;
              }
            >;
            seller: { __typename?: 'FED_User' } & Pick<
              Fed_User,
              'id' | 'firstName' | 'lastName'
            > & {
                company?: Maybe<
                  { __typename?: 'FED_Company' } & Pick<
                    Fed_Company,
                    'id' | 'name' | 'avatarUrl'
                  >
                >;
              };
            creator?: Maybe<
              { __typename?: 'FED_User' } & Pick<
                Fed_User,
                'id' | 'firstName'
              > & {
                  company?: Maybe<
                    { __typename?: 'FED_Company' } & Pick<
                      Fed_Company,
                      'id' | 'role'
                    >
                  >;
                }
            >;
            rollups?: Maybe<
              { __typename?: 'FED_OfferRollups' } & {
                totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
                  Fed_OfferRollupsTotalRollup,
                  | 'uniqueProducts'
                  | 'totalUnpriced'
                  | 'draftTotalUnits'
                  | 'draftTotalPrice'
                  | 'avgMargin'
                  | 'totalMsrp'
                  | 'totalMsrpOff'
                  | 'totalWhl'
                  | 'totalWhlOff'
                  | 'totalElements'
                  | 'totalProfit'
                >;
                truckloadTotals?: Maybe<
                  {
                    __typename?: 'FED_OfferRollupsTruckloadTotalRollup';
                  } & Pick<
                    Fed_OfferRollupsTruckloadTotalRollup,
                    'totalTrucks' | 'totalGrossWeight' | 'totalCube'
                  >
                >;
                sizesByCategory: Array<
                  { __typename?: 'FED_OfferRollupsSizeByCategory' } & Pick<
                    Fed_OfferRollupsSizeByCategory,
                    'name'
                  > & {
                      totals?: Maybe<
                        {
                          __typename?: 'FED_OfferRollupsCategoryTotals';
                        } & Pick<
                          Fed_OfferRollupsCategoryTotals,
                          'draftTotalUnits'
                        >
                      >;
                      sizes: Array<
                        { __typename?: 'FED_OfferRollupsSize' } & Pick<
                          Fed_OfferRollupsSize,
                          'name' | 'draftTotalUnits'
                        >
                      >;
                    }
                >;
              }
            >;
          }
      >;
    };
};

export type NegotiationRollupQueryVariables = {
  buyerCompanyUUID?: Maybe<Scalars['String']>;
  filterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
  listingCreatorCompanyUUID: Scalars['String'];
  listingUUID: Scalars['String'];
};

export type NegotiationRollupQuery = { __typename?: 'Query' } & {
  rows: { __typename?: 'FED_OfferRollups' } & {
    totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
      Fed_OfferRollupsTotalRollup,
      | 'avgCost'
      | 'avgMargin'
      | 'avgMarkup'
      | 'avgMsrp'
      | 'totalMsrpOff'
      | 'avgRetail'
      | 'avgUnitPrice'
      | 'avgWhl'
      | 'totalWhlOff'
      | 'draftTotalPrice'
      | 'draftTotalUnits'
      | 'initialTotalUnits'
      | 'totalCost'
      | 'totalMsrp'
      | 'totalProfit'
      | 'totalRetail'
      | 'totalUnpriced'
      | 'totalRetailUnpriced'
      | 'totalCostUnpriced'
      | 'totalWhl'
      | 'uniqueProducts'
      | 'totalElements'
      | 'totalCases'
      | 'avgCasePrice'
    >;
    truckloadTotals?: Maybe<
      { __typename?: 'FED_OfferRollupsTruckloadTotalRollup' } & Pick<
        Fed_OfferRollupsTruckloadTotalRollup,
        | 'totalGrossWeight'
        | 'totalCube'
        | 'totalTrucks'
        | 'totalQuantity'
        | 'totalUnits'
        | 'totalCases'
      >
    >;
  };
};

export type NegotiationPdpOfferRowAttributeFragment = {
  __typename?: 'FED_OfferRowAttribute';
} & Pick<Fed_OfferRowAttribute, 'id' | 'inturnType' | 'label' | 'value'>;

export type NegotiationPdpOfferRowPackageCategorySizeSizeFragment = {
  __typename?: 'FED_OfferRowPackageCategorySizeSize';
} & Pick<
  Fed_OfferRowPackageCategorySizeSize,
  | 'id'
  | 'label'
  | 'currentUnits'
  | 'draftUnits'
  | 'initialUnits'
  | 'hasMultipleDimensions'
  | 'unitsPerPackageCategorySize'
>;

export type NegotiationPdpOfferRowPackageFragment = {
  __typename?: 'FED_OfferRowPackage';
} & Pick<
  Fed_OfferRowPackage,
  | 'id'
  | 'initialUnits'
  | 'currentUnits'
  | 'draftUnits'
  | 'initialPackageQuantity'
  | 'currentPackageQuantity'
  | 'draftPackageQuantity'
  | 'packageCost'
  | 'packageMsrp'
  | 'packageWholesale'
  | 'unitsPerPackage'
> & {
    categorySizes?: Maybe<
      { __typename?: 'FED_OfferRowPackageCategorySizes' } & {
        nodes: Array<
          { __typename?: 'FED_OfferRowPackageCategorySize' } & {
            sizes?: Maybe<
              { __typename?: 'FED_OfferRowPackageCategorySizeSizes' } & {
                nodes: Array<
                  {
                    __typename?: 'FED_OfferRowPackageCategorySizeSize';
                  } & NegotiationPdpOfferRowPackageCategorySizeSizeFragment
                >;
              }
            >;
          }
        >;
      }
    >;
  };

export type NegotiationPdpOfferRowProductFragment = {
  __typename?: 'FED_OfferRowProductDetail';
} & Pick<Fed_OfferRowProductDetail, 'uuid' | 'name' | 'sku' | 'description'> & {
    attributes: { __typename?: 'FED_OfferRowAttributes' } & {
      nodes: Array<
        {
          __typename?: 'FED_OfferRowAttribute';
        } & NegotiationPdpOfferRowAttributeFragment
      >;
    };
    packages: { __typename?: 'FED_OfferRowProductPackages' } & {
      nodes: Array<
        { __typename?: 'FED_OfferRowProductPackage' } & Pick<
          Fed_OfferRowProductPackage,
          'uuid'
        > & {
            variants: { __typename?: 'FED_OfferRowProductPackageVariants' } & {
              nodes: Array<
                { __typename?: 'FED_OfferRowProductPackageVariant' } & Pick<
                  Fed_OfferRowProductPackageVariant,
                  'uuid' | 'ratio' | 'position'
                >
              >;
            };
            groups: { __typename?: 'FED_OfferRowProductPackageGroups' } & {
              nodes: Array<
                { __typename?: 'FED_OfferRowProductPackageGroup' } & Pick<
                  Fed_OfferRowProductPackageGroup,
                  'uuid' | 'available'
                >
              >;
            };
          }
      >;
    };
    variants: { __typename?: 'FED_OfferRowVariants' } & {
      nodes: Array<
        { __typename?: 'FED_OfferRowVariant' } & Pick<
          Fed_OfferRowVariant,
          'uuid'
        > & {
            images?: Maybe<
              { __typename?: 'FED_OfferRowVariantImages' } & {
                nodes: Array<
                  { __typename?: 'FED_OfferRowVariantImage' } & Pick<
                    Fed_OfferRowVariantImage,
                    'src'
                  >
                >;
              }
            >;
            options: { __typename?: 'FED_OfferRowVariantOptions' } & {
              nodes: Array<
                { __typename?: 'FED_OfferRowVariantOption' } & Pick<
                  Fed_OfferRowVariantOption,
                  'inturnType' | 'name' | 'value' | 'valueUuid'
                >
              >;
            };
          }
      >;
    };
  };

export type NegotiationPdpOfferRowFragment = {
  __typename?: 'FED_OfferRow';
} & Pick<
  Fed_OfferRow,
  | 'id'
  | 'createdAt'
  | 'unitCost'
  | 'unitMsrp'
  | 'unitRetail'
  | 'unitWholesale'
  | 'margin'
  | 'markup'
  | 'draftPercentageOffMsrp'
  | 'currentPercentageOffMsrp'
  | 'draftPercentageOffWholesale'
  | 'currentPercentageOffWholesale'
  | 'name'
  | 'notes'
  | 'kind'
  | 'currentTotalPrice'
  | 'currentTotalUnits'
  | 'currentUnitPrice'
  | 'currentPackagePrice'
  | 'description'
  | 'draftTotalPrice'
  | 'draftTotalUnits'
  | 'draftUnitPrice'
  | 'draftPackagePrice'
  | 'initialTotalPrice'
  | 'initialTotalUnits'
  | 'initialUnitPrice'
  | 'initialPackagePrice'
  | 'updatedAt'
> & {
    attributes: { __typename?: 'FED_OfferRowAttributes' } & {
      nodes: Array<
        {
          __typename?: 'FED_OfferRowAttribute';
        } & NegotiationPdpOfferRowAttributeFragment
      >;
    };
    images: { __typename?: 'FED_OfferRowImages' } & {
      nodes: Array<
        { __typename?: 'FED_OfferRowImage' } & Pick<
          Fed_OfferRowImage,
          'id' | 'src' | 'colorMatch'
        >
      >;
    };
    skus: { __typename?: 'FED_OfferRowSkus' } & {
      nodes: Array<
        { __typename?: 'FED_OfferRowSku' } & Pick<Fed_OfferRowSku, 'value'>
      >;
    };
    packages: { __typename?: 'FED_OfferRowPackages' } & {
      nodes: Array<
        {
          __typename?: 'FED_OfferRowPackage';
        } & NegotiationPdpOfferRowPackageFragment
      >;
    };
    products?: Maybe<
      { __typename?: 'FED_OfferRowProducts' } & {
        nodes: Array<
          {
            __typename?: 'FED_OfferRowProductDetail';
          } & NegotiationPdpOfferRowProductFragment
        >;
      }
    >;
    productIds: { __typename?: 'FED_OfferRowProductIds' } & {
      nodes: Array<
        { __typename?: 'FED_OfferRowProductId' } & Pick<
          Fed_OfferRowProductId,
          'value'
        >
      >;
    };
  };

export type NegotiationPdpOfferRowsQueryVariables = {
  buyerCompanyUUID?: Maybe<Scalars['String']>;
  filterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
  listingCreatorCompanyUUID: Scalars['String'];
  listingUUID: Scalars['String'];
};

export type NegotiationPdpOfferRowsQuery = { __typename?: 'Query' } & {
  rows: { __typename?: 'FED_OfferRows' } & {
    nodes: Array<
      { __typename?: 'FED_OfferRow' } & NegotiationPdpOfferRowFragment
    >;
  };
  rollups: { __typename?: 'FED_OfferRollups' } & {
    totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
      Fed_OfferRollupsTotalRollup,
      'draftTotalUnits'
    >;
  };
};

export type NegotiationProductsRollupQueryVariables = {
  key: Scalars['String'];
  entity: Scalars['String'];
  filters?: Maybe<Array<Maybe<CoreApiFilter>>>;
};

export type NegotiationProductsRollupQuery = { __typename?: 'Query' } & {
  inventoryProductsRollup: { __typename?: 'InventoryProductsRollup' } & Pick<
    InventoryProductsRollup,
    'id' | 'allHaveCost' | 'allHaveMsrp' | 'allHaveWholesale'
  > & {
      totalCost?: Maybe<
        { __typename?: 'Metric' } & Pick<Metric, 'displayValue'>
      >;
      totalItems: { __typename?: 'Metric' } & Pick<Metric, 'displayValue'>;
      totalMsrp: { __typename?: 'Metric' } & Pick<Metric, 'displayValue'>;
      totalUnits: { __typename?: 'Metric' } & Pick<Metric, 'displayValue'>;
      totalWholesale: { __typename?: 'Metric' } & Pick<Metric, 'displayValue'>;
      totalCasepacks: { __typename?: 'Metric' } & Pick<Metric, 'displayValue'>;
    };
};

export type NegotiationSyncListingDataMutationVariables = {
  listingId: Scalars['String'];
};

export type NegotiationSyncListingDataMutation = { __typename?: 'Mutation' } & {
  syncListing?: Maybe<
    { __typename?: 'BooleanResult' } & Pick<BooleanResult, 'ok'>
  >;
};

export type UpdateBidSizeMutationVariables = {
  id: Scalars['ID'];
  offerId: Scalars['ID'];
  bidId?: Maybe<Scalars['ID']>;
  input?: Maybe<UpdateBidSizingInput>;
  productKind?: Maybe<Scalars['String']>;
};

export type UpdateBidSizeMutation = { __typename?: 'Mutation' } & {
  updateBidSize?: Maybe<
    { __typename?: 'OfferBidSize' } & Pick<OfferBidSize, 'id'> & {
        available?: Maybe<{ __typename?: 'Metric' } & Pick<Metric, 'value'>>;
        included?: Maybe<{ __typename?: 'Metric' } & Pick<Metric, 'value'>>;
      }
  >;
};

export type UpdateBidTotalUnitsMutationVariables = {
  offerId: Scalars['ID'];
  bidId?: Maybe<Scalars['ID']>;
  input?: Maybe<UpdateBidTotalUnitsInput>;
  productKind?: Maybe<Scalars['String']>;
};

export type UpdateBidTotalUnitsMutation = { __typename?: 'Mutation' } & {
  updateBidTotalUnits?: Maybe<
    { __typename?: 'Bid' } & Pick<Bid, 'id' | 'quantity' | 'isRemoved'> & {
        sizes?: Maybe<
          { __typename?: 'OfferBidSizes' } & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'OfferBidSize' } & Pick<OfferBidSize, 'id'> & {
                      included?: Maybe<
                        { __typename?: 'Metric' } & Pick<
                          Metric,
                          'value' | 'displayValue'
                        >
                      >;
                    }
                >
              >
            >;
          }
        >;
      }
  >;
};

export type Fed_BulkUpdateCspKsMutationVariables = {
  listingId: Scalars['ID'];
  offerId: Scalars['ID'];
  update?: Maybe<Fed_Update>;
  buyerRetailPrice?: Maybe<Scalars['Float']>;
  context?: Maybe<Scalars['AnyObject']>;
  searchKey: Scalars['String'];
};

export type Fed_BulkUpdateCspKsMutation = { __typename?: 'Mutation' } & {
  isSuccessful: Mutation['FED_bulkUpdateCSPKs'];
};

export type Fed_BulkUpdateLooseItemsMutationVariables = {
  listingId: Scalars['ID'];
  offerId: Scalars['ID'];
  update?: Maybe<Fed_Update>;
  buyerRetailPrice?: Maybe<Scalars['Float']>;
  context?: Maybe<Scalars['AnyObject']>;
  searchKey: Scalars['String'];
  packageID?: Maybe<Scalars['ID']>;
};

export type Fed_BulkUpdateLooseItemsMutation = { __typename?: 'Mutation' } & {
  isSuccessful: Mutation['FED_bulkUpdateLooseItems'];
};

export type EndOfferMutationVariables = {
  groupId: Scalars['String'];
  input: EndOfferInput;
  offerId: Scalars['String'];
  sellerCompanyId: Scalars['String'];
  userUUID: Scalars['String'];
};

export type EndOfferMutation = { __typename?: 'Mutation' } & {
  endOffer: { __typename?: 'BooleanResult' } & Pick<BooleanResult, 'ok'>;
};

export type BulkUpdateFilterKeyQueryVariables = {
  companyUUID: Scalars['ID'];
  entityType: FilterKeyEntityType;
  query: SearchQueryType;
};

export type BulkUpdateFilterKeyQuery = { __typename?: 'Query' } & {
  bulkUpdateFilterKeyData?: Maybe<
    { __typename?: 'SearchServiceFilterKey' } & Pick<
      SearchServiceFilterKey,
      'data'
    >
  >;
};

export type NegotiationMoveUnitsMutationVariables = {
  companyUUID?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['AnyObject']>;
  entityType: EntityType;
  filterGroups: Array<Maybe<SearchServiceFilterGroup>>;
  groupId: Scalars['String'];
  moves: Array<Maybe<SearchServiceMoveData>>;
  uploadChannelId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
  singleRowUpdate?: Maybe<Scalars['Boolean']>;
};

export type NegotiationMoveUnitsMutation = { __typename?: 'Mutation' } & {
  isSuccessful: Mutation['searchServiceMoveUnits'];
};

export type Fed_UpdateOfferRowMutationVariables = {
  input?: Maybe<Fed_UpdateOfferRowRequest>;
};

export type Fed_UpdateOfferRowMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'FED_updateOfferRow'
>;

export type Fed_SubmitOfferMutationVariables = {
  offerId: Scalars['ID'];
  listingId: Scalars['ID'];
  uploadChannelId: Scalars['ID'];
  context: Fed_SubmitOfferContext;
};

export type Fed_SubmitOfferMutation = { __typename?: 'Mutation' } & {
  workflowId: Mutation['FED_submitOffer'];
};

export type Fed_UpdateNotesMutationVariables = {
  input: UpdateNotesInput;
};

export type Fed_UpdateNotesMutation = { __typename?: 'Mutation' } & {
  ok: Mutation['FED_updateNotes'];
};

export type NegotiationTableUpdateOfferRowsMutationVariables = {
  input?: Maybe<UpdateOfferRowsInput>;
  listingCreatorCompanyUUID?: Maybe<Scalars['String']>;
  offerId?: Maybe<Scalars['String']>;
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  isAsync?: Maybe<Scalars['Boolean']>;
};

export type NegotiationTableUpdateOfferRowsMutation = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'updateOfferRows'>;

export type Fed_WithdrawOfferMutationVariables = {
  input?: Maybe<Fed_WithdrawOfferRequest>;
};

export type Fed_WithdrawOfferMutation = { __typename?: 'Mutation' } & {
  workflowId: Mutation['FED_withdrawOffer'];
};

export type Fed_NegotiationAllEntitiesCountsQueryVariables = {
  buyerCompanyUUID?: Maybe<Scalars['String']>;
  listingCreatorCompanyUUID: Scalars['String'];
  listingUUID: Scalars['String'];
  offerUUID?: Maybe<Scalars['AnyObject']>;
};

export type Fed_NegotiationAllEntitiesCountsQuery = { __typename?: 'Query' } & {
  casepacks: { __typename?: 'FED_OfferRollups' } & {
    totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
      Fed_OfferRollupsTotalRollup,
      'withoutImages' | 'totalElements'
    >;
  };
  items: { __typename?: 'FED_OfferRollups' } & {
    totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
      Fed_OfferRollupsTotalRollup,
      'withoutImages' | 'totalElements'
    >;
  };
};

export type NegotiationListingCompanyOffersQueryVariables = {
  listingId: Scalars['ID'];
  buyerCompanyId: Scalars['ID'];
  currentCompanyId: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
};

export type NegotiationListingCompanyOffersQuery = { __typename?: 'Query' } & {
  listingCompanyOffers?: Maybe<
    { __typename?: 'ListingCompanyOffers' } & {
      nodes: Array<
        { __typename?: 'Offer' } & Pick<
          Offer,
          | 'id'
          | 'isCurrent'
          | 'isDraftEdited'
          | 'listingTitle'
          | 'status'
          | 'version'
        > & {
            buyers?: Maybe<
              { __typename?: 'Buyers' } & {
                nodes?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'User' } & Pick<User, 'id'> & {
                          company: { __typename?: 'Company' } & Pick<
                            Company,
                            'id' | 'uuid'
                          > & {
                              logo?: Maybe<
                                { __typename?: 'File' } & Pick<File, 'src'>
                              >;
                            };
                        }
                    >
                  >
                >;
              }
            >;
          }
      >;
    }
  >;
};

export type LegacyNegotiationMeIdQueryQueryVariables = {};

export type LegacyNegotiationMeIdQueryQuery = { __typename?: 'Query' } & {
  me?: Maybe<{ __typename?: 'Me' } & Pick<Me, 'id' | 'companyId'>>;
};

export type NegotiationOfferRowAttributeFragment = {
  __typename?: 'FED_OfferRowAttribute';
} & Pick<Fed_OfferRowAttribute, 'id' | 'label' | 'value' | 'inturnType'>;

export type NegotiationOfferRowPackageCategorySizeSizeFragment = {
  __typename?: 'FED_OfferRowPackageCategorySizeSize';
} & Pick<
  Fed_OfferRowPackageCategorySizeSize,
  | 'id'
  | 'label'
  | 'currentUnits'
  | 'draftUnits'
  | 'initialUnits'
  | 'hasMultipleDimensions'
>;

export type NegotiationOfferRowPackageFragment = {
  __typename?: 'FED_OfferRowPackage';
} & Pick<
  Fed_OfferRowPackage,
  | 'id'
  | 'initialUnits'
  | 'currentUnits'
  | 'draftUnits'
  | 'initialPackageQuantity'
  | 'currentPackageQuantity'
  | 'draftPackageQuantity'
  | 'packageCost'
  | 'packageMsrp'
  | 'packageWholesale'
  | 'unitsPerPackage'
> & {
    categorySizes?: Maybe<
      { __typename?: 'FED_OfferRowPackageCategorySizes' } & {
        nodes: Array<
          { __typename?: 'FED_OfferRowPackageCategorySize' } & {
            sizes?: Maybe<
              { __typename?: 'FED_OfferRowPackageCategorySizeSizes' } & {
                nodes: Array<
                  {
                    __typename?: 'FED_OfferRowPackageCategorySizeSize';
                  } & NegotiationOfferRowPackageCategorySizeSizeFragment
                >;
              }
            >;
          }
        >;
      }
    >;
  };

export type NegotiationOfferRowFragment = {
  __typename?: 'FED_OfferRow';
} & Pick<
  Fed_OfferRow,
  | 'id'
  | 'createdAt'
  | 'unitCost'
  | 'unitMsrp'
  | 'unitRetail'
  | 'unitWholesale'
  | 'margin'
  | 'markup'
  | 'draftPercentageOffMsrp'
  | 'currentPercentageOffMsrp'
  | 'draftPercentageOffWholesale'
  | 'currentPercentageOffWholesale'
  | 'name'
  | 'notes'
  | 'kind'
  | 'currentTotalPrice'
  | 'currentTotalUnits'
  | 'currentUnitPrice'
  | 'currentPackagePrice'
  | 'description'
  | 'draftTotalPrice'
  | 'draftTotalUnits'
  | 'draftUnitPrice'
  | 'draftPackagePrice'
  | 'historicAnalyticData'
  | 'initialTotalPrice'
  | 'initialTotalUnits'
  | 'initialUnitPrice'
  | 'initialPackagePrice'
  | 'theyChangedQuantityValueBy'
  | 'theyChangedPriceValueBy'
  | 'theyChangedPackageDistribution'
  | 'weChangedPriceValueBy'
  | 'weChangedQuantityValueBy'
  | 'weChangedPackageDistribution'
  | 'updatedAt'
> & {
    attributes: { __typename?: 'FED_OfferRowAttributes' } & {
      nodes: Array<
        {
          __typename?: 'FED_OfferRowAttribute';
        } & NegotiationOfferRowAttributeFragment
      >;
    };
    images: { __typename?: 'FED_OfferRowImages' } & {
      nodes: Array<
        { __typename?: 'FED_OfferRowImage' } & Pick<
          Fed_OfferRowImage,
          'id' | 'src' | 'colorMatch'
        >
      >;
    };
    skus: { __typename?: 'FED_OfferRowSkus' } & {
      nodes: Array<
        { __typename?: 'FED_OfferRowSku' } & Pick<Fed_OfferRowSku, 'value'>
      >;
    };
    packages: { __typename?: 'FED_OfferRowPackages' } & {
      nodes: Array<
        {
          __typename?: 'FED_OfferRowPackage';
        } & NegotiationOfferRowPackageFragment
      >;
    };
    productIds: { __typename?: 'FED_OfferRowProductIds' } & {
      nodes: Array<
        { __typename?: 'FED_OfferRowProductId' } & Pick<
          Fed_OfferRowProductId,
          'value'
        >
      >;
    };
  };

export type Fed_NegotiationOfferRowsQueryVariables = {
  buyerCompanyUUID?: Maybe<Scalars['String']>;
  filterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
  limit?: Maybe<Scalars['Int']>;
  listingCreatorCompanyUUID: Scalars['String'];
  listingUUID: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  sortKey?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<Scalars['String']>;
  sortScope?: Maybe<Scalars['String']>;
  sortScopeValue?: Maybe<Scalars['String']>;
  marketId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
};

export type Fed_NegotiationOfferRowsQuery = { __typename?: 'Query' } & {
  rows: { __typename?: 'FED_OfferRows' } & {
    nodes: Array<{ __typename?: 'FED_OfferRow' } & NegotiationOfferRowFragment>;
    pagination: { __typename?: 'FED_OfferRowsPagination' } & Pick<
      Fed_OfferRowsPagination,
      'total' | 'totalElements' | 'offset' | 'limit'
    >;
  };
  rollups: { __typename?: 'FED_OfferRollups' } & {
    totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
      Fed_OfferRollupsTotalRollup,
      'draftTotalUnits' | 'totalUnpriced' | 'uniqueProducts'
    >;
  };
};

export type Fed_NegotiationOfferRowsFetchMoreQueryVariables = {
  buyerCompanyUUID?: Maybe<Scalars['String']>;
  filterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
  limit?: Maybe<Scalars['Int']>;
  listingCreatorCompanyUUID: Scalars['String'];
  listingUUID: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  sortKey?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<Scalars['String']>;
  sortScope?: Maybe<Scalars['String']>;
  sortScopeValue?: Maybe<Scalars['String']>;
  marketId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
};

export type Fed_NegotiationOfferRowsFetchMoreQuery = {
  __typename?: 'Query';
} & {
  rows: { __typename?: 'FED_OfferRows' } & {
    nodes: Array<{ __typename?: 'FED_OfferRow' } & NegotiationOfferRowFragment>;
  };
};

export type NegotiationUserAllocationsQueryVariables = {
  userId: Scalars['ID'];
};

export type NegotiationUserAllocationsQuery = { __typename?: 'Query' } & {
  userAllocations?: Maybe<
    { __typename?: 'Allocations' } & {
      nodes?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Allocation' } & Pick<Allocation, 'id' | 'label'>
          >
        >
      >;
    }
  >;
};

export type OfferOverviewHeroBuyerFragment = { __typename?: 'User' } & Pick<
  User,
  'id' | 'uuid' | 'avatarUrl' | 'email' | 'firstName' | 'lastName'
>;

export type OfferOverviewHero_Listing_V2Fragment = {
  __typename?: 'ListingV2';
} & Pick<
  ListingV2,
  | 'id'
  | 'buyerCompanyName'
  | 'parentGroupId'
  | 'marketId'
  | 'description'
  | 'title'
> & {
    seller: { __typename?: 'User' } & Pick<
      User,
      'id' | 'email' | 'firstName' | 'lastName' | 'avatarUrl'
    > & {
        company: { __typename?: 'Company' } & Pick<
          Company,
          'id' | 'uuid' | 'name'
        >;
      };
    buyers: { __typename?: 'Users' } & {
      nodes?: Maybe<
        Array<{ __typename?: 'User' } & OfferOverviewHeroBuyerFragment>
      >;
    };
  };

export type Fed_ArchiveOfferMutationVariables = {
  input?: Maybe<Fed_ArchiveOfferRequest>;
};

export type Fed_ArchiveOfferMutation = { __typename?: 'Mutation' } & {
  workflowId: Mutation['FED_archiveOffer'];
};

export type OfferOverviewListingQueryVariables = {
  id: Scalars['ID'];
  offerRowsFilterGroups: Array<Fed_SearchServiceFilterGroup>;
  includeDeletedUsers?: Maybe<Scalars['Boolean']>;
};

export type OfferOverviewListingQuery = { __typename?: 'Query' } & {
  FED_listing: { __typename?: 'FED_Listing' } & Pick<
    Fed_Listing,
    | 'id'
    | 'allowCounterOffers'
    | 'allowPickingQuantities'
    | 'allowPickingItems'
    | 'allowPickingSizes'
    | 'endDateTime'
    | 'expirationDateTime'
    | 'showSizes'
    | 'showMsrp'
    | 'showWholesale'
    | 'status'
    | 'state'
    | 'title'
    | 'description'
    | 'customPo'
    | 'otherRestrictions'
    | 'canAccept'
  > & {
      parentGroup?: Maybe<{ __typename?: 'FED_Group' } & Pick<Fed_Group, 'id'>>;
      truckload?: Maybe<
        { __typename?: 'FED_ListingTruckload' } & Pick<
          Fed_ListingTruckload,
          'truckloadMinimumSize' | 'truckloadMaximumSize'
        >
      >;
      endNegotiationReasons: Array<
        Maybe<
          { __typename?: 'FED_EndNegotiationReason' } & Pick<
            Fed_EndNegotiationReason,
            'type' | 'id'
          >
        >
      >;
      creator?: Maybe<
        { __typename?: 'FED_User' } & Pick<Fed_User, 'id' | 'userId'>
      >;
      buyerCompanies?: Maybe<
        Array<
          Maybe<
            { __typename?: 'FED_Company' } & Pick<
              Fed_Company,
              'id' | 'name' | 'avatarUrl'
            >
          >
        >
      >;
      buyers: Array<
        { __typename?: 'FED_User' } & Pick<
          Fed_User,
          'id' | 'userId' | 'firstName' | 'lastName' | 'email' | 'avatarUrl'
        > & {
            company?: Maybe<
              { __typename?: 'FED_Company' } & Pick<
                Fed_Company,
                'id' | 'name' | 'avatarUrl'
              >
            >;
          }
      >;
      market?: Maybe<
        { __typename?: 'FED_Market' } & Pick<Fed_Market, 'id'> & {
            currency?: Maybe<
              { __typename?: 'FED_Currency' } & Pick<
                Fed_Currency,
                'id' | 'code'
              >
            >;
          }
      >;
      offers: Array<
        { __typename?: 'FED_Offer' } & Pick<
          Fed_Offer,
          | 'id'
          | 'version'
          | 'isDraftEdited'
          | 'isCurrent'
          | 'status'
          | 'submittedAt'
          | 'updatedAt'
        > & {
            creator?: Maybe<
              { __typename?: 'FED_User' } & Pick<
                Fed_User,
                'id' | 'userId' | 'firstName' | 'lastName'
              > & {
                  company?: Maybe<
                    { __typename?: 'FED_Company' } & Pick<
                      Fed_Company,
                      'id' | 'role'
                    >
                  >;
                }
            >;
            offerRows?: Maybe<
              { __typename?: 'FED_OfferRows' } & {
                nodes: Array<
                  { __typename?: 'FED_OfferRow' } & Pick<Fed_OfferRow, 'id'> & {
                      images: { __typename?: 'FED_OfferRowImages' } & {
                        nodes: Array<
                          { __typename?: 'FED_OfferRowImage' } & Pick<
                            Fed_OfferRowImage,
                            'src'
                          >
                        >;
                      };
                    }
                >;
              }
            >;
            seller: { __typename?: 'FED_User' } & Pick<
              Fed_User,
              'id' | 'userId' | 'email' | 'firstName' | 'lastName' | 'avatarUrl'
            > & {
                company?: Maybe<
                  { __typename?: 'FED_Company' } & Pick<
                    Fed_Company,
                    'id' | 'name' | 'avatarUrl'
                  >
                >;
              };
            declineInfo?: Maybe<
              { __typename?: 'FED_DeclineInfo' } & {
                user?: Maybe<
                  { __typename?: 'FED_User' } & Pick<
                    Fed_User,
                    'userId' | 'id' | 'firstName'
                  > & {
                      company?: Maybe<
                        { __typename?: 'FED_Company' } & Pick<Fed_Company, 'id'>
                      >;
                    }
                >;
              }
            >;
            rollups?: Maybe<
              { __typename?: 'FED_OfferRollups' } & {
                totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
                  Fed_OfferRollupsTotalRollup,
                  | 'uniqueProducts'
                  | 'totalUnpriced'
                  | 'draftTotalUnits'
                  | 'draftTotalPrice'
                  | 'avgMargin'
                  | 'totalMsrp'
                  | 'totalMsrpOff'
                  | 'totalWhl'
                  | 'totalWhlOff'
                  | 'totalElements'
                  | 'totalProfit'
                >;
                truckloadTotals?: Maybe<
                  {
                    __typename?: 'FED_OfferRollupsTruckloadTotalRollup';
                  } & Pick<
                    Fed_OfferRollupsTruckloadTotalRollup,
                    'totalTrucks' | 'totalGrossWeight' | 'totalCube'
                  >
                >;
                sizesByCategory: Array<
                  { __typename?: 'FED_OfferRollupsSizeByCategory' } & Pick<
                    Fed_OfferRollupsSizeByCategory,
                    'name'
                  > & {
                      totals?: Maybe<
                        {
                          __typename?: 'FED_OfferRollupsCategoryTotals';
                        } & Pick<
                          Fed_OfferRollupsCategoryTotals,
                          'draftTotalUnits'
                        >
                      >;
                      sizes: Array<
                        { __typename?: 'FED_OfferRollupsSize' } & Pick<
                          Fed_OfferRollupsSize,
                          'name' | 'draftTotalUnits'
                        >
                      >;
                    }
                >;
              }
            >;
          }
      >;
    };
};

export type Deprecated_NegotiationActionBar_Listing_V2Fragment = {
  __typename?: 'ListingV2';
} & Pick<
  ListingV2,
  | 'id'
  | 'status'
  | 'allowPickingItems'
  | 'allowPickingSizes'
  | 'allowPickingQuantities'
  | 'allowCounterOffers'
  | 'description'
  | 'otherRestrictions'
  | 'endDate'
  | 'purchasingRule'
  | 'buyerCompanyId'
  | 'buyerCompanyName'
> & {
    seller: { __typename?: 'User' } & Pick<
      User,
      'id' | 'firstName' | 'lastName' | 'companyName'
    >;
    buyers: { __typename?: 'Users' } & {
      nodes?: Maybe<
        Array<
          { __typename?: 'User' } & Pick<
            User,
            'uuid' | 'id' | 'firstName' | 'lastName'
          > & {
              company: { __typename?: 'Company' } & Pick<
                Company,
                'id' | 'uuid' | 'name'
              > & { logo?: Maybe<{ __typename?: 'File' } & Pick<File, 'src'>> };
            }
        >
      >;
    };
    offers: { __typename?: 'ListingOffersV2' } & {
      nodes: Array<
        { __typename?: 'OfferV2' } & Pick<
          OfferV2,
          'id' | 'isDraftEdited' | 'status' | 'version' | 'creator'
        > & {
            offerRows?: Maybe<
              { __typename?: 'OfferRows' } & {
                totals?: Maybe<
                  { __typename?: 'OfferRowsTotals' } & Pick<
                    OfferRowsTotals,
                    | 'uniqueProducts'
                    | 'totalUnpriced'
                    | 'draftTotalUnits'
                    | 'draftTotalPrice'
                    | 'avgMargin'
                    | 'totalProfit'
                    | 'totalMsrp'
                    | 'totalMsrpOff'
                    | 'totalWhl'
                    | 'totalWhlOff'
                  >
                >;
              }
            >;
          }
      >;
      actions: { __typename?: 'ListingOffersV2Actions' } & Pick<
        ListingOffersV2Actions,
        'customPo' | 'accept' | 'setActualizedData'
      >;
    };
  };

export type Fed_NegotiationActionBar_ListingFragment = {
  __typename?: 'FED_Listing';
} & Pick<
  Fed_Listing,
  | 'id'
  | 'status'
  | 'allowPickingItems'
  | 'allowPickingSizes'
  | 'allowPickingQuantities'
  | 'allowCounterOffers'
  | 'description'
  | 'otherRestrictions'
  | 'endDateTime'
> & {
    buyers: Array<
      { __typename?: 'FED_User' } & {
        company?: Maybe<
          { __typename?: 'FED_Company' } & Pick<
            Fed_Company,
            'id' | 'name' | 'role'
          >
        >;
      }
    >;
    creator?: Maybe<
      { __typename?: 'FED_User' } & Pick<
        Fed_User,
        'id' | 'firstName' | 'lastName'
      > & {
          company?: Maybe<
            { __typename?: 'FED_Company' } & Pick<
              Fed_Company,
              'id' | 'name' | 'role'
            >
          >;
        }
    >;
    offers: Array<
      { __typename?: 'FED_Offer' } & Pick<
        Fed_Offer,
        'id' | 'isDraftEdited' | 'isCurrent' | 'status' | 'version'
      > & {
          creator?: Maybe<
            { __typename?: 'FED_User' } & Pick<Fed_User, 'id' | 'firstName'> & {
                company?: Maybe<
                  { __typename?: 'FED_Company' } & Pick<
                    Fed_Company,
                    'id' | 'name' | 'role'
                  >
                >;
              }
          >;
          rollups?: Maybe<
            { __typename?: 'FED_OfferRollups' } & {
              totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
                Fed_OfferRollupsTotalRollup,
                | 'uniqueProducts'
                | 'totalUnpriced'
                | 'draftTotalUnits'
                | 'draftTotalPrice'
                | 'avgMargin'
                | 'totalProfit'
                | 'totalMsrp'
                | 'totalMsrpOff'
                | 'totalWhl'
                | 'totalWhlOff'
              >;
            }
          >;
        }
    >;
  };

export type OfferActionsBarTotalAvailableUnitsQueryVariables = {
  buyerCompanyUUID?: Maybe<Scalars['String']>;
  filterGroups?: Maybe<Array<Maybe<Fed_SearchServiceFilterGroup>>>;
  listingCreatorCompanyUUID: Scalars['String'];
  listingUUID: Scalars['String'];
};

export type OfferActionsBarTotalAvailableUnitsQuery = {
  __typename?: 'Query';
} & {
  rows: { __typename?: 'FED_OfferRollups' } & {
    totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
      Fed_OfferRollupsTotalRollup,
      'draftTotalUnits'
    >;
  };
};

export type FedOfferAllEntitiesCountsQueryVariables = {
  buyerCompanyUUID?: Maybe<Scalars['String']>;
  listingCreatorCompanyUUID: Scalars['String'];
  listingUUID: Scalars['String'];
  offerUUID?: Maybe<Scalars['AnyObject']>;
};

export type FedOfferAllEntitiesCountsQuery = { __typename?: 'Query' } & {
  casepacks: { __typename?: 'FED_OfferRollups' } & {
    totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
      Fed_OfferRollupsTotalRollup,
      'withoutImages' | 'totalElements'
    >;
  };
  items: { __typename?: 'FED_OfferRollups' } & {
    totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
      Fed_OfferRollupsTotalRollup,
      'withoutImages' | 'totalElements'
    >;
  };
};

export type OfferAllEntitiesCountsQueryVariables = {
  buyerCompanyUUID?: Maybe<Scalars['String']>;
  listingCreatorCompanyUUID: Scalars['String'];
  listingUUID: Scalars['String'];
  offerUUID: Scalars['AnyObject'];
};

export type OfferAllEntitiesCountsQuery = { __typename?: 'Query' } & {
  casepacks: { __typename?: 'FED_OfferRollups' } & {
    totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
      Fed_OfferRollupsTotalRollup,
      'totalElements' | 'withoutImages'
    >;
  };
  items: { __typename?: 'FED_OfferRollups' } & {
    totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
      Fed_OfferRollupsTotalRollup,
      'totalElements' | 'withoutImages'
    >;
  };
};

export type OfferUpdateOfferRowsMutationVariables = {
  input?: Maybe<UpdateOfferRowsInput>;
  listingCreatorCompanyUUID?: Maybe<Scalars['String']>;
  offerId?: Maybe<Scalars['String']>;
  filterGroups?: Maybe<Array<Maybe<SearchServiceFilterGroup>>>;
  isAsync?: Maybe<Scalars['Boolean']>;
};

export type OfferUpdateOfferRowsMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'updateOfferRows'
>;

export type ActualizeOfferModalTransactionFragment = {
  __typename?: 'Transaction';
} & Pick<
  Transaction,
  | 'id'
  | 'totalItems'
  | 'totalUnits'
  | 'finalPrice'
  | 'totalMsrp'
  | 'totalWholesale'
  | 'description'
  | 'createdAt'
  | 'updatedAt'
  | 'isoCurrencyCode'
>;

export type ActualizeOfferModalTransactionsQueryVariables = {
  offerId: Scalars['ID'];
};

export type ActualizeOfferModalTransactionsQuery = { __typename?: 'Query' } & {
  transactions: { __typename?: 'Transactions' } & {
    nodes: Array<
      { __typename?: 'Transaction' } & ActualizeOfferModalTransactionFragment
    >;
  };
};

export type ActualizeOfferModalCreateTransactionMutationVariables = {
  offerId: Scalars['ID'];
  input: TransactionInput;
};

export type ActualizeOfferModalCreateTransactionMutation = {
  __typename?: 'Mutation';
} & {
  createTransaction: {
    __typename?: 'Transaction';
  } & ActualizeOfferModalTransactionFragment;
};

export type ActualizeOfferModalUpdateTransactionMutationVariables = {
  offerId: Scalars['ID'];
  transactionId: Scalars['ID'];
  input: TransactionInput;
};

export type ActualizeOfferModalUpdateTransactionMutation = {
  __typename?: 'Mutation';
} & {
  updateTransaction: {
    __typename?: 'Transaction';
  } & ActualizeOfferModalTransactionFragment;
};

export type Fed_ClearDraftModalMutationVariables = {
  input: ClearDraftInput;
};

export type Fed_ClearDraftModalMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'FED_clearDraft'
>;

export type OfferActionBarEndOfferMutationVariables = {
  groupId: Scalars['String'];
  input: EndOfferInput;
  offerId: Scalars['String'];
  sellerCompanyId: Scalars['String'];
  userUUID: Scalars['String'];
};

export type OfferActionBarEndOfferMutation = { __typename?: 'Mutation' } & {
  endOffer: { __typename?: 'BooleanResult' } & Pick<BooleanResult, 'ok'>;
};

export type PublishListingModalOfferRollupQueryVariables = {
  offerId: Scalars['ID'];
  offerRowsFilterGroups: Array<Fed_SearchServiceFilterGroup>;
};

export type PublishListingModalOfferRollupQuery = { __typename?: 'Query' } & {
  offer?: Maybe<
    { __typename?: 'FED_Offer' } & Pick<Fed_Offer, 'id'> & {
        rollups?: Maybe<
          { __typename?: 'FED_OfferRollups' } & {
            totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
              Fed_OfferRollupsTotalRollup,
              | 'avgMargin'
              | 'totalMsrp'
              | 'totalMsrpOff'
              | 'totalWhl'
              | 'totalWhlOff'
              | 'draftTotalPrice'
              | 'draftTotalUnits'
              | 'totalProfit'
              | 'totalElements'
            >;
          }
        >;
      }
  >;
};

export type OfferUploadCounterOfferMutationVariables = {
  offerId: Scalars['ID'];
  file: Scalars['Upload'];
};

export type OfferUploadCounterOfferMutation = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'listingOffersV2UploadCounterOffer'>;

export type OfferActionBarUpdateListingMutationVariables = {
  listingId: Scalars['ID'];
  input: ListingInputV2;
};

export type OfferActionBarUpdateListingMutation = {
  __typename?: 'Mutation';
} & {
  updateListingV2: { __typename?: 'ListingV2' } & Pick<
    ListingV2,
    'id' | 'status'
  >;
};

export type OfferActionBarUploadOfferMutationVariables = {
  offerId: Scalars['ID'];
  file: Scalars['Upload'];
};

export type OfferActionBarUploadOfferMutation = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'listingOffersV2UploadCounterOffer'>;

export type Fed_OfferInsightsSizesFragment = {
  __typename?: 'FED_OfferRollupsSizeByCategory';
} & Pick<Fed_OfferRollupsSizeByCategory, 'name'> & {
    totals?: Maybe<
      { __typename?: 'FED_OfferRollupsCategoryTotals' } & Pick<
        Fed_OfferRollupsCategoryTotals,
        'draftTotalUnits'
      >
    >;
    sizes: Array<
      { __typename?: 'FED_OfferRollupsSize' } & Pick<
        Fed_OfferRollupsSize,
        'name' | 'draftTotalUnits'
      >
    >;
  };

export type OfferOverviewListingInsightsQueryVariables = {
  id: Scalars['ID'];
};

export type OfferOverviewListingInsightsQuery = { __typename?: 'Query' } & {
  FED_listing: { __typename?: 'FED_Listing' } & Pick<
    Fed_Listing,
    'id' | 'showMsrp' | 'showWholesale' | 'showSizes'
  > & {
      buyers: Array<
        { __typename?: 'FED_User' } & {
          company?: Maybe<
            { __typename?: 'FED_Company' } & Pick<
              Fed_Company,
              'id' | 'avatarUrl' | 'name'
            >
          >;
        }
      >;
    };
};

export type OfferInsightsOfferQueryVariables = {
  offerId: Scalars['ID'];
  offerRowsFilterGroups: Array<Fed_SearchServiceFilterGroup>;
};

export type OfferInsightsOfferQuery = { __typename?: 'Query' } & {
  FED_offer?: Maybe<
    { __typename?: 'FED_Offer' } & Pick<
      Fed_Offer,
      | 'id'
      | 'isDraftEdited'
      | 'updatedAt'
      | 'submittedAt'
      | 'status'
      | 'version'
    > & {
        creator?: Maybe<
          { __typename?: 'FED_User' } & Pick<Fed_User, 'id'> & {
              company?: Maybe<
                { __typename?: 'FED_Company' } & Pick<
                  Fed_Company,
                  'id' | 'role'
                >
              >;
            }
        >;
        seller: { __typename?: 'FED_User' } & Pick<Fed_User, 'id'> & {
            company?: Maybe<
              { __typename?: 'FED_Company' } & Pick<
                Fed_Company,
                'id' | 'avatarUrl' | 'name'
              >
            >;
          };
        rollups?: Maybe<
          { __typename?: 'FED_OfferRollups' } & {
            totals: { __typename?: 'FED_OfferRollupsTotalRollup' } & Pick<
              Fed_OfferRollupsTotalRollup,
              | 'avgMargin'
              | 'totalMsrpOff'
              | 'totalWhlOff'
              | 'draftTotalPrice'
              | 'draftTotalUnits'
              | 'totalMsrp'
              | 'totalWhl'
              | 'totalProfit'
              | 'totalElements'
              | 'totalCases'
              | 'totalCasepacks'
              | 'totalCasepacksUnits'
              | 'totalItems'
              | 'totalLooseItemsUnits'
              | 'totalUnpriced'
              | 'totalCost'
              | 'totalCostUnpriced'
              | 'totalRetail'
              | 'totalRetailUnpriced'
            >;
            truckloadTotals?: Maybe<
              { __typename?: 'FED_OfferRollupsTruckloadTotalRollup' } & Pick<
                Fed_OfferRollupsTruckloadTotalRollup,
                'totalGrossWeight' | 'totalCube' | 'totalTrucks'
              >
            >;
            sizesByCategory: Array<
              {
                __typename?: 'FED_OfferRollupsSizeByCategory';
              } & Fed_OfferInsightsSizesFragment
            >;
          }
        >;
        offerRows?: Maybe<
          { __typename?: 'FED_OfferRows' } & {
            nodes: Array<
              { __typename?: 'FED_OfferRow' } & Pick<Fed_OfferRow, 'id'>
            >;
          }
        >;
      }
  >;
};

export type OnboardingCompanyLogoMutationMutationVariables = {
  id: Scalars['ID'];
  file: Scalars['Upload'];
};

export type OnboardingCompanyLogoMutationMutation = {
  __typename?: 'Mutation';
} & {
  updateCompanyLogo: { __typename: 'Company' } & Pick<Company, 'id'> & {
      logo?: Maybe<{ __typename?: 'File' } & Pick<File, 'src'>>;
    };
};

export type OnboardingCompanyLogoQueryVariables = {
  companyId: Scalars['ID'];
};

export type OnboardingCompanyLogoQuery = { __typename?: 'Query' } & {
  company?: Maybe<
    { __typename?: 'Company' } & Pick<Company, 'id'> & {
        logo?: Maybe<{ __typename?: 'File' } & Pick<File, 'src'>>;
      }
  >;
};

export type OnboardingUploadAvatarMutationVariables = {
  input: ImageAvatarInput;
};

export type OnboardingUploadAvatarMutation = { __typename?: 'Mutation' } & {
  uploadUserAvatar?: Maybe<{ __typename?: 'Me' } & Pick<Me, 'avatarUrl'>>;
};

export type OnboardingSetUserInfoMutationVariables = {
  input: EditableUserInfo;
};

export type OnboardingSetUserInfoMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'updateUserInfo'
>;

export type OnboardingSetOnboardingCompleteMutationVariables = {
  input: ProductCategoriesUpdate;
};

export type OnboardingSetOnboardingCompleteMutation = {
  __typename?: 'Mutation';
} & Pick<Mutation, 'setProductCategoriesByUser'>;

export type FillUserDataMutationVariables = {
  id: Scalars['ID'];
  listingId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  companyName: Scalars['String'];
  password: Scalars['String'];
};

export type FillUserDataMutation = { __typename?: 'Mutation' } & {
  isSuccessful: Mutation['fillUserData'];
};

export type ResendVerificationEmailMutationVariables = {
  id: Scalars['ID'];
  listingId: Scalars['String'];
};

export type ResendVerificationEmailMutation = { __typename?: 'Mutation' } & {
  isSuccessful: Mutation['resendVerificationEmail'];
};

export type SimpleBuyerSenderDetailsQueryVariables = {
  id: Scalars['ID'];
};

export type SimpleBuyerSenderDetailsQuery = { __typename?: 'Query' } & {
  company?: Maybe<{ __typename?: 'Company' } & Pick<Company, 'id' | 'name'>>;
};

export type VerifyAccountMutationVariables = {
  id: Scalars['ID'];
  token: Scalars['String'];
};

export type VerifyAccountMutation = { __typename?: 'Mutation' } & {
  isSuccessful: Mutation['verifyAccount'];
};

export type TeamInviteTeamMemberMutationVariables = {
  input?: Maybe<CreateUserInput>;
};

export type TeamInviteTeamMemberMutation = { __typename?: 'Mutation' } & {
  createUser?: Maybe<
    { __typename?: 'BooleanResult' } & Pick<BooleanResult, 'ok'>
  >;
};

export type TeamCompanyMemberFragment = { __typename?: 'User' } & Pick<
  User,
  | 'avatarUrl'
  | 'companyId'
  | 'companyName'
  | 'companyUuid'
  | 'email'
  | 'firstName'
  | 'id'
  | 'isPersonalEmail'
  | 'jobTitle'
  | 'lastName'
  | 'onboardingCompletedAt'
  | 'userRole'
  | 'uuid'
>;

export type TeamCompanyQueryVariables = {
  companyId: Scalars['ID'];
  memberFilters?: Maybe<Array<Maybe<CoreApiFilter>>>;
  membersPage: Scalars['Int'];
};

export type TeamCompanyQuery = { __typename?: 'Query' } & {
  company?: Maybe<
    { __typename?: 'Company' } & Pick<Company, 'id' | 'avatarUrl' | 'name'> & {
        members?: Maybe<
          { __typename?: 'Members' } & {
            nodes: Array<{ __typename?: 'User' } & TeamCompanyMemberFragment>;
            pagination: { __typename?: 'CoreAPIPagination' } & Pick<
              CoreApiPagination,
              'currentPage' | 'grandTotal' | 'perPage' | 'total' | 'totalPages'
            >;
            filters: { __typename?: 'CoreAPIFiltersResponse' } & {
              nodes: Array<
                { __typename?: 'CoreAPIFiltersResponseFilter' } & Pick<
                  CoreApiFiltersResponseFilter,
                  'label'
                > & {
                    options?: Maybe<
                      { __typename?: 'CoreAPIFiltersResponseFilterOptions' } & {
                        nodes: Array<
                          {
                            __typename?: 'CoreAPIFiltersResponseFilterOption';
                          } & Pick<
                            CoreApiFiltersResponseFilterOption,
                            'name' | 'label' | 'value' | 'checked'
                          >
                        >;
                      }
                    >;
                  }
              >;
            };
          }
        >;
      }
  >;
};

export type UserProfileChangePasswordMutationVariables = {
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
  newPasswordConfirmation: Scalars['String'];
};

export type UserProfileChangePasswordMutation = { __typename?: 'Mutation' } & {
  changePassword?: Maybe<
    | ({ __typename?: 'BooleanResult' } & Pick<BooleanResult, 'ok'>)
    | ({ __typename?: 'GenericError' } & Pick<GenericError, 'message' | 'kind'>)
  >;
};

export type UserProfileMakeConnectionMutationVariables = {
  userId: Scalars['ID'];
};

export type UserProfileMakeConnectionMutation = { __typename?: 'Mutation' } & {
  isContactEstablished: Mutation['makeConnection'];
};

export type UserProfileRemoveConnectionMutationVariables = {
  userId: Scalars['ID'];
};

export type UserProfileRemoveConnectionMutation = {
  __typename?: 'Mutation';
} & { isContactRemoved: Mutation['removeConnection'] };

export type UserProfileUpdateUserInfoMutationVariables = {
  input: EditableUserInfo;
};

export type UserProfileUpdateUserInfoMutation = { __typename?: 'Mutation' } & {
  isUpdated: Mutation['updateUserInfo'];
};

export type UserProfileUploadAvatarMutationVariables = {
  input: ImageAvatarInput;
};

export type UserProfileUploadAvatarMutation = { __typename?: 'Mutation' } & {
  updatedUserInfo?: Maybe<{ __typename?: 'Me' } & Pick<Me, 'avatarUrl'>>;
};

export type UserProfileGetUserQueryVariables = {
  userId: Scalars['ID'];
};

export type UserProfileGetUserQuery = { __typename?: 'Query' } & {
  userPageOwnerInfo?: Maybe<
    { __typename?: 'Me' } & Pick<
      Me,
      | 'avatarUrl'
      | 'address'
      | 'address2'
      | 'city'
      | 'countryCode'
      | 'companyId'
      | 'companyName'
      | 'connectionStatus'
      | 'department'
      | 'email'
      | 'firstName'
      | 'jobTitle'
      | 'lastName'
      | 'onboardingCompletedAt'
      | 'phoneNumber'
      | 'visible'
      | 'zip'
    >
  >;
};
